// App.js
import React, { useState, useEffect, useRef } from 'react';
import Select from "react-select";

import { match } from 'path-to-regexp'; 
import { Rnd } from 'react-rnd';
import ProgressBar from 'react-bootstrap/ProgressBar'; // تأكد من أنك مثبت bootstrap
import QRCode from "qrcode";

import {
  BarChart, Bar, LineChart, Line,
  PieChart, Pie, Cell, Tooltip, XAxis, YAxis,
  ResponsiveContainer
} from "recharts";








import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams ,
  useNavigate,
  useLocation
} from 'react-router-dom';
import './App.css';
import './navbar.css';
import './home.css';
import './orders.css';
import './services.css';
import './mtnsyriatel.css';
import './servpage.css';
import './tran.css';
import './sguinup.css';
import './notifications.css';
import './SignupSuccess.css';
import './star.css';
import './agent-style.css';
import './passc.css';
import './poe.css';
import './profile.css';
import './tool.css';
import './print.css';
import './design.css';
import './server.css';
import './templates.css';
import './DeviceDetails.css';

import './BroadbandOptions.css';

import './cards-cleanup-panel.css';
import './whatsapp-log.css';


const STATUS_COLORS = {
    'مكتمل': '#28a745', // أخضر
    'ملغي': '#dc3545',   // أحمر
    'قيد المعالجة': '#ffc107', // أصفر/برتقالي
};



function LoadingSpinner({ text = "جاري تحميل البيانات..." }) {
  return (
    <div className="text-center text-primary mt-5">
      <i className="fas fa-spinner fa-spin fa-2x"></i>
      <p className="mt-2">{text}</p>
    </div>
  );
}



function MessageDisplay({ message, type, onClose }) {
  if (!message) return null;

  const typeClass = type === 'success' ? 'message-success' : 'message-error';
  const iconClass = type === 'success' ? 'fas fa-check-circle' : 'fas fa-times-circle';

  return (
    <div className={`message-display ${typeClass}`}>
      <div className="message-content">
        <i className={`${iconClass} message-icon`}></i>
        <p className="message-text">{message}</p>
        <button className="message-close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </div>
  );
}






function Navbar() {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [accountNumber, setAccountNumber] = React.useState('');
  const [accountname, setAccountname] = React.useState('');
  const [unreadCount, setUnreadCount] = React.useState(0);

  const navigate = useNavigate(); // hook للتحويل برمجياً

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };



  const handleLogout = () => {
    // حذف بيانات الجلسة
    localStorage.removeItem('authToken');
   
  

    // إعادة التوجيه إلى صفحة تسجيل الدخول
    navigate('/', { replace: true });
  };




  React.useEffect(() => {
    setAccountNumber(localStorage.getItem('accountNumber') || 'غير متوفر');
    setAccountname(localStorage.getItem('accountname') || 'غير متوفر');

    const token = localStorage.getItem('authToken');
   if (!token) {
    // إعادة توجيه المستخدم إذا لم يكن مسجلاً الدخول
    navigate('/', { replace: true });
  }


   const fetchNotifications = () => {
  fetch(`https://mcrm.com.tr/api.php?notifications&token=${token}`, {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  })
    .then(res => res.json())
    .then(data => {
      if (!data.success && data.message === 'التوكين غير موجود بقواعد البيانات') {
        // حذف البيانات المحلية
        localStorage.removeItem('authToken');
       

        // إعادة التوجيه لصفحة تسجيل الدخول
        navigate('/', { replace: true });
        return;
      }

      if (data.success && data.unreadCount !== undefined) {
        setUnreadCount(data.unreadCount);
      }
    })
    .catch(() => setUnreadCount(0));
};



    fetchNotifications(); // جلب فوري عند التحميل

    const intervalId = setInterval(fetchNotifications, 5000); // تحديث كل 5 ثواني

    return () => clearInterval(intervalId); // تنظيف عند التفكيك
  }, []);



  
  // دالة للتحويل عند الضغط على أيقونة الجرس
  const goToNotifications = () => {
    navigate('/notifications');  // عدل الرابط حسب صفحة الإشعارات عندك
  };

  return (
    <>
      <nav className="navbar-custom">
        <div className="account-info">
   

<img 
  src={localStorage.getItem('userAvatar') || '/images/user.png'} 
  alt="الصورة الشخصية"
  className="account-image"
  style={{
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover'
  }}
/>


          <div className="account-details">
            <div className="account-text-label">{accountname}</div>
            <div className="account-number">{accountNumber}</div>
          </div>
        </div>
        <div className="nav-icons">
          <div
            className="bell-icon-container"
            style={{ position: 'relative', cursor: 'pointer' }}
            onClick={goToNotifications}  // هنا حدث الضغط
          >
            <i className="fas fa-bell"></i>
            {unreadCount > 0 && (
              <span
                className="notification-badge"
                style={{
                  position: 'absolute',
                  top: '-5px',
                  backgroundColor: 'red',
                  color: 'white',
                  borderRadius: '50%',
                  padding: '2px 6px',
                  fontSize: '12px'
                }}
              >
                {unreadCount}
              </span>
            )}
          </div>
          <i className="fas fa-bars" onClick={toggleSidebar}></i>
        </div>
      </nav>

      {/* القائمة الجانبية */}
      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <h3>منجرتك</h3>
        <ul>
        <li><a href="/home"><i className="fas fa-home"></i> الرئيسية</a></li>



<li>
  <a href="/clients">
    <i className="fas fa-users"></i> العملاء
  </a>
</li>





      <li>
  <a href="/hotspot-profile">
    <i className="fas fa-wifi"></i> بروفايلات الهوت سبوت
  </a>
</li>

<li>
  <a href="/broadband-profile">
    <i className="fas fa-network-wired"></i> بروفايلات البرودباند
  </a>
</li>

<li>
  <a href="/usershare">
    <i className="fas fa-tachometer-alt"></i> السرعات التشاركية
  </a>
</li>

<li>
  <a href="/device">
    <i className="fas fa-tools"></i> تجهيزات الشبكة
  </a>
</li>

<li>
  <a href="/print-templates">
    <i className="fas fa-print"></i> قوالب الطباعة
  </a>
</li>


<li>
  <a href="/sales">
    <i className="fas fa-cash-register"></i> المبيعات
  </a>
</li>





<li>
  <a href="/accounting">
    <i className="fas fa-calculator"></i> المحاسبة
  </a>
</li>






<li>
  <a href="/backups">
    <i className="fas fa-database"></i> النسخ الاحتياطي
  </a>
</li>

<li>
  <a href="/mcrmapp">
    <i className="fas fa-mobile-alt"></i> التطبيق 
  </a>
</li>





        <li><a href="/passc"><i className="fas fa-user"></i> الملف الشخصي</a></li>

  <li>
  <a href="/generals">
    <i className="fas fa-bell"></i> إعداد الإشعارات
  </a>
</li>

  <li>
  <a href="/editable">
    <i className="fas fa-sliders-h"></i> الإعدادت العامة
  </a>
</li>

<li>
  <a href="/managers">
    <i className="fas fa-user-shield"></i> المدراء
  </a>
</li>



        <li>

     <a href="#" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i> تسجيل خروج
        </a>

        </li>

    <li>

     <a href="#" onClick={handleLogout}>
        
        </a>

        </li>

  <li>

     <a href="#" onClick={handleLogout}>
        
        </a>

        </li>


      </ul>
      </div>

      {/* خلفية مظللة */}
      {sidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </>
  );
}




function BottomNavbar() {
  const location = useLocation();

  const isActiveLink = (path) => location.pathname === path;

  return (
    <nav className="navbar bottom-navbar">
      <div className="container-fluid d-flex justify-content-around align-items-center flex-wrap gap-2">

        {/* أدوات */}
        <Link className={`nav-link ${isActiveLink('/tools') ? 'active' : ''}`} to="/tools">
          <i className="fas fa-toolbox"></i> <span>أدوات</span>
        </Link>

        {/* طباعة */}
        <Link className={`nav-link ${isActiveLink('/print') ? 'active' : ''}`} to="/print">
          <i className="fas fa-print"></i> <span>طباعة</span>
        </Link>

        {/* هوت سبوت - حسابات */}
        <Link className={`nav-link ${isActiveLink('/hotspot-accounts') ? 'active' : ''}`} to="/hotspot-accounts">
          <i className="fas fa-wifi"></i> <span>هوت سبوت</span>
        </Link>

        {/* برودباند - حسابات */}
        <Link className={`nav-link ${isActiveLink('/broadband-accounts') ? 'active' : ''}`} to="/broadband-accounts">
          <i className="fas fa-network-wired"></i> <span>برودباند</span>
        </Link>

        {/* الرئيسية */}
        <Link className={`nav-link ${isActiveLink('/home') ? 'active' : ''}`} to="/home">
          <i className="fas fa-home"></i> <span>الرئيسية</span>
        </Link>

      </div>
    </nav>
  );
}





function NotificationCard({ notification, onMarkAsRead }) {
    return (
        <div className={`notification-card ${!notification.isRead ? 'unread' : ''}`}>
            <div className="notification-content">
                <div className="notification-icon-wrapper">
                    {/* أيقونة الإشعار: يمكن تغييرها بناءً على نوع الإشعار */}
                    {notification.type === 'success' && <i className="fas fa-check-circle notification-icon success-icon"></i>}
                    {notification.type === 'info' && <i className="fas fa-info-circle notification-icon info-icon"></i>}
                    {notification.type === 'warning' && <i className="fas fa-exclamation-triangle notification-icon warning-icon"></i>}
                    {notification.type === 'error' && <i className="fas fa-times-circle notification-icon error-icon"></i>}
                    {!notification.type && <i className="fas fa-bell notification-icon default-icon"></i>} {/* أيقونة افتراضية */}
                </div>
                <div className="notification-details">
                    <h6 className="notification-title">{notification.title}</h6>
                    <p className="notification-message">{notification.message}</p>
                    <span className="notification-date">{notification.date}</span>
                </div>
            </div>
            {!notification.isRead && (
                <button className="mark-read-btn" onClick={() => onMarkAsRead(notification.id)}>
                    <i className="fas fa-eye-slash"></i>
                </button>
            )}
        </div>
    );
}



function NotificationsPage() {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchNotifications = async () => {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('authToken');
            if (!token) {
                setError('لم يتم العثور على التوكين، يرجى تسجيل الدخول مجدداً.');
                setLoading(false);
                return;
            }

            // التوكين في رابط الـ GET (مع ترميز مناسب)
            const API_ENDPOINT_NOTIFICATIONS = `https://mcrm.com.tr/api.php?get_notifications&token=${encodeURIComponent(token)}`;

            try {
                const response = await fetch(API_ENDPOINT_NOTIFICATIONS, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                const rawNotifications = data.notifications || data;

                const formattedNotifications = rawNotifications.map(notif => ({
                    id: notif.id || notif.notification_id,
                    title: notif.title || notif.notification_title,
                    message: notif.message || notif.notification_message,
                    date: notif.date || notif.created_at,
                    isRead: notif.is_read === 1 || notif.is_read === true,
                    type: notif.type || 'info',
                }));

                setNotifications(formattedNotifications);

            } catch (err) {
                setError(err.message || "فشل في جلب الإشعارات.");
            } finally {
                setLoading(false);
            }
        };

        fetchNotifications();
    }, []);

    const handleMarkAsRead = async (id) => {
        setNotifications(prev =>
            prev.map(notif => (notif.id === id ? { ...notif, isRead: true } : notif))
        );

        const token = localStorage.getItem('authToken');
        if (!token) {
            console.error('No token found for marking notification as read.');
            return;
        }

        const API_ENDPOINT_MARK_READ = `https://mcrm.com.tr/api.php?mark_notification_read&token=${encodeURIComponent(token)}`;

        try {
            const response = await fetch(API_ENDPOINT_MARK_READ, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ notification_id: id, status: 'read' })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || `Failed to mark notification as read: ${response.status}`);
            }

            console.log(`Notification ${id} marked as read successfully on server.`);

        } catch (err) {
            console.error("Error marking notification as read:", err);
            setNotifications(prev =>
                prev.map(notif => (notif.id === id ? { ...notif, isRead: false } : notif))
            );
            setError("فشل في تحديث حالة الإشعار.");
        }
    };

    return (
        <div className="container mt-4 mb-4">
            <h4 className="page-header-title">الإشعارات</h4>

            {loading ? (
                <div className="text-center text-primary mt-5">
                    <i className="fas fa-spinner fa-spin fa-2x"></i>
                    <p className="mt-2">جاري تحميل الإشعارات...</p>
                </div>
            ) : error ? (
                <div className="text-center text-danger mt-5">
                    <i className="fas fa-exclamation-circle fa-2x"></i>
                    <p className="mt-2">{error}</p>
                </div>
            ) : notifications.length === 0 ? (
                <div className="text-center text-muted mt-5">
                    <i className="fas fa-bell-slash fa-2x"></i>
                    <p className="mt-2">لا توجد إشعارات حالياً.</p>
                </div>
            ) : (
                <div className="notifications-list">
                    {notifications.map(notification => (
                        <NotificationCard
                            key={notification.id}
                            notification={notification}
                            onMarkAsRead={handleMarkAsRead}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}




function Accounting() {
  const [data, setData] = useState({
    dueAccounts: 0,
    dueAmount: 0,
    monthExpenses: 0,
    cashBalance: 0,
    totalProfit: 0,
    monthlyRevenue: [],
    monthlyExpenses: [],
    months: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const response = await fetch(
        `https://mcrm.com.tr/api.php?get-accounting&token=${token}`
      );

      const text = await response.text();
      let result;

      try {
        result = JSON.parse(text);
      } catch {
        throw new Error("❌ السيرفر لم يُرجع JSON صالح: " + text);
      }

      if (result.success) {
        setData(result.data);
      } else {
        setError(result.message || "❌ خطأ في البيانات");
      }
    } catch (err) {
      setError(err.message || "❌ حدث خطأ أثناء الاتصال بالسيرفر");
    } finally {
      setLoading(false);
    }
  };

  const chartData = {
    labels: data.months,
    datasets: [
      {
        label: "الإيرادات",
        data: data.monthlyRevenue,
        borderColor: "#0d6efd",
        backgroundColor: "#0d6efd33",
      },
      {
        label: "المصاريف",
        data: data.monthlyExpenses,
        borderColor: "#dc3545",
        backgroundColor: "#dc354533",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: { display: true, text: "أداء الإيرادات والمصاريف الشهري" },
    },
  };

  return (
    <div className="accounting-dashboard p-4">
      {/* 🔵 زر الصندوق */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="text-center">📊 لوحة المحاسبة الخاصة بالشبكة</h2>

        <a
          href="/balance"      // ← ضع هنا رابط صفحة الصندوق
          className="btn btn-primary"
          style={{ fontSize: "18px", padding: "8px 20px" }}
        >
          💰 الصندوق
        </a>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {loading && <div className="loading">⏳ جاري تحميل البيانات...</div>}

      {!loading && !error && (
        <>
          <div className="stats-grid">
            <div className="stat-item">
              <i className="fas fa-users fa-2x"></i>
              <span className="title">عدد الحسابات المستحقة</span>
              <span className="value">{data.dueAccounts}</span>
            </div>

            <div className="stat-item">
              <i className="fas fa-wallet fa-2x"></i>
              <span className="title">المبالغ المستحقة</span>
              <span className="value">{data.dueAmount} </span>
            </div>

            <div className="stat-item">
              <i className="fas fa-file-invoice-dollar fa-2x"></i>
              <span className="title">مصاريف الشهر</span>
              <span className="value">{data.monthExpenses} </span>
            </div>

            <div className="stat-item">
              <i className="fas fa-cash-register fa-2x"></i>
              <span className="title">رصيد الصندوق</span>
              <span className="value">{data.cashBalance} </span>
            </div>

            <div className="stat-item">
              <i className="fas fa-chart-line fa-2x"></i>
              <span className="title">إجمالي الربح</span>
              <span className="value">{data.totalProfit} </span>
            </div>
          </div>

          <div className="chart-container mt-5">
            <Line data={chartData} options={chartOptions} />
          </div>
        </>
      )}
    </div>
  );
}






function CustomerDashboard() {
  const navigate = useNavigate();

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // فلاتر البحث
  const [filterName, setFilterName] = useState('');
  const [filterPhone, setFilterPhone] = useState('');
  const [filterMinBalance, setFilterMinBalance] = useState('');
  const [filterMaxBalance, setFilterMaxBalance] = useState('');

  // الفرز
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");

  // التعديل
  const [editingId, setEditingId] = useState(null);

  const [editForm, setEditForm] = useState({
  name: "",
  phone: "",
  reminderDays: "",
  address: "",
  nationalId: "",
  stopIfNegative: 0,
  stopIfDebtOver: 0,
  maxDebt: ""
});


  // موبايل
  const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 640);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // جلب العملاء
  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    setLoading(true);
    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?get-customers&token=${token}`);
      const text = await res.text();
      const result = JSON.parse(text);

      if (result.success) setCustomers(result.data);
      else setError(result.message);

    } catch {
      setError("❌ خطأ أثناء الاتصال بالسيرفر");
    }

    setLoading(false);
  };

  // فتح المودال
const openModal = (c) => {
  setEditingId(c.id);
setEditForm({
  name: c.name,
  phone: c.phone,
  reminderDays: c.reminderDays,
  address: c.address || "",
  nationalId: c.nationalId || "",
  stopIfNegative: c.stopIfNegative || 0,
  stopIfDebtOver: c.stopIfDebtOver || 0,
  maxDebt: c.maxDebt || ""
});
  const modal = new window.bootstrap.Modal(document.getElementById("editModal"));
  modal.show();
};

  // إغلاق المودال
  const closeModal = () => {
    setEditingId(null);
    const modal = window.bootstrap.Modal.getInstance(document.getElementById("editModal"));
    modal.hide();
  };

  // حفظ التعديل
  
const handleSave = async () => {
  // التحقق من رقم الهاتف
  const phonePattern = /^09\d{8}$/; // يبدأ بـ 09 ويتبعه 8 أرقام = 10 خانات
  if (!phonePattern.test(editForm.phone)) {
    alert("❌ رقم الهاتف يجب أن يكون 10 خانات ويبدأ بـ 09");
    return;
  }

  if (!editForm.reminderDays || Number(editForm.reminderDays) <= 0) {
    alert("❌ يجب إدخال رقم صالح لتذكير الدفع");
    return;
  }

  const token = localStorage.getItem("authToken");

  try {
    const res = await fetch(`https://mcrm.com.tr/api.php?update-customer&token=${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
body: JSON.stringify({
  id: editingId,
  name: editForm.name,
  phone: editForm.phone,
  reminderDays: editForm.reminderDays,
  address: editForm.address,
  nationalId: editForm.nationalId,
  stopIfNegative: editForm.stopIfNegative,
  stopIfDebtOver: editForm.stopIfDebtOver,
  maxDebt: editForm.maxDebt
}),
    });

    const result = await res.json();

    if (result.success) {
      setCustomers(prev =>
        prev.map(c =>
          c.id === editingId
            ? { ...c,
                name: editForm.name,
                phone: editForm.phone,
                reminderDays: editForm.reminderDays,
                address: editForm.address,
                nationalId: editForm.nationalId
              }
            : c
        )
      );
      closeModal();
    } else alert(result.message);

  } catch {
    alert("❌ خطأ أثناء الاتصال بالسيرفر");
  }
};


  // حذف
  const handleDelete = async (customer) => {
    if (customer.broadbandAccounts > 0 || customer.hotspotAccounts > 0 || customer.balance > 0) {
      alert("❌ لا يمكن حذف العميل لأنه مرتبط بحسابات أو رصيد.");
      return;
    }

    if (!window.confirm(`هل أنت متأكد من حذف العميل "${customer.name}"؟`)) return;

    const token = localStorage.getItem("authToken");

    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?delete-customer&token=${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: customer.id }),
      });

      const result = await res.json();

      if (result.success) {
        setCustomers(prev => prev.filter(c => c.id !== customer.id));
      } else alert(result.message);

    } catch {
      alert("❌ خطأ أثناء الاتصال بالسيرفر");
    }
  };

  // تغيير اتجاه الفرز
  const toggleSort = (col) => {
    if (sortColumn === col) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(col);
      setSortDirection("asc");
    }
  };

  // عمل فلترة + فرز
  const filteredCustomers = customers
    .filter(c => {
      const nameMatch = c.name.toLowerCase().includes(filterName.toLowerCase());
      const phoneMatch = c.phone.toLowerCase().includes(filterPhone.toLowerCase());
      const minBalance = filterMinBalance ? c.balance >= Number(filterMinBalance) : true;
      const maxBalance = filterMaxBalance ? c.balance <= Number(filterMaxBalance) : true;
      return nameMatch && phoneMatch && minBalance && maxBalance;
    })
    .sort((a, b) => {
      let valA = a[sortColumn];
      let valB = b[sortColumn];

      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (valA < valB) return sortDirection === "asc" ? -1 : 1;
      if (valA > valB) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });

  const sortArrow = (col) =>
    sortColumn === col ? (sortDirection === "asc" ? "▲" : "▼") : "↕";

  if (loading) return <p className="text-center py-5">📡 جاري تحميل العملاء...</p>;

  return (
    <div className="container py-4" style={{ direction: "rtl" }}>
      <h2 className="mb-4 text-center text-primary">👥 لوحة العملاء</h2>

      {/* ————————————— الفلاتر ————————————— */}
      <div className="card p-3 shadow-sm mb-4">

        <div className="row g-3">

          <div className="col-md-3">
            <label>بحث بالاسم</label>
            <input className="form-control" value={filterName}
              onChange={(e) => setFilterName(e.target.value)} />
          </div>

          <div className="col-md-3">
            <label>بحث بالهاتف</label>
            <input className="form-control" value={filterPhone}
              onChange={(e) => setFilterPhone(e.target.value)} />
          </div>

          <div className="col-md-3">
            <label>رصيد من</label>
            <input type="number" className="form-control" value={filterMinBalance}
              onChange={(e) => setFilterMinBalance(e.target.value)} />
          </div>

          <div className="col-md-3">
            <label>رصيد إلى</label>
            <input type="number" className="form-control" value={filterMaxBalance}
              onChange={(e) => setFilterMaxBalance(e.target.value)} />
          </div>

        </div>

        <div className="text-end mt-3">
          <button
            className="btn btn-secondary"
            onClick={() => {
              setFilterName("");
              setFilterPhone("");
              setFilterMinBalance("");
              setFilterMaxBalance("");
            }}>
            ✖ مسح الفلاتر
          </button>
        </div>

      </div>

      {/* ————————————— جدول الكمبيوتر ————————————— */}
      <div className="d-none d-md-block table-responsive shadow-sm rounded-3 overflow-hidden">
        <table className="table table-hover table-striped text-center align-middle mb-0">
          <thead className="table-dark">
            <tr>
              <th onClick={() => toggleSort("id")} style={{ cursor: "pointer" }}>
                رقم المعرف {sortArrow("id")}
              </th>

              <th onClick={() => toggleSort("name")} style={{ cursor: "pointer" }}>
                الاسم {sortArrow("name")}
              </th>

              <th onClick={() => toggleSort("phone")} style={{ cursor: "pointer" }}>
                الهاتف {sortArrow("phone")}
              </th>

              <th onClick={() => toggleSort("broadbandAccounts")} style={{ cursor: "pointer" }}>
                برودباند {sortArrow("broadbandAccounts")}
              </th>

              <th onClick={() => toggleSort("hotspotAccounts")} style={{ cursor: "pointer" }}>
                هوت سبوت {sortArrow("hotspotAccounts")}
              </th>

              <th onClick={() => toggleSort("balance")} style={{ cursor: "pointer" }}>
                الرصيد {sortArrow("balance")}
              </th>

              <th>تعديل</th>
              <th>حذف</th>
            </tr>
          </thead>

          <tbody>
            {filteredCustomers.length > 0 ? (
              filteredCustomers.map(c => (
                <tr key={c.id}>
                  <td>{c.id}</td>
                  <td>{c.name}</td>
                  <td>{c.phone}</td>

                  <td>
                    <button className="btn btn-link"
                      onClick={() => navigate(`/broadband-accounts/${c.id}`)}>
                      {c.broadbandAccounts}
                    </button>
                  </td>

                  <td>
                    <button className="btn btn-link"
                      onClick={() => navigate(`/hotspot-accounts/${c.id}`)}>
                      {c.hotspotAccounts}
                    </button>
                  </td>

                  <td>
                    <button className="btn btn-link text-info"
                      onClick={() => navigate(`/balance/${c.id}`)}>
                      {c.balance} 
                    </button>
                  </td>

                  <td>
                    <button className="btn btn-warning btn-sm"
                      onClick={() => openModal(c)}>
                      🖊 تعديل
                    </button>
                  </td>

                  <td>
                    <button className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(c)}>
                      🗑 حذف
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-muted py-3">
                  لا توجد نتائج حسب الفلتر المحدد
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ————————————— بطاقات الموبايل ————————————— */}
      
<div className="d-block d-md-none">
  {filteredCustomers.length > 0 ? (
    filteredCustomers.map(customer => (
      <div key={customer.id} className="mobile-card">

        {/* الاسم */}
        <h5 className="mobile-card-name">{customer.name}</h5>

        {/* معلومات */}
        <p className="mobile-card-info">
          رقم المعرف: {customer.id} <br />
          الهاتف: {customer.phone}
        </p>

        {/* القيم */}
        <div className="mobile-values-grid">
          <span className="mobile-value-box mobile-blue"
            onClick={() => navigate(`/broadband-accounts/${customer.id}`)}
            style={{ cursor: "pointer" }}
          >
            بروبداند: {customer.broadbandAccounts}
          </span>

          <span className="mobile-value-box mobile-blue"
            onClick={() => navigate(`/hotspot/${customer.id}`)}
            style={{ cursor: "pointer" }}
          >
            هوت سبوت: {customer.hotspotAccounts}
          </span>

          <span className="mobile-value-box mobile-green"
            onClick={() => navigate(`/balance/${customer.id}`)}
            style={{ cursor: "pointer" }}
          >
            الرصيد: {customer.balance} 
          </span>
        </div>

        {/* الأزرار */}
        <button
          className="btn btn-warning mobile-btn mb-2"
          onClick={() => openModal(customer)}
        >
          ✏ تعديل
        </button>

        <button
          className="btn btn-danger mobile-btn"
          onClick={() => handleDelete(customer)}
        >
          🗑 حذف
        </button>

      </div>
    ))
  ) : (
    <p className="text-center text-muted">لا توجد نتائج حسب الفلتر المحدد</p>
  )}
</div>


      {/* ————————————— مودال التعديل ————————————— */}
      <div className="modal fade" id="editModal" tabIndex="-1">
    <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">تعديل بيانات العميل</h5>
              <button type="button" className="btn-close" onClick={closeModal}></button>
            </div>

            <div className="modal-body">
              <label>الاسم</label>
              <input className="form-control mb-3"
                value={editForm.name}
                onChange={(e) => setEditForm({ ...editForm, name: e.target.value })} />

              <label>الهاتف</label>
              <input className="form-control"
                value={editForm.phone}
                onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })} />
            
            <label>العنوان</label>
<input
  className="form-control mb-3"
  value={editForm.address}
  onChange={(e) => setEditForm({ ...editForm, address: e.target.value })}
/>

<label>الرقم الوطني</label>
<input
  className="form-control mb-3"
  value={editForm.nationalId}
  onChange={(e) => setEditForm({ ...editForm, nationalId: e.target.value })}
/>


              {/* حقل جديد لتذكير الدفع */}
  <label>تذكير بدفع المستحقات كل (أيام)</label>
  <input
    type="number"
    className="form-control"
    value={editForm.reminderDays || ""}
    onChange={(e) =>
      setEditForm({ ...editForm, reminderDays: e.target.value })
    }
    placeholder="أدخل رقم الأيام"
  />



<hr />

<label>إيقاف الحساب إذا أصبح الرصيد سالب؟</label>
<select
  className="form-control mb-3"
  value={editForm.stopIfNegative}
  onChange={(e) =>
    setEditForm({ ...editForm, stopIfNegative: e.target.value })
  }
>
  <option value={0}>لا</option>
  <option value={1}>نعم</option>
</select>

<label>إيقاف الحساب إذا أصبح الدين أكثر من حد معين؟</label>
<select
  className="form-control mb-3"
  value={editForm.stopIfDebtOver}
  onChange={(e) =>
    setEditForm({ ...editForm, stopIfDebtOver: e.target.value })
  }
>
  <option value={0}>لا</option>
  <option value={1}>نعم</option>
</select>

{editForm.stopIfDebtOver == 1 && (
  <>
    <label>الحد الأعلى للدين</label>
    <input
      type="number"
      className="form-control mb-3"
      value={editForm.maxDebt}
      onChange={(e) =>
        setEditForm({ ...editForm, maxDebt: e.target.value })
      }
      placeholder="مثال: 100"
    />
  </>
)}





            </div>

            <div className="modal-footer">
              <button className="btn btn-success" onClick={handleSave}>حفظ</button>
              <button className="btn btn-secondary" onClick={closeModal}>إلغاء</button>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}




function ChangePasswordForm() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage('❌ كلمة المرور غير متطابقة');
      return;
    }

    setLoading(true);
    setMessage('');
    const token = localStorage.getItem('authToken');

    try {
      const response = await fetch(`https://mcrm.com.tr/api.php?change-password&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword }),
      });

      const result = await response.json();
      if (result.success) {
        setMessage('✅ تم تغيير كلمة المرور بنجاح');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        setMessage(`❌ ${result.message}`);
      }
    } catch {
      setMessage('❌ حدث خطأ أثناء الاتصال بالسيرفر');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="change-password-container">
      <form className="change-password-form" onSubmit={handleSubmit}>
        <h2>🔐 تغيير كلمة المرور</h2>

        {message && <div className="message">{message}</div>}

        <label>كلمة المرور الجديدة</label>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="كلمة المرور الجديدة"
          required
        />

        <label>تأكيد كلمة المرور</label>
        <input
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          placeholder="تأكيد كلمة المرور"
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? '⏳ جاري الحفظ...' : '💾 حفظ التغييرات'}
        </button>
      </form>
    </div>
  );
}


function TransactionCard({ transaction }) {
    const statusDotColor = STATUS_COLORS[transaction.status] || '#6c757d'; // لون رمادي افتراضي

    return (
        <div className="transaction-card">
            <div className="transaction-header">
                <h6 className="transaction-title">{transaction.title}</h6>
                {transaction.status && (
                    <div className="transaction-status">
                        <span className="status-dot" style={{ backgroundColor: statusDotColor }}></span>
                        <span style={{ color: statusDotColor }}>{transaction.status}</span>
                    </div>
                )}
                {/* لعرض 'قيد المعالجة' أو 'المعالجة' */}
                {transaction.processingStatus && (
                    <div className="transaction-status">
                        <span className="status-dot" style={{ backgroundColor: STATUS_COLORS['قيد المعالجة'] }}></span>
                        <span style={{ color: STATUS_COLORS['قيد المعالجة'] }}>{transaction.processingStatus}</span>
                    </div>
                )}
            </div>

            <div className="transaction-details-grid">
                <div className="detail-row">
                    <span className="detail-label">التاريخ</span>
                    <span className="detail-value">{transaction.date}</span>
                </div>
                {transaction.method && (
                    <div className="detail-row">
                        <span className="detail-label">طريقة الإيداع</span>
                        <span className="detail-value">{transaction.method}</span>
                    </div>
                )}
                {transaction.reason && (
                    <div className="detail-row">
                        <span className="detail-label">سبب المعالجة</span>
                        <span className="detail-value">{transaction.reason}</span>
                    </div>
                )}
                {transaction.orderId && (
                    <div className="detail-row">
                        <span className="detail-label">رقم العملية</span>
                        <span className="detail-value">{transaction.orderId}</span>
                    </div>
                )}
                 <div className="detail-row">
                    <span className="detail-label">المبلغ</span>
                    <span className={`detail-value amount-value ${transaction.amount.startsWith('-') ? 'amount-minus' : 'amount-plus'}`}>
                        {transaction.amount} {transaction.currency}
                    </span>
                </div>
            </div>

           
        </div>
    );
}





function HomePage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setError('لم يتم العثور على التوكين، الرجاء تسجيل الدخول مجدداً.');
      setLoading(false);
      navigate('/');
      return;
    }

    const fetchData = () => {
      const token = localStorage.getItem('authToken');
      fetch(`https://mcrm.com.tr/api.php?home&token=${token}`)
        .then(res => res.json())
        .then(json => {
          setData(json);
          setLoading(false);
        })
        .catch(err => {
          console.error('فشل تحميل البيانات:', err);
          setError('فشل تحميل البيانات');
          setLoading(false);
        });
    };

    fetchData();
    const interval = setInterval(fetchData, 20000);
    return () => clearInterval(interval);
  }, [navigate]);

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="error text-danger mt-4">{error}</div>;
  if (!data) return null;

  // ✅ تحقق من حالة السيرفر (بناءً على بيانات الـ API)
  const isServerOffline =
    data.server_status === 'offline' ||
    data.status === 'error' ||
    data.server_status === false ||
    data.server_status === 'false';


const systemRemaining = data?.systemRemaining || null;
const whatsappRemaining = data?.whatsappRemaining || null;



  return (
    <div className="dashboard">


{/* ⏳ تنبيه الاشتراك */}
{systemRemaining && systemRemaining.days <= 5 && (
  <div style={{
    background: systemRemaining.days <= 1 ? "#d9534f" : "#f0ad4e",
    color: "#fff",
    padding: "12px",
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: "8px",
    marginBottom: "10px"
  }}>
    🖥️ اشتراك النظام ينتهي بعد {systemRemaining.days} يوم و {systemRemaining.hours} ساعة
  </div>
)}

{whatsappRemaining && whatsappRemaining.days <= 5 && (
  <div style={{
    background: whatsappRemaining.days <= 1 ? "#d9534f" : "#5bc0de",
    color: "#fff",
    padding: "12px",
    textAlign: "center",
    fontWeight: "bold",
    borderRadius: "8px",
    marginBottom: "15px"
  }}>
    🤖 بوت واتساب ينتهي بعد {whatsappRemaining.days} يوم و {whatsappRemaining.hours} ساعة
  </div>
)}



      {/* 🔴 الشريط الأحمر في حال السيرفر غير متصل */}
      {isServerOffline && (
        <div style={{
          backgroundColor: '#d9534f',
          color: '#fff',
          textAlign: 'center',
          padding: '12px',
          fontWeight: 'bold',
          borderBottom: '3px solid #b52b27',
          fontSize: '16px',
          position: 'sticky',
          top: 0,
          zIndex: 9999
        }}>
          ⚠️ المنصة غير متصلة بالسيرفر، يرجى تحديث الصفحة بعد 5 دقائق قبل التواصل مع الدعم الفني
        </div>
      )}

      {/* الإحصائيات العامة */}
      <section className="grid two-column">
        <Card title="هوتسبوت " value={data.activeSpot} icon="fas fa-user" color="blue" />
        <Card title="برودباند " value={data.activeRb} icon="fas fa-user-lock" color="purple" />
        <Card title="الترافيك" value={`${data.traffic}`} icon="fas fa-chart-line" color="orange" />
        <Card title="المعالج" value={`${data.cpu}%`} icon="fas fa-microchip" color="red" isProgress />
      </section>

      {/* الحسابات المنتهية قريباً - هوتسبوت */}
      <section className="expiring-summary">
        <div className="expiring-box">
          <div className="expiring-header">
            <span className="expiring-title">تنتهي قريباً هوتسبوت</span>
            <span className="expiring-total">{data.expiringSpot}</span>
          </div>
          <div className="expiring-days">
            {data.spotExpiringDays?.map((count, index) => (
              <span className="day-badge" key={index}>
                {count}
              </span>
            ))}
            <span className="day-badge">الكل</span>
          </div>
        </div>
      </section>

      {/* الحسابات المنتهية قريباً - برودباند */}
      <section className="expiring-summary">
        <div className="expiring-boxx">
          <div className="expiring-header">
            <span className="expiring-title">تنتهي قريباً برودباند</span>
            <span className="expiring-total">{data.expiringRb}</span>
          </div>
          <div className="expiring-days">
            {data.pppoeExpiringDays?.map((count, index) => (
              <span className="day-badge" key={index}>
                {count}
              </span>
            ))}
            <span className="day-badge">الكل</span>
          </div>
        </div>
      </section>

      {/* حالة الخدمات */}
      <section className="grid two-column">
        <Service
          title="سكربت الربط"
          value={data.linkScript === true || data.linkScript === "متصل" || data.linkScript === "true" ? "متصل" : "غير متصل"}
          status={data.linkScript === true || data.linkScript === "متصل" || data.linkScript === "true"}
        />

        <Service
          title="تحكم بعيد"
          value={data.remoteControl === true || data.remoteControl === "متصل" || data.remoteControl === "true" ? "متصل" : "غير متصل"}
          status={data.remoteControl === true || data.remoteControl === "متصل" || data.remoteControl === "true"}
        />

       

        <Service
          title="Real API"
          value={data.realApi === true || data.realApi === "متصل" || data.realApi === "true" ? "متصل" : "غير متصل"}
          status={data.realApi === true || data.realApi === "متصل" || data.realApi === "true"}
        />

        <Service
          title="عداد الجيغات برودباند"
          value={data.okk === true || data.okk === "مفعل" || data.okk === "true" ? "مفعل" : "غير مفعل"}
          status={data.okk === true || data.okk === "مفعل" || data.okk === "true"}
        />
      </section>

      {/* إحصائيات الهوتسبوت */}
      <section className="grid two-column">
        <Card title="هوتسبوت مفعلة" value={data.spot.active} icon="fas fa-wifi" color="green" />
        <Card title="تجهيزات خارج الخدمة" value={data.spot.noactived} icon="fas fa-plug" color="gray" />
        <Card title="هوتسبوت معطلة" value={data.spot.disabled} icon="fas fa-ban" color="red" />
        <Card title="هوتسبوت لم تتوقف" value={data.spot.notStopped} icon="fas fa-pause-circle" color="orange" />
        <Card title="برودباند ايام لم يتوقف" value={data.spot.notStoppedb} icon="fas fa-calendar-times" color="orange" />
        <Card title="برودباند جيغات لم يتوقف" value={data.spot.notStoppedp} icon="fas fa-database" color="orange" />
        <Card title="مبيعات اليوم" value={data.spot.sale} icon="fas fa-dollar-sign" color="blue" />
      </section>
    </div>
  );
}




function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstall(true);
    };

    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('✅ تم التثبيت');
        }
        setDeferredPrompt(null);
        setShowInstall(false);
      });
    }
  };

  return (
    showInstall && (
<button onClick={handleInstallClick} className="center-install-button">
  📲 تثبيت التطبيق
</button>

    )
  );
}



function EditableProviderForm() {
  const [provider, setProvider] = useState({
    name: "",
    logo: "",
    icon: "",
    theme_color: "#2563eb",
    support: "",
    website: "",
    operation_type: "USDT",   // ✅ جديد
    shamcash_code: "",        // ✅ جديد
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [appLink, setAppLink] = useState(""); // ✅ رابط التطبيق بعد الحفظ

  // ✅ تحميل بيانات المزود بناء على التوكين
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("⚠️ يرجى تسجيل الدخول أولاً.");
      setLoading(false);
      return;
    }

    fetch(`https://mcrm.com.tr/api.php?homes&token=${token}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.provider) {
          setProvider(data.provider);
          if (data.provider.website) {
            setAppLink(`https://wifisy.com/${data.provider.website}`);
          }
        } else {
          setMessage("تعذر تحميل بيانات المزود ❌");
        }
      })
      .catch(() => setMessage("حدث خطأ أثناء الاتصال بالخادم"))
      .finally(() => setLoading(false));
  }, []);

  // ✅ تحديث القيم النصية
  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = name === "website" ? value.toLowerCase() : value;
    setProvider((prev) => ({ ...prev, [name]: newValue }));
  };

  // ✅ تحميل الصورة للشعار أو الأيقونة
  const handleFileUpload = async (e, field) => {
    const file = e.target.files[0];
    if (!file) return;

    const token = localStorage.getItem("authToken");
    const formData = new FormData();
    formData.append("file", file);
    formData.append("token", token);

    setMessage("📤 جاري رفع الصورة...");

    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?upload_image`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();

      if (data.success && data.url) {
        setProvider((prev) => ({ ...prev, [field]: data.url }));
        setMessage("✅ تم رفع الصورة بنجاح");
      } else {
        setMessage("❌ فشل رفع الصورة");
      }
    } catch (err) {
      setMessage("⚠️ حدث خطأ أثناء الرفع");
    }
  };

  // ✅ التحقق من صحة الدومين
  const validateDomain = (domain) => /^[a-zA-Z0-9-]+$/.test(domain);

  // ✅ حفظ التعديلات
  const handleSave = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      setMessage("⚠️ لا يوجد توكين. يرجى تسجيل الدخول.");
      return;
    }

    if (!validateDomain(provider.website)) {
      setMessage("❌ يجب أن يحتوي الدومين على أحرف إنكليزية وأرقام فقط بدون رموز أو فراغات.");
      return;
    }

    setSaving(true);
    setMessage("⏳ جاري التحقق من توفر الدومين...");

    const checkRes = await fetch(
      `https://mcrm.com.tr/api.php?check_domain=${provider.website}&token=${token}`
    );
    const checkData = await checkRes.json();

    if (checkData.used) {
      setSaving(false);
      setMessage("❌ هذا الدومين مستخدم بالفعل، اختر آخر.");
      return;
    }

    setMessage("💾 جاري حفظ التعديلات...");

    const res = await fetch(
      `https://mcrm.com.tr/api.php?update_provider&token=${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(provider),
      }
    );

    const data = await res.json();
    if (data.success) {
      setMessage("✅ تم حفظ التعديلات بنجاح!");
      const newLink = `https://wifisy.com/${provider.website}`;
      setAppLink(newLink);
    } else {
      setMessage("❌ فشل الحفظ، حاول مرة أخرى.");
    }
    setSaving(false);
  };

  // ✅ نسخ الرابط
  const handleCopy = () => {
    navigator.clipboard.writeText(appLink);
    setMessage("📋 تم نسخ رابط التطبيق بنجاح!");
  };

  if (loading) return <div className="loading">⏳ جاري تحميل البيانات...</div>;

  return (
    <div className="provider-form">
      <h2>تعديل معلومات المزود</h2>

      <label>اسم المزود:</label>
      <input type="text" name="name" value={provider.name} onChange={handleChange} />

      <label>الشعار:</label>
      <input type="file" accept="image/*" onChange={(e) => handleFileUpload(e, "logo")} />
      {provider.logo && (
        <img src={provider.logo} alt="Logo" style={{ width: 100, marginTop: 10 }} />
      )}

      <label>الأيقونة:</label>
      <input type="file" accept="image/*" onChange={(e) => handleFileUpload(e, "icon")} />
      {provider.icon && (
        <img src={provider.icon} alt="Icon" style={{ width: 60, marginTop: 10 }} />
      )}

      <label>لون الواجهة:</label>
      <input
        type="color"
        name="theme_color"
        value={provider.theme_color}
        onChange={handleChange}
      />

      <label>رقم الدعم:</label>
      <input type="text" name="support" value={provider.support} onChange={handleChange} />

      <label>الدومين (أحرف إنكليزية فقط):</label>
      <input
        type="text"
        name="website"
        value={provider.website}
        onChange={handleChange}
        placeholder="مثال: syriacash"
      />

      <label>نوع العملية:</label>
      <select
        name="operation_type"
        value={provider.operation_type}
        onChange={handleChange}
      >
        <option value="USDT">USDT</option>
        <option value="SYP">SYP</option>
      </select>

      <label>كود الشام كاش:</label>
      <input
        type="text"
        name="shamcash_code"
        value={provider.shamcash_code}
        onChange={handleChange}
        placeholder="ادخل كود الشام كاش"
      />

      <button className="btn btn-success" onClick={handleSave} disabled={saving}>
        {saving ? "جاري الحفظ..." : "💾 حفظ التعديلات"}
      </button>

      {appLink && (
        <div className="app-link-box">
          <p>
            🌐 رابط تطبيقك:
            <br />
            <a href={appLink} target="_blank" rel="noopener noreferrer">
              {appLink}
            </a>
          </p>
          <button className="btn btn-outline-primary" onClick={handleCopy}>
            📋 نسخ الرابط
          </button>
        </div>
      )}

      {message && <p className="msg">{message}</p>}
    </div>
  );
}









function Toolx() {
  const [loading, setLoading] = useState(false);
  const [linked, setLinked] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleLink = () => {
    setLoading(true);
    fetch(`https://mcrm.com.tr/api.php?checkRemoteStatus&token=${localStorage.getItem('authToken')}`)
      .then(res => res.json())
   
.then(json => {
  setLoading(false);
  if (json.status === "success") {
    setLinked(true);
    setMessage(json.message || '✅ التحكم البعيد مفعل، يتم الآن الدخول...');
    setMessageType('success');
    handleEnterServer();
  } else {
    setLinked(false);
    const errorMsg =
      Array.isArray(json.errors) && json.errors.length > 0
        ? json.errors.join('، ')
        : (json.message || '❌ التحكم البعيد غير مفعل حالياً.');
    setMessage(errorMsg);
    setMessageType('error');
  }
})


      .catch(() => {
        setLoading(false);
        setMessage('⚠️ حدث خطأ أثناء التحقق من حالة التحكم.');
        setMessageType('error');
      });
  };

  const handleEnterServer = () => {
    setLoading(true);
    fetch(`https://mcrm.com.tr/api.php?checkRemoteStatus&token=${localStorage.getItem('authToken')}`)
      .then(res => res.json())
      .then(json => {
        setLoading(false);
        if (json.success && json.url) {
          window.open(json.url, '_blank');
        } else {
          setMessage('⚠️ فشل في الحصول على رابط الدخول.');
          setMessageType('error');
        }
      })
      .catch(() => {
        setLoading(false);
        setMessage('⚠️ حدث خطأ أثناء الاتصال بالخادم.');
        setMessageType('error');
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={handleLink} disabled={loading}>
        {loading ? '⏳ جاري التحقق...' : '🔌 التحقق من التحكم البعيد'}
      </button>

      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage('')}
      />
    </div>
  );
}



function RemoteConnectTool() {
  const { deviceId, port } = useParams(); // ← استقبال الرقمين من الرابط
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const handleConnection = async () => {
    setLoading(true);
    setProgress(0);
    setMessage(`🔄 جاري الاتصال بالتجهيزة رقم ${deviceId} على البورت ${port}...`);
    setMessageType('info');

    try {
      for (let i = 1; i <= 90; i += 10) {
        setProgress(i);
        await sleep(100);
      }

      // تمرير رقم التجهيزة والبورت إلى الـ API
      const res = await fetch(`https://mcrm.com.tr/api.php?checkRemoteStatusgo&token=${localStorage.getItem('authToken')}&device=${deviceId}&port=${port}`);
      const json = await res.json();

      setProgress(100);

   if (json.success && json.details?.ip && json.details?.port) {
  const protocol = json.details.port === "443" ? "http" : "https";
  const url = `${protocol}://ip.mcrm.com.tr:${json.details.port}`;

  setMessage('✅ تم الاتصال، يتم الآن فتح التجهيزة...');
  setMessageType('success');
  await sleep(500);
  window.open(url, '_blank');
} else {
        const errorMsg =
          Array.isArray(json.errors) && json.errors.length > 0
            ? json.errors.join('، ')
            : '❌ فشل الاتصال بالتجهيزة.';
        setMessage(errorMsg);
        setMessageType('error');
      }
    } catch (err) {
      setMessage('⚠️ حدث خطأ أثناء الاتصال بالتجهيزة.');
      setMessageType('error');
    }

    setLoading(false);
  };

  useEffect(() => {
    if (deviceId && port) handleConnection(); // ← تشغيل تلقائي فقط عند وجود كلا المتغيرين
  }, [deviceId, port]);

  return (
    <div className="p-3">
      {loading && <ProgressBar striped animated now={progress} className="mt-3" />}
      {message && (
        <div className={`alert alert-${messageType} mt-3`} role="alert">
          {message}
        </div>
      )}
    </div>
  );
}





function Tool() {
  const [loading, setLoading] = useState(false);
  const [linked, setLinked] = useState(false);

const [message, setMessage] = useState('');
const [messageType, setMessageType] = useState('success');


  const handleEnterServer = () => {
    setLoading(true);
    fetch(`https://mcrm.com.tr/api.php?getLoginURL&token=${localStorage.getItem('authToken')}`)
      .then(res => res.json())
      .then(json => {
        setLoading(false);
        if (json.success && json.url) {
          window.open(json.url, '_blank');
        } else {
          alert('فشل في الحصول على رابط الدخول.');
        }
      })
      .catch(() => {
        setLoading(false);
        alert('حدث خطأ أثناء الاتصال بالخادم.');
      });
  };







  const deletfinshcard = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/deletfinshcard';
    
  };



  const handleLinkServer = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/linkserver';
    
  };

  
 const handleServerAnalysis = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/server';
    
  };


   const handleLink = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/remot';
    
  };

   const handleLinxk = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/eroeeserver';
    
  };




   const WidGet = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/WidGet';
    
  };







   const sitPoe = () => {
    // فتح الرابط في لسان جديد
     window.location.href = '/spoe';
    
  };

const handleWhatsAppBot = () => {
   window.location.href = '/whatsapp';
};

const handleBroadcastMessages = () => {
   window.location.href = '/sendwhatsapp';
};



const sitPoecc = () => {
   window.location.href = '/eroeeserverx';
};


const handleBroadcastDmg = () => {
   window.location.href = '/linedmg';
};




const speddopen = () => {
   window.location.href = '/speddopen';
};



const handleBroadcastDmgapp = () => {
   window.location.href = '/myapp';
};

const handleLinxkC = () => {
   window.location.href = 'https://wa.me/963989582661';
};



  const handleSpeedTest = () => {
    alert('جاري قياس سرعة الإنترنت... يمكنك لاحقاً دمج Speedtest API هنا.');
  };



  return (
    <div className="home-container">
      <h1 className="home-title">لوحة التحكم</h1>

      <div className="button-group">
        <button className="btn primary" onClick={handleEnterServer} disabled={loading}>
          <i className="fas fa-sign-in-alt"></i> {loading ? 'جارٍ الدخول...' : 'دخول للسيرفر'}
        </button>

   
        <button className="btn danger" onClick={handleServerAnalysis}>
          <i className="fas fa-stethoscope"></i> تحليل مشاكل المنجرتك
        </button>



        <button className="btn secondary" onClick={handleWhatsAppBot}>
          <i className="fab fa-whatsapp"></i> بوت الواتس اب   
        </button>



<button className="btn danger" onClick={deletfinshcard}>
  <i className="fas fa-trash-alt"></i> حذف الكروت المنتهية
</button>



<button className="btn danger" onClick={sitPoe}>
  <i className="fas fa-cogs"></i> خيارات للبرودباند
</button>






    <button
      className={`btn ${linked ? 'success' : 'primary'}`}
      onClick={handleLinkServer}
    >
      <i className="fas fa-server"></i>{' '}
      {linked ? 'تم الربط مع السيرفر' : 'الربط مع السيرفر'}
    </button>
 



<button className="btn danger" onClick={handleBroadcastDmgapp}>
  <i className="fab fa-android"></i> تطبيق الشبكة  
</button>


    <MessageDisplay
      message={message}
      type={messageType}
      onClose={() => setMessage('')}
    />
      </div>
    </div>



  );
}



function ServerAnalysis() {
  const [steps, setSteps] = useState([
    { label: 'التحقق من الاتصال بـ Real IP', status: 'pending', message: '' },
    { label: 'التحقق من سكربت تشغيل الربط', status: 'pending', message: '' },
    { label: 'التحقق من سكربت الربط', status: 'pending', message: '' },
    { label: 'التحقق من بوت API', status: 'pending', message: '' },
    { label: 'التحقق من ملفات الربط', status: 'pending', message: '' },
  ]);
  const [analyzing, setAnalyzing] = useState(false);

  const updateStepStatus = (index, status, message = '') => {
    setSteps(prev =>
      prev.map((step, i) =>
        i === index ? { ...step, status, message } : step
      )
    );
  };

  const handleServerAnalysis = async () => {
    setAnalyzing(true);
    const token = localStorage.getItem('authToken');

    const checks = [
      'checkRealIP',
      'checkScriptInit',
      'checkScriptLink',
      'checkApiBot',
      'checkLinkFiles',
    ];

    for (let i = 0; i < checks.length; i++) {
      updateStepStatus(i, 'loading');

      try {
        const res = await fetch(`https://mcrm.com.tr/api.php?${checks[i]}&token=${token}`);
        const json = await res.json();
        if (json.success) {
          updateStepStatus(i, 'success', json.message || 'تم بنجاح');
        } else {
          updateStepStatus(i, 'error', json.message || 'حدث خطأ');
          break;
        }
      } catch (err) {
        updateStepStatus(i, 'error', 'فشل الاتصال بالخادم');
        break;
      }
    }

    setAnalyzing(false);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'pending':
        return <i className="fas fa-clock text-gray-500"></i>;
      case 'loading':
        return <i className="fas fa-spinner fa-spin text-blue-500"></i>;
      case 'success':
        return <i className="fas fa-check-circle text-green-500"></i>;
      case 'error':
        return <i className="fas fa-times-circle text-red-500"></i>;
      default:
        return null;
    }
  };

  return (
    <div className="server-analysis-container">
      <h2>تحليل مشاكل الربط مع السيرفر</h2>
      <button className="btn danger" onClick={handleServerAnalysis} disabled={analyzing}>
        <i className="fas fa-stethoscope"></i> {analyzing ? 'جاري التحليل...' : 'بدء التحليل'}
      </button>

      <ul className="analysis-steps">
        {steps.map((step, i) => (
          <li key={i} className="analysis-step">
            {getStatusIcon(step.status)} <span>{step.label}</span>
            {step.message && (
            <p className={`message ${step.status === 'success' ? 'success' : step.status === 'error' ? 'error' : ''}`}>
  {step.message}
</p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}



const ConfigScript = () => {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  const [copiedLink, setCopiedLink] = useState('');

  const [inputCode, setInputCode] = useState('');
  const [secret, setSecret] = useState('');
  const [loadingSend, setLoadingSend] = useState(false);
  const [errorSend, setErrorSend] = useState('');

  /* =======================
     جلب البيانات من السيرفر
     ======================= */
  const fetchData = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?script&token=${token}`);
      const json = await res.json();
      setData(json);
    } catch (err) {
      console.error('خطأ في جلب البيانات:', err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* =======================
     إرسال الكود + الرقم السري
     ======================= */
  const sendConfig = async () => {
    if (!inputCode || !secret) {
      setErrorSend('يرجى إدخال الكود والرقم السري');
      return;
    }

    setLoadingSend(true);
    setErrorSend('');

    try {
       const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?scriptx&token=${token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: inputCode,
          password: secret,
          token: localStorage.getItem('authToken'),
        }),
      });

      const json = await res.json();

      if (!res.ok || json.error) {
        throw new Error(json.error || 'فشل الإرسال');
      }

      fetchData();
    } catch (err) {
      setErrorSend(err.message);
    } finally {
      setLoadingSend(false);
    }
  };

  /* =======================
     نسخ الكود
     ======================= */
  const handleCopy = () => {
    if (!data) return;
    navigator.clipboard.writeText(getFormattedCode());
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleCopyLink = (text) => {
    navigator.clipboard.writeText(text);
    setCopiedLink(text);
    setTimeout(() => setCopiedLink(''), 1500);
  };

  /* =======================
     توليد كود MikroTik
     ======================= */
  const getFormattedCode = () => {
    if (!data) return '';
    const { iduser, username, password, ip } = data;

    return `
/interface wireguard
add listen-port=51820 mtu=1420 name=mcrmip

/interface wireguard peers
add allowed-address=201.10.1.1/16 endpoint-address=ip.mcrm.com.tr endpoint-port=51820 interface=mcrmip name=mcrmip persistent-keepalive=25s public-key="HxczKpMyfxBVoEf16vIA3MG3Oi/ow2WmrGtYFpFb12A="

/ip address
add address=${ip}/16 interface=mcrmip network=10.10.10.0


/ppp profile remove [find name="mcrma"]


/interface l2tp-client remove [find name="MCRM"]
/interface l2tp-client remove [find name="MCRMA"]

/ppp profile add change-tcp-mss=yes name=mcrma


/interface l2tp-client add profile=mcrma  connect-to=193.29.104.70 disabled=no name=MCRM password=66 user=66
/interface l2tp-client add profile=mcrma  connect-to=193.187.148.189 disabled=no name=MCRMA password=66 user=66

/ip route add check-gateway=ping disabled=no distance=1 dst-address=72.61.178.49/32 gateway=3.3.3.1 routing-table=main scope=30 target-scope=10
/ip route add check-gateway=ping disabled=no distance=1 dst-address=72.61.178.49/32 gateway=6.3.3.1 routing-table=main scope=30 target-scope=10

/ip service
set api disabled=no port=8728

/user remove [/user find comment="mcrm"]

/user group
add name=mcrm policy=ftp,read,write,test,api

/user
add name=${username} password=${password} address=201.10.10.1 comment=mcrm group=mcrm

/system scheduler remove [find name=command]

/system scheduler
add interval=15s name=command-hotspot+ on-event="/system script run command" start-time=startup

/system script remove [find name=command]

/system script
add name=command source={
 /tool fetch   http-method=post http-data=""   keep-result=yes url="https://mcrm.com.tr/new/app/${iduser}/upgrade.rsc"
 /tool fetch   http-method=post http-data=""   keep-result=no url="https://mcrm.com.tr/new/app/del.php?m=${iduser}"
 /import upgrade.rsc
 /file remove upgrade.rsc
 /tool fetch   http-method=post http-data=""    keep-result=no url="https://mcrm.com.tr/new/app/del.php?m=${iduser}"
  }
`.trim();
  };

  if (!data) return <div>⏳ جاري التحميل...</div>;

  const { apiLink, webLink, winboxLink } = data;

  return (
    <div style={{ maxWidth: '1000px', margin: 'auto', padding: '20px' }}>

      {/* ===== إدخال البيانات ===== */}
      <div style={boxStyle}>
        <h3>🔐 إدخال البيانات</h3>

        <input
          type="text"
          placeholder="الكود"
          value={inputCode}
          onChange={(e) => setInputCode(e.target.value)}
          style={inputStyle}
        />

        <input
          type="password"
          placeholder="الرقم السري"
          value={secret}
          onChange={(e) => setSecret(e.target.value)}
          style={inputStyle}
        />

        {errorSend && <div style={{ color: 'red' }}>{errorSend}</div>}

        <button onClick={sendConfig} disabled={loadingSend} style={submitBtn}>
          {loadingSend ? '⏳ جاري الإرسال...' : '✅ موافق'}
        </button>
      </div>

      {/* ===== كود الإعدادات ===== */}
      <h3>📜 كود الإعدادات</h3>

      <pre style={codeBox}>
        <code>{getFormattedCode()}</code>
      </pre>

      <button onClick={handleCopy} style={copyBtn(copied)}>
        {copied ? '✅ تم النسخ' : '📋 نسخ الكود'}
      </button>

      {/* ===== الروابط ===== */}
      <div style={{ marginTop: '30px' }}>
        <h4>🔗 روابط سريعة</h4>

        {[['API', apiLink], ['WEB', webLink], ['Winbox', winboxLink]].map(
          ([label, link]) => (
            <div key={label} style={{ marginBottom: '10px' }}>
              <strong>{label}:</strong> {link}
              <button onClick={() => handleCopyLink(link)} style={iconBtn}>
                {copiedLink === link ? '✅' : '📋'}
              </button>
              <a href={link} target="_blank" rel="noreferrer"> 🔗 فتح</a>
            </div>
          )
        )}
      </div>
    </div>
  );
};

/* =======================
   Styles
   ======================= */
const inputStyle = {
  width: '100%',
  padding: '10px',
  marginBottom: '10px',
  borderRadius: '5px',
  border: '1px solid #ccc'
};

const boxStyle = {
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  marginBottom: '30px',
  border: '1px solid #ddd'
};

const submitBtn = {
  padding: '10px 25px',
  background: '#28a745',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
};

const codeBox = {
  background: '#f4f4f4',
  padding: '20px',
  borderRadius: '8px',
  overflowX: 'auto',
  direction: 'ltr'
};

const copyBtn = (copied) => ({
  marginTop: '10px',
  padding: '10px 20px',
  backgroundColor: copied ? '#4caf50' : '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '5px',
  cursor: 'pointer'
});

const iconBtn = {
  marginLeft: '10px',
  cursor: 'pointer'
};


// أنماط الأزرار والروابط
const buttonStyle = {
  marginLeft: '10px',
  padding: '4px 10px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer'
};

const openLinkStyle = {
  marginLeft: '10px',
  color: '#007bff',
  textDecoration: 'underline',
  fontWeight: 'bold'
};




const Card = ({ title, value, icon, color, isProgress }) => (
  <div className={`card ${color}`}> 
    <div className="card-icon"><i className={icon}></i></div>
    <div className="card-content">
      <h5>{title}</h5>
      <div className="value">{value}</div>
      {isProgress && <div className="progress"><div style={{ width: value }}></div></div>}
    </div>
  </div>
);

const Service = ({ title, value, status }) => (
  <div className={`service ${status ? 'green' : 'red'}`}> 
    <span><i className={`fas ${status ? 'fa-check-circle' : 'fa-times-circle'}`}></i> {title}</span>
    <span>{value}</span>
  </div>
);








 function Sguinup() {
  const navigate = useNavigate();

  /* ---------------- حالة الحقول ---------------- */
  const [phoneNumber, setPhoneNumber]   = useState("");
 
  const [name, setName]                 = useState("");
  const [email, setEmail]               = useState("");
  const [password, setPassword]         = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError]               = useState("");
  const [message, setMessage]           = useState("");

  /* ---------------- معالجة الإرسال ---------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    /* تحقق بسيط */
  
if (!phoneNumber.trim()) {
  setError("يرجى إدخال رقم الهاتف");
  return;
}
// تحقق من أن الرقم يبدأ بـ "+" أو "00"
if (!/^(?:\+|00)\d{6,15}$/.test(phoneNumber)) {
  setError("يرجى إدخال رقم الهاتف بالشكل الدولي الصحيح (مثال: +963xxxxxxxx أو 00963xxxxxxxx)");
  return;
}



    
    if (!name.trim())               return setError("يرجى إدخال الاسم الكامل");
    if (!email.trim())              return setError("يرجى إدخال البريد الإلكتروني");
    if (!/\S+@\S+\.\S+/.test(email)) return setError("صيغة البريد الإلكتروني غير صالحة");
    if (!password.trim())           return setError("يرجى إدخال كلمة المرور");
    if (password.length < 6)        return setError("يجب أن تكون كلمة المرور 6 أحرف على الأقل");
    if (password !== confirmPassword) return setError("كلمة المرور وتأكيدها غير متطابقين");

    setError(""); setMessage("");

    try {
      const res = await fetch("https://mcrm.com.tr/api.php?register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phoneNumber, name, email, password }),
      });

      const data = await res.json();
      if (data.success) {
        setMessage(data.message || "تم إنشاء الحساب بنجاح! يمكنك الآن تسجيل الدخول.");
        /* تفريغ الحقول */
        setPhoneNumber("");  setName("");
        setEmail(""); setPassword(""); setConfirmPassword("");
         navigate("/signup-success"); 
      } else {
        setError(data.message || "فشل في إنشاء الحساب. يرجى المحاولة مرة أخرى.");
      }
    } catch (err) {
      setError("حدث خطأ في الاتصال بالخادم، يرجى التحقق من الإنترنت.");
      console.error(err);
    }
  };

  /* ---------------- JSX ---------------- */
  return (
    <div className="signup-container">
      <div className="signup-card">
        {/* رأس منحنٍ جذّاب */}
        <header className="signup-header">
          <h2 className="signup-title">إنشاء حساب جديد</h2>
        </header>

        {/* نموذج التسجيل */}
        <form onSubmit={handleSubmit} style={{ padding: "0 28px 32px" }}>
          {/* الهاتف */}
          <div className="form-group">
            <label htmlFor="phoneNumber" className="form-label">اسم المستخدم</label>
            <div className="input-wrapper">
              <input
                id="phoneNumber"
                className="form-input"
                type="text"
                placeholder="ادخل اسم المستخدم باللغة الانكليزية"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
              <i className="fas fa-phone-alt input-icon"></i>
            </div>
          </div>

 
          {/* الاسم الكامل */}
          <div className="form-group">
            <label htmlFor="name" className="form-label">الاسم الكامل</label>
            <div className="input-wrapper">
              <input
                id="name"
                className="form-input"
                type="text"
                placeholder="اسمك الكامل"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <i className="fas fa-address-card input-icon"></i>
            </div>
          </div>

          {/* البريد */}
          <div className="form-group">
            <label htmlFor="email" className="form-label">البريد الإلكتروني</label>
            <div className="input-wrapper">
              <input
                id="email"
                className="form-input"
                type="email"
                placeholder="example@domain.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <i className="fas fa-envelope input-icon"></i>
            </div>
          </div>

          {/* كلمة المرور */}
          <div className="form-group">
            <label htmlFor="password" className="form-label">كلمة المرور</label>
            <div className="input-wrapper">
              <input
                id="password"
                className="form-input"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i className="fas fa-lock input-icon"></i>
            </div>
          </div>

          {/* تأكيد كلمة المرور */}
          <div className="form-group">
            <label htmlFor="confirmPassword" className="form-label">تأكيد كلمة المرور</label>
            <div className="input-wrapper">
              <input
                id="confirmPassword"
                className="form-input"
                type="password"
                placeholder="********"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <i className="fas fa-lock input-icon"></i>
            </div>
          </div>

          {/* رسائل الحالة */}
          {error   && <p className="error-message">{error}</p>}
          {message && <p className="success-message">{message}</p>}

          {/* زر الإرسال */}
          <button className="submit-button" type="submit">إنشاء حساب</button>

          {/* رابط تسجيل الدخول */}
          <div className="login-link-text">
            لديك حساب بالفعل؟
            <a href="/" className="login-link"> تسجيل الدخول</a>
          </div>
        </form>
      </div>
    </div>
  );
}



function SignupSuccess() {
  return (
    <div className="success-container">
      <div className="success-box">
        <h1>🎉 تم إنشاء حسابك بنجاح</h1>
        <p>يمكنك الآن تسجيل الدخول إلى حسابك.</p>
        <Link to="/" className="login-linkx">
          اضغط هنا لتسجيل الدخول
        </Link>
      </div>
    </div>
  );

}



function LoginForm() {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  // استرجاع البيانات عند تحميل الصفحة
  useEffect(() => {

const savedPhone = localStorage.getItem('phoneNumber') || sessionStorage.getItem('phoneNumber') || '';
const savedPassword = localStorage.getItem('password') || sessionStorage.getItem('password') || '';
const savedRemember = localStorage.getItem('phoneNumber') !== null; // إذا كانت موجودة في localStorage

setPhoneNumber(savedPhone);
setPassword(savedPassword);
setRememberMe(savedRemember);

  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      setError('يرجى  ادخال اسم المستخدم ');
      return;
    }
    if (!password.trim()) {
      setError('يرجى إدخال كلمة المرور');
      return;
    }

    setError('');

    fetch('https://mcrm.com.tr/apilogin.php?login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber, password }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          const storage = rememberMe ? localStorage : sessionStorage;

          localStorage.setItem('authToken', data.token);
          storage.setItem('username', data.username);
          storage.setItem('accountNumber', data.accountNumber);
          storage.setItem('accountname', data.name);
           storage.setItem('userAvatar', data.icon);
          localStorage.setItem('loggedIn', 'true');

          // حفظ رقم الهاتف وكلمة المرور فقط إذا اخترت تذكرني
          if (rememberMe) {
            storage.setItem('phoneNumber', phoneNumber);
            storage.setItem('password', password);
          } else {
            storage.removeItem('phoneNumber');
            storage.removeItem('password');
          }

          navigate('/home');
        } else {
          setError(data.message || 'خطأ في تسجيل الدخول');
        }
      })
      .catch(() => setError('حدث خطأ في الاتصال بالخادم'));
  };

  return (
    <form onSubmit={handleSubmit} className="login-form-body">
      <div className="mb-3">
        <label htmlFor="phoneNumber" className="form-label">
        اسم المستخدم
        </label>
        <div className="form-control-icon">
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
           placeholder="ادخل اسم المستخدم هنا.." 
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <i className="fas fa-phone-alt input-icon"></i>
        </div>
      </div>

      <div className="mb-3" dir="rtl">
        <label htmlFor="password" className="form-label">كلمة المرور</label>
        <div className="position-relative">
          <i
            className="fas fa-lock"
            style={{
              position: 'absolute',
              top: '50%',
              right: '10px',
              transform: 'translateY(-50%)',
              color: '#999',
              pointerEvents: 'none'
            }}
          ></i>

          <input
            type={showPassword ? 'text' : 'password'}
            className="form-control pe-5 ps-5"
            id="password"
            placeholder="********"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            dir="rtl"
          />

          <i
            className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
            style={{
              position: 'absolute',
              top: '50%',
              left: '10px',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#999'
            }}
            onClick={() => setShowPassword(!showPassword)}
          ></i>
        </div>
      </div>

      <div className="row align-items-center mb-4">
        <div className="col-auto">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="rememberMe"
              checked={rememberMe}
              onChange={() => setRememberMe(!rememberMe)}
            />
            <label className="form-check-label" htmlFor="rememberMe">
              تذكرني
            </label>
          </div>
        </div>
        <div className="col-auto">
          <a href="/pass" className="forgot-password-link">
            نسيت كلمة المرور؟
          </a>
        </div>
      </div>

      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

      <button type="submit" className="btn btn-primary">
        تسجيل الدخول
      </button>

      <div className="create-account-link">
        <p>
          إنشاء حساب جديد <a href="/sguinup">ليس لديك حساب؟</a>
        </p>
      </div>
    </form>
  );
}




function MovementsPage() {
  const { id } = useParams(); // ← معرف العميل إن وجد

  const [movements, setMovements] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [addType, setAddType] = useState(""); // client / expense
  const [editType, setEditType] = useState("");

  const [customerId, setCustomerId] = useState(id || "");
  const [expenseType, setExpenseType] = useState("");
  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");

  const [editId, setEditId] = useState(0);

  const [customers, setCustomers] = useState([]);

  const [filterFrom, setFilterFrom] = useState("");
  const [filterTo, setFilterTo] = useState("");
  const [filterCustomer, setFilterCustomer] = useState(null);
  const [filterName, setFilterName] = useState("");

  const token = localStorage.getItem("authToken");


const [voucherType, setVoucherType] = useState(""); // receipt / payment





  // جلب الحركات والعملاء
  useEffect(() => {
    fetchMovements();
    fetchCustomers();
  }, [id]);

  const fetchMovements = async () => {
    setLoading(true);

    try {
      let url = `https://mcrm.com.tr/api.php?get-movements&token=${token}`;

      if (id) url += `&customer_id=${id}`;

      const res = await fetch(url);
      const result = await res.json();
      if (result.success) setMovements(result.data);
    } catch {
      alert("❌ خطأ أثناء الاتصال بالسيرفر");
    }

    setLoading(false);
  };

  const fetchCustomers = async () => {
    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?get-customers&token=${token}`
      );
      const result = await res.json();
      if (result.success) setCustomers(result.data);
    } catch {}
  };

  // حذف الحركة
  const deleteMovement = async (id) => {
    if (!window.confirm("هل تريد حذف الحركة المالية؟")) return;

    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?delete-movement&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        }
      );

      const result = await res.json();
      if (result.success)
        setMovements((prev) => prev.filter((m) => m.id !== id));
    } catch {
      alert("❌ خطأ أثناء الاتصال بالسيرفر");
    }
  };

  // فتح نافذة إضافة
  const openAdd = () => {
    setShowAdd(true);

    setAddType("");
    setCustomerId(id || "");
    setExpenseType("");
    setAmount("");
    setDescription("");
setVoucherType("");
    if (id) setAddType("client");
  };

  // فتح نافذة التعديل
  const openEdit = (movement) => {
    setShowEdit(true);
    setEditId(movement.id);

    const isClient = movement.inmd > 0;
    setEditType(isClient ? "client" : "expense");

    setCustomerId(movement.customer_id || "");
    setAmount(isClient ? movement.inmd : movement.outd);
    setDescription(movement.description);

    if (!isClient)
      setExpenseType(
        movement.description.startsWith("مصروف")
          ? movement.description.split(":")[1].split("-")[0].trim()
          : ""
      );
  };

  // حفظ الإضافة
 
const saveAdd = async () => {
  const amt = parseFloat(amount) || 0;

  let finalAmountIn = 0;
  let finalAmountOut = 0;

  if (addType === "client") {
    if (voucherType === "receipt") finalAmountIn = amt;
    else if (voucherType === "payment") finalAmountOut = amt;
  } else if (addType === "expense") {
    finalAmountOut = amt; // مصروف يُحسب دائمًا كمبلغ صادر
  }

  const body = {
    type: addType,
    customer_id: addType === "client" ? customerId : 0, // المصروف يمكن وضع customer_id = 0
    expense_type: addType === "expense" ? expenseType : "",
    inmd: finalAmountIn,
    outd: finalAmountOut,
    description: description || "",
  };

  try {
    const res = await fetch(
      `https://mcrm.com.tr/api.php?add-movement&token=${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );

    const result = await res.json();

    if (result.success) {
      alert("✔ تم إضافة الحركة بنجاح");
      setShowAdd(false);
      fetchMovements();
    } else alert("❌ لم يتم الحفظ");
  } catch {
    alert("❌ خطأ أثناء الاتصال بالسيرفر");
  }
};


const downloadPDF = () => {
  const fromUnix = filterFrom
    ? Math.floor(new Date(filterFrom).getTime() / 1000)
    : 0;

  const toUnix = filterTo
    ? Math.floor(new Date(filterTo).getTime() / 1000)
    : Math.floor(Date.now() / 1000);

  const url = `https://mcrm.com.tr/api.php?generate-pdf-statement&token=${token}&customer_id=${id}&from=${fromUnix}&to=${toUnix}`;

  window.open(url, "_blank"); // فتح PDF في نافذة جديدة / التحميل حسب إعدادات المتصفح
};







const sendStatementApi = async () => {
  try {
    const res = await fetch(
      `https://mcrm.com.tr/api.php?send-whatsapp-statement&token=${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          customer_id: id,
          from: filterFrom || null,
          to: filterTo || null
        }),
      }
    );

    const result = await res.json();

    if (result.success) {
      alert("✅ تم إرسال أمر كشف الحساب بنجاح");
    } else {
      alert("❌ فشل إرسال الأمر");
    }
  } catch {
    alert("❌ خطأ أثناء الاتصال بالسيرفر");
  }
};


  // حفظ التعديل
 
const saveEdit = async () => {
  let finalAmountIn = 0;
  let finalAmountOut = 0;

  if (editType === "client") {
    if (voucherType === "receipt") finalAmountIn = parseFloat(amount);
    else if (voucherType === "payment") finalAmountOut = parseFloat(amount);
  }

  const body = {
    id: editId,
    type: editType,
    customer_id: customerId,
    expense_type: expenseType,
    inmd: finalAmountIn,
    outd: finalAmountOut,
    description,
  };

  try {
    const res = await fetch(
      `https://mcrm.com.tr/api.php?edit-movement&token=${token}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      }
    );

    const result = await res.json();

    if (result.success) {
      alert("✔ تم تعديل الحركة بنجاح");
      setShowEdit(false);
      fetchMovements();
    } else alert("❌ لم يتم التعديل");
  } catch {
    alert("❌ خطأ أثناء الاتصال بالسيرفر");
  }
};


  // فلترة الحركات
  const applyFilters = () => {
    const fromUnix = filterFrom
      ? Math.floor(new Date(filterFrom).getTime() / 1000)
      : 0;

    const toUnix = filterTo
      ? Math.floor(new Date(filterTo).getTime() / 1000)
      : Math.floor(Date.now() / 1000);

    let url = `https://mcrm.com.tr/api.php?get-movements&token=${token}&from=${fromUnix}&to=${toUnix}`;

    if (id) url += `&customer_id=${id}`;
    else if (filterCustomer) url += `&customer_id=${filterCustomer.value}`;

    if (filterName) url += `&search_name=${encodeURIComponent(filterName)}`;

    fetchMovements(url);
  };

  // الإحصائيات
  const totalOut = movements.reduce(
    (s, m) => s + parseFloat(m.outd || 0),
    0
  );
  const totalIn = movements.reduce(
    (s, m) => s + parseFloat(m.inmd || 0),
    0
  );
  const balance = totalIn - totalOut;

  if (loading)
    return <p className="text-center py-5">⏳ جاري جلب البيانات...</p>;

  return (
    <div className="container py-4" style={{ direction: "rtl" }}>
      {/* رأس الصفحة */}
      <div className="movement-header d-flex justify-content-between align-items-center mb-3">
        <span className="movement-title h5">
          📑 {id ? `حركات العميل رقم ${id}` : "المعاملات المالية"}
        </span>

      


<button
  className="btn btn-success me-2"
  onClick={() => {
    setAddType("client");
    setCustomerId(id || "");
    setDescription("");
    setVoucherType("receipt"); // سند قبض
    setAmount("");
    setShowAdd(true);
  }}
>
  🧾 سند قبض
</button>

<button
  className="btn btn-danger me-2"
  onClick={() => {
    setAddType("client");
    setCustomerId(id || "");
    setDescription("");
    setVoucherType("payment"); // سند دين
    setAmount("");
    setShowAdd(true);
  }}
>
  💵 سند دين
</button>

{id && (
  <button
    className="btn btn-success me-2"
    onClick={sendStatementApi}
  >
    📤 كشف حساب
  </button>
)}
{id && (
  <button
    className="btn btn-secondary me-2"
    onClick={downloadPDF}
  >
    ⬇ تحميل PDF
  </button>
)}


      </div>

      {/* الفلاتر */}
      {!id && (
        <div className="filters mb-3 d-flex gap-2 flex-wrap align-items-end">
          <div>
            <label>من تاريخ:</label>
            <input
              type="date"
              className="form-control"
              value={filterFrom}
              onChange={(e) => setFilterFrom(e.target.value)}
            />
          </div>

          <div>
            <label>إلى تاريخ:</label>
            <input
              type="date"
              className="form-control"
              value={filterTo}
              onChange={(e) => setFilterTo(e.target.value)}
            />
          </div>

          <div style={{ minWidth: "200px" }}>
            <label>اسم العميل:</label>
            <input
              type="text"
              className="form-control"
              placeholder="ابحث بالاسم..."
              value={filterName}
              onChange={(e) => setFilterName(e.target.value)}
            />
          </div>

          <div style={{ minWidth: "200px" }}>
            <label>اختر العميل:</label>
            <Select
              options={customers.map((c) => ({
                value: c.id,
                label: c.name,
              }))}
              value={filterCustomer}
              onChange={setFilterCustomer}
              placeholder="ابحث عن العميل..."
              isClearable
              isSearchable
            />
          </div>

          <div>
            <button
              className="btn btn-primary mt-2"
              onClick={applyFilters}
            >
              تطبيق الفلاتر 🔍
            </button>
          </div>
        </div>
      )}

      {/* الإحصائيات */}
      <div className="financial-stats mb-3 d-flex gap-3">
        <div className="p-2 bg-light border rounded">
          إجمالي الوارد: <b className="text-success">{totalIn}</b>
        </div>
        <div className="p-2 bg-light border rounded">
          إجمالي الصادر: <b className="text-danger">{totalOut}</b>
        </div>
        <div className="p-2 bg-light border rounded">
          الرصيد: <b>{balance}</b>
        </div>
      </div>

      {/* جدول الكمبيوتر */}
      <div className="d-none d-md-block">
        <table className="table table-striped text-center align-middle">
          <thead>
            <tr>
              <th>#</th>
              <th>التاريخ</th>
              <th>الصادر</th>
              <th>الوارد</th>
              <th>البيان</th>
              <th>الحساب المرتبط</th>

<th>نوع الحركة</th>
<th>نوع المصروف</th>

              <th>تعديل</th>
              <th>حذف</th>
            </tr>
          </thead>

          <tbody>
            {movements.map((m, index) => (
              <tr key={m.id}>
                <td>{index + 1}</td>
                <td>{m.date}</td>
                <td className="text-danger">{m.outd}</td>
                <td className="text-success">{m.inmd}</td>
                <td>{m.description}</td>
                <td>{m.customer_name}</td>


<td>
  {m.type === "client" ? "عميل" : "مصروف"}
</td>

<td>
  {m.type === "expense" ? m.expense_type : "-"}
</td>


                <td>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={() => openEdit(m)}
                  >
                    تعديل
                  </button>
                </td>

                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteMovement(m.id)}
                  >
                    حذف
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* نسخة الموبايل */}
      <div className="d-block d-md-none">
        {movements.map((m, index) => (
          <div key={m.id} className="card mb-2 p-2">
            <p>
              <b>#{index + 1}</b> التاريخ: {m.date}
            </p>

            <p>
              الصادر: <span className="text-danger">{m.outd}</span>
            </p>

            <p>
              الوارد: <span className="text-success">{m.inmd}</span>
            </p>

            <p>البيان: {m.description}</p>

            <p>الحساب المرتبط: {m.customer_name}</p>

<p>نوع الحركة: {m.type === "client" ? "عميل" : "مصروف"}</p>
<p>نوع المصروف: {m.type === "expense" ? m.expense_type : "-"}</p>



            <div className="d-flex gap-2">
              <button
                className="btn btn-warning btn-sm flex-fill"
                onClick={() => openEdit(m)}
              >
                تعديل ✏
              </button>

              <button
                className="btn btn-danger btn-sm flex-fill"
                onClick={() => deleteMovement(m.id)}
              >
                حذف 🗑
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* نافذة الإضافة والتعديل */}
      {(showAdd || showEdit) && (
        <div
          className="modal-overlay position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{ background: "rgba(0,0,0,0.5)", zIndex: 999 }}
        >
          <div
            className="modal-box bg-white p-3 rounded"
            style={{ width: "350px", direction: "rtl" }}
          >
            <h5>
              {showAdd ? "➕ إضافة حركة مالية" : "✏ تعديل حركة مالية"}
            </h5>

            {/* نوع الحركة */}
            <label>نوع الحركة:</label>
            <select
              className="form-control mb-2"
              value={showAdd ? addType : editType}
              onChange={(e) =>
                showAdd
                  ? setAddType(e.target.value)
                  : setEditType(e.target.value)
              }
              disabled={id ? true : false}
            >
              <option value="">اختر النوع</option>
              <option value="client">عميل</option>
              <option value="expense">مصروف</option>
            </select>

            {/* اختيار العميل */}
            {(showAdd ? addType : editType) === "client" && (
              <>
                <label>اختر العميل:</label>
                <Select
                  options={customers.map((c) => ({
                    value: c.id,
                    label: c.name,
                  }))}
                  value={
                    customers.find(
                      (c) => c.id === parseInt(customerId)
                    )
                      ? {
                          value: parseInt(customerId),
                          label: customers.find(
                            (c) => c.id === parseInt(customerId)
                          ).name,
                        }
                      : null
                  }
                  onChange={(selected) =>
                    setCustomerId(selected ? selected.value : "")
                  }
                  placeholder="ابحث عن العميل..."
                  isClearable={!id}
                  isSearchable
                  isDisabled={id ? true : false}
                />
              </>
            )}

            {/* مصروف */}
            {(showAdd ? addType : editType) === "expense" && (
              <>
                <label>نوع المصروف:</label>
                <select
                  className="form-control mb-2"
                  value={expenseType}
                  onChange={(e) => setExpenseType(e.target.value)}
                >
                  <option value="">اختر نوع المصروف</option>
                  <option value="وقود">وقود</option>
                  <option value="رواتب">رواتب</option>
                  <option value="صيانة">صيانة</option>
                        <option value="تجهيزات">تجهيزات</option>
        <option value="باقة الانترنت">باقة انترنت</option>


                  <option value="other">مصروف آخر</option>
                </select>
              </>
            )}


  <>
    <label>نوع السند:</label>
    <select
      className="form-control mb-2"
      value={voucherType}
      onChange={(e) => setVoucherType(e.target.value)}
    >
      <option value="">اختر نوع السند</option>
      <option value="receipt">سند قبض</option>
      <option value="payment">سند دين</option>
    </select>
  </>




            <label>المبلغ:</label>
            <input
              className="form-control mb-2"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />

            <label>البيان:</label>
            <input
              className="form-control mb-3"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />

            <button
              className="btn btn-success w-100 mb-2"
              onClick={showAdd ? saveAdd : saveEdit}
            >
              حفظ ✔
            </button>

            <button
              className="btn btn-secondary w-100"
              onClick={() => {
                setShowAdd(false);
                setShowEdit(false);
              }}
            >
              إغلاق ✖
            </button>
          </div>
        </div>
      )}
    </div>
  );
}





function PasswordResetForm() {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!phoneNumber.trim()) {
      setError('يرجى إدخال اسم المستخدم');
      return;
    }

    setError('');
    setSuccessMessage('');

    // إرسال الطلب إلى API الخاص بالاستعادة
    fetch('https://mcrm.com.tr/api.php?reset_password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSuccessMessage('تم إرسال رابط أو رمز استعادة كلمة المرور بنجاح');
        } else {
          setError(data.message || 'تعذر استعادة كلمة المرور');
        }
      })
      .catch(() => setError('حدث خطأ في الاتصال بالخادم'));
  };

  return (
           <div className="new">
              <div className="login-container">
                <div className="header-section">
                  <div className="profile-icon">
                    <img
    src="images/logo.png"  // ← عدل المسار حسب مكان الشعار
    alt="شعار التطبيق"
    style={{ width: '60px', height: '60px', borderRadius: '50%' }} // ← تعديل الشكل حسب الحاجة
  />
                  </div>
                  <h2>استعادة كلمة المرور</h2>
                  <p>أدخل بياناتك للوصول إلى حسابك</p>
                </div>
    <form onSubmit={handleSubmit} className="login-form-body">
      <div className="mb-3">
        <label htmlFor="phoneNumber" className="form-label">
      اسم المستخدم
        </label>
        <div className="form-control-icon">
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
          placeholder="ادخل اسم المستخدم الخاص بك...." 
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
          />
          <i className="fas fa-phone-alt input-icon"></i>
        </div>
      </div>

      {error && <p style={{ color: 'red' , textAlign: 'center' }}>{error}</p>}
      {successMessage && <p style={{ color: 'green', textAlign: 'center' }}>{successMessage}</p>}

      <button type="submit" className="btn btn-primary">
        استعادة كلمة المرور
      </button>

      <div className="create-account-link mt-3">
        <p>
          العودة إلى <a href="/">تسجيل الدخول</a>
        </p>
      </div>
    </form>
     </div>
      </div>
  );
}





function BroadbandAccounts() {

 const { customerId } = useParams();

  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  const [showRenewForm, setShowRenewForm] = useState(false);
  const [renewType, setRenewType] = useState('');
  const [dayOption, setDayOption] = useState('');
  const [daysToAdd, setDaysToAdd] = useState('');
  const [newExpiry, setNewExpiry] = useState('');
  const [usageOption, setUsageOption] = useState('');
  const [newUsage, setNewUsage] = useState('');
  const [additionalUsage, setAdditionalUsage] = useState('');

const [autoRenew, setAutoRenew] = useState(false);


const [newClientId, setNewClientId] = useState(null); // 🆕 نخزن المعرّف


const [showEditClientModal, setShowEditClientModal] = useState(false);
const [newClientName, setNewClientName] = useState('');
const [clientSuggestionsForEdit, setClientSuggestionsForEdit] = useState([]);

const editClientTimeout = useRef(null);



// أضف هذه الحقول الجديدة:
const [renewPrice, setRenewPrice] = useState('');
const [renewPaidAmount, setRenewPaidAmount] = useState('');


const handleEditClientNameChange = (e) => {
  const value = e.target.value;
  setNewClientName(value);
  setNewClientId(null); // 👈 مهم جداً (اسم جديد)

  if (editClientTimeout.current) {
    clearTimeout(editClientTimeout.current);
  }

  editClientTimeout.current = setTimeout(() => {
    fetchClientSuggestions(value, 'edit');
  }, 300);
};



// 🟢 دالة موحدة لجلب اقتراحات العملاء
const fetchClientSuggestions = async (query, type = 'add') => {
  if (!query.trim()) {
    if (type === 'add') {
      setClientSuggestions([]);
      setIsNewClient(true);
    } else {
      setClientSuggestionsForEdit([]);
    }
    return;
  }

  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch(
      `https://mcrm.com.tr/api.php?checkClient&clientName=${encodeURIComponent(query)}&token=${token}`
    );
    const data = await res.json();

    if (data.suggestions && data.suggestions.length > 0) {
      if (type === 'add') {
        setClientSuggestions(data.suggestions);
        setIsNewClient(false);
      } else {
        setClientSuggestionsForEdit(data.suggestions);
      }
    } else {
      if (type === 'add') {
        setClientSuggestions([]);
        setIsNewClient(true);
      } else {
        setClientSuggestionsForEdit([]);
      }
    }
  } catch (err) {
    console.error("فشل جلب اقتراحات العملاء:", err);
    if (type === 'add') {
      setClientSuggestions([]);
    } else {
      setClientSuggestionsForEdit([]);
    }
  }
};



const handleEditClientClick = (acc) => {
  setSelectedAccount(acc);
  setNewClientName(acc.client);
  setShowEditClientModal(true);
};


const handleSaveClientName = () => {
  const token = localStorage.getItem('authToken');
  fetch(`https://mcrm.com.tr/api.php?updateClientName&token=${token}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      accountId: selectedAccount.id,  // 🆕 معرف الحساب
      newClientName,
      clientId: newClientId           // 🆕 معرف العميل إذا اختاره من القاعدة
    })
  })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        showNotification("تم تعديل اسم العميل بنجاح", "success");
        // إعادة تحميل الحسابات
        
setAccounts(prev =>
  prev.map(acc =>
    acc.id === selectedAccount.id
      ? { ...acc, client: newClientName }
      : acc
  )
);




      } else {
        showNotification(data.message || "فشل تعديل الاسم", "error");
      }
      setShowEditClientModal(false);
    })
    .catch(err => {
      console.error(err);
      showNotification("حدث خطأ أثناء تعديل الاسم", "error");
    });
};





  // حالة الرسائل والسبينر العام
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false);

  // حالات مودال إضافة حساب جديد
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [addAccountStep, setAddAccountStep] = useState(1);
  const [newAccountData, setNewAccountData] = useState({
    clientName: '',
    username: '',
    password: '',
    expiryType: 'days', // 'days' or 'date'
    daysOrDate: '', // number of days or expiry date timestamp
    gigabytes: '',
    price: '',
    profile: ''
  });
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [isNewClient, setIsNewClient] = useState(false); // لتحديد ما إذا كان العميل المُدخل جديداً
  const [allProfiles, setAllProfiles] = useState([]); // لتخزين البروفايلات المحملة

    const [selectedClientId, setSelectedClientId] = useState(null);

const [sessions, setSessions] = useState([]);
const [loadingSessions, setLoadingSessions] = useState(false);


  // حالات التحقق من التوافر لاسم العميل واسم المستخدم
  const [isClientNameAvailable, setIsClientNameAvailable] = useState(true);
  const [clientNameCheckMessage, setClientNameCheckMessage] = useState('');
  const clientCheckTimeout = useRef(null); // Debounce ref for client name

  const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
  const [usernameCheckMessage, setUsernameCheckMessage] = useState('');
  const usernameCheckTimeout = useRef(null); // Debounce ref for username

  // **NEW: State for the filter buttons**
  const [currentFilter, setCurrentFilter] = useState('all'); // 'all', 'endsToday', 'endsTomorrow', 'active', 'inactive'

  // دالة لعرض رسالة تنبيه مؤقتة
  const showNotification = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 5000); // تختفي الرسالة بعد 5 ثوانٍ
  };

  // دالة لجلب البيانات عند تحميل المكون
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setLoading(true); // إظهار تحميل مبدئي لجلب الحسابات

    // جلب الحسابات
    let accountsUrl = `https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`;
       if (customerId) {
          accountsUrl = `https://mcrm.com.tr/api.php?customerAccountspoe&customerId=${customerId}&token=${token}`;
        }
    
    fetch(accountsUrl)



      .then(res => res.json())
      .then(data => {
        setAccounts(data.accounts || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("فشل تحميل الحسابات:", err);
        setLoading(false);
        showNotification("فشل تحميل الحسابات.", "error");
      });

// دالة لجلب اقتراحات العملاء
const fetchClientSuggestions = async (query) => {
  if (!query.trim()) {
    setClientSuggestions([]);
    return;
  }

  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch(
      `https://mcrm.com.tr/api.php?checkClient&clientName=${encodeURIComponent(query)}&token=${token}`
    );
    const data = await res.json();

    if (data.suggestions && data.suggestions.length > 0) {
      setClientSuggestions(data.suggestions);
    } else {
      setClientSuggestions([]);
    }
  } catch (err) {
    console.error("فشل جلب اقتراحات العملاء:", err);
    setClientSuggestions([]);
  }
};

    // جلب البروفايلات لاستخدامها في نموذج إضافة حساب جديد
    fetch(`https://mcrm.com.tr/api.php?getProfiles&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.profiles) {
          setAllProfiles(data.profiles);
        } else {
          console.error("فشل تحميل البروفايلات:", data.message);
        }
      })
      .catch(err => {
        console.error("فشل تحميل البروفايلات:", err);
      });

  }, []); // يتم تشغيله مرة واحدة عند تحميل المكون

  // دوال مساعدة لحساب الاستهلاك
  const parseUsage = (value) => {
    if (!value || (typeof value !== 'string' && typeof value !== 'number')) return 0;
    return parseFloat(value.toString().replace(/[^\d.]/g, '')) || 0;
  };

function getUsagePercent(usage, limit, isRemaining = false) {
  const val = parseUsage(usage);
  const total = parseUsage(limit);
  if (!val || !total) return 0;

  let used = isRemaining ? (total - val) : val;
  return Math.min((used / total) * 100, 100);
}


  function getUsageColor(usage, limit) {
    const percent = getUsagePercent(usage, limit);
    if (percent < 50) return '#28a745';
    if (percent < 80) return '#ffc107';
    return '#dc3545';
  }

  // دالة لمعالجة الإجراءات على الحسابات (تعديل، تجديد، تفعيل، تعطيل، حذف)
  function handleAction(action) {
    if (!selectedAccount || !selectedAccount.id) {
      console.error("لم يتم تحديد الحساب");
      showNotification("الرجاء تحديد حساب للقيام بالإجراء.", "error");
      return;
    }

    const id = selectedAccount.id;
   const token = localStorage.getItem("authToken");
    switch (action) {
      case 'edit':
     
        setShowLoadingSpinner(true);
        fetch(`https://mcrm.com.tr/api.php?getAccount&id=${id}&token=${token}`)
          .then(res => res.json())
          .then(data => {
            setShowLoadingSpinner(false);
            if (data.success) {
              setEditData(data.account);
              setAutoRenew(data.account.auto_renew == 1);
              setIsEditing(true);
            } else {
              showNotification(data.message || "فشل في تحميل بيانات الحساب", "error");
            }
          })
          .catch(err => {
            setShowLoadingSpinner(false);
            console.error("فشل جلب بيانات التعديل:", err);
            showNotification("حدث خطأ أثناء جلب بيانات التعديل.", "error");
          });
        break;



     
 case 'whatsapp':
      setShowLoadingSpinner(true);
      fetch(`https://mcrm.com.tr/api.php?sendWhatsApp&token=${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clientId: id   // 🟢 فقط نرسل معرف العميل
        })
      })
        .then(res => res.json())
        .then(data => {
          setShowLoadingSpinner(false);
          if (data.success) {
            showNotification("تم إرسال الرسالة للعميل عبر واتساب ✅", "success");
          } else {
            showNotification(data.message || "فشل إرسال الرسالة عبر واتساب", "error");
          }
        })
        .catch(err => {
          setShowLoadingSpinner(false);
          console.error("خطأ في إرسال واتساب:", err);
          showNotification("حدث خطأ أثناء الإرسال عبر واتساب", "error");
        });
      break;







case 'sessions':
  setLoadingSessions(true);
  fetch(`https://mcrm.com.tr/api.php?accountSessions&id=${id}&token=${localStorage.getItem("authToken")}`)
    .then(res => res.json())
    .then(data => {
      setLoadingSessions(false);
      if (data.success) {
        setSessions(data.sessions || []);
      } else {
        showNotification("فشل تحميل سجل الجلسات", "error");
      }
    })
    .catch(err => {
      setLoadingSessions(false);
      console.error("خطأ بجلب الجلسات:", err);
      showNotification("حدث خطأ أثناء تحميل الجلسات", "error");
    });
  break;




 case 'router':
      if (selectedAccount.routerUrl) {
        // 🟢 فتح الرابط في نافذة جديدة
        window.open(selectedAccount.routerUrl, "_blank");
      } else {
        showNotification("لا يوجد رابط راوتر مسجل لهذا الحساب.", "error");
      }
      break;



      case 'renew':
        setRenewType('');
        setDayOption('');
        setDaysToAdd('');
        setNewExpiry('');
        setUsageOption('');
        setNewUsage('');
        setAdditionalUsage('');
        setIsEditing(false);
        setShowRenewForm(true);
        break;

      case 'enable':
        setShowLoadingSpinner(true);
        // هذا مجرد محاكاة، استبدله باستدعاء API الحقيقي
        setTimeout(() => {
          setShowLoadingSpinner(false);
          showNotification(`تم تفعيل الحساب ID: ${id}`, "success");
          setShowModal(false);
          // تحديث قائمة الحسابات بعد التفعيل (اختياري)
          fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${localStorage.getItem('authToken')}`)
            .then(res => res.json())
            .then(data => setAccounts(data.accounts || []));
        }, 1000);
        break;

      case 'disable':
        setShowLoadingSpinner(true);
        // هذا مجرد محاكاة، استبدله باستدعاء API الحقيقي
        setTimeout(() => {
          setShowLoadingSpinner(false);
          showNotification(`تم تعطيل الحساب ID: ${id}`, "success");
          setShowModal(false);
          // تحديث قائمة الحسابات بعد التعطيل (اختياري)
          fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${localStorage.getItem('authToken')}`)
            .then(res => res.json())
            .then(data => setAccounts(data.accounts || []));
        }, 1000);
        break;

      case 'delete':
        if (window.confirm("هل أنت متأكد من الحذف؟")) {
          setShowLoadingSpinner(true);

          const token = localStorage.getItem('authToken'); // لو كان التوكن مطلوب

          fetch(`https://mcrm.com.tr/api.php?deleteb=${id}&token=${localStorage.getItem('authToken')}`, {
            method: 'POST', // أو 'POST' إذا كانت API لا تدعم DELETE
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` // إذا كان التوكن مطلوبًا
            }
          })
            .then(response => response.json())
            .then(data => {
              setShowLoadingSpinner(false);
              if (data.success) {
                showNotification(`تم حذف الحساب ID: ${id}`, "success");
                setShowModal(false);
                setAccounts(prev => prev.filter(acc => acc.id !== id));
              } else {
                showNotification(`فشل الحذف: ${data.message || 'خطأ غير معروف'}`, "error");
              }
            })
            .catch(error => {
              setShowLoadingSpinner(false);
              showNotification(`حدث خطأ أثناء الحذف: ${error.message}`, "error");
            });
        }

        break;
    }
  }

  // دالة لحفظ تعديلات الحساب
  function handleSaveEdit() {
    const token = localStorage.getItem('authToken');
    setShowLoadingSpinner(true);
    fetch(`https://mcrm.com.tr/api.php?updateAccount&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: selectedAccount.id,
        ...editData,
        auto_renew: autoRenew ? 1 : 0
      })
    })
      .then(res => res.json())
      .then(res => {
        setShowLoadingSpinner(false);
        if (res.success) {
          showNotification(res.message || "تم حفظ التعديلات بنجاح", "success");
        } else {
          showNotification(res.message || "فشل حفظ التعديلات.", "error");
        }
        setShowModal(false);
        setIsEditing(false);
        // إعادة جلب الحسابات لتحديث الواجهة
        fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`)
          .then(res => res.json())
          .then(data => setAccounts(data.accounts || []))
          .catch(err => console.error("فشل تحديث الحسابات بعد التعديل:", err));
      })
      .catch(err => {
        setShowLoadingSpinner(false);
        console.error("فشل التعديل:", err);
        showNotification("حدث خطأ أثناء حفظ التعديلات.", "error");
      });
  }

  // دالة لتجديد الحساب
 
  function handleRenew() {
    const token = localStorage.getItem("authToken");

    const payload = {
        id: selectedAccount.id,
        renewType,
    };

    if (renewType === "days" || renewType === "both") {
        if (dayOption === "setDate") {
            payload.newExpiry = Math.floor(new Date(newExpiry).getTime() / 1000);
            payload.dayOption = "setDate";
        } else if (dayOption === "addDays") {
            payload.daysToAdd = parseInt(daysToAdd);
            payload.dayOption = "addDays";
        }
    }

    if (renewType === "usage" || renewType === "both") {
        if (usageOption === "add") {
            payload.usageOption = "add";
            payload.additionalUsage = parseFloat(additionalUsage);
        } else if (usageOption === "reset") {
            payload.usageOption = "reset";
            payload.newUsage = parseFloat(newUsage);
        }
    }

    // إضافة السعر والمبلغ المدفوع إلى payload
    if (renewPrice) {
        payload.price = parseFloat(renewPrice);
    }
    
    if (renewPaidAmount) {
        payload.paidAmount = parseFloat(renewPaidAmount);
    }

    setShowLoadingSpinner(true);
    fetch("https://mcrm.com.tr/api.php?renewAccount&token=" + token, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((res) => res.json())
        .then((data) => {
            setShowLoadingSpinner(false);
            if (data.success) {
                showNotification(data.message || "تم تجديد الحساب بنجاح", "success");
            } else {
                showNotification(data.message || "فشل تجديد الحساب.", "error");
            }
            setShowModal(false);
            setShowRenewForm(false);
            // إعادة جلب الحسابات لتحديث الواجهة
            fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`)
                .then(res => res.json())
                .then(data => setAccounts(data.accounts || []))
                .catch(err => console.error("فشل تحديث الحسابات بعد التجديد:", err));
        })
        .catch((err) => {
            setShowLoadingSpinner(false);
            console.error("فشل التجديد:", err);
            showNotification("حدث خطأ أثناء التجديد.", "error");
        });
}

  // -----------------------------------------------------------
  // دوال ومراحل إضافة حساب جديد
  // -----------------------------------------------------------

  // دالة لفتح مودال إضافة حساب جديد وإعادة تهيئة الحالات
const handleAddNewAccountClick = () => {
  setShowAddAccountModal(true);
  setAddAccountStep(1);
  setNewAccountData({
    clientName: '',
    username: '',
    password: '',
    expiryType: 'days',
    daysOrDate: '',
    gigabytes: '',
    price: '',
    paidAmount: '',
    profile: ''
  });
  setClientSuggestions([]);
  setSelectedClientId(null);
  setIsNewClient(false);
  setIsClientNameAvailable(true);
  setClientNameCheckMessage('');
  setIsUsernameAvailable(true);
  setUsernameCheckMessage('');
};

  // دالة للتحقق من توافر اسم العميل (مع Debouncing)


const checkClientNameAvailability = async (clientName) => {
  if (!clientName.trim()) {
    setIsClientNameAvailable(true);
    setClientNameCheckMessage('');
    setClientSuggestions([]);
    setIsNewClient(false);
    return;
  }

  setShowLoadingSpinner(true);
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(
      `https://mcrm.com.tr/api.php?checkClient&clientName=${encodeURIComponent(clientName)}&token=${token}`
    );
    const data = await response.json();
    setShowLoadingSpinner(false);

    if (data.exists) {
      setIsClientNameAvailable(true);
      setClientNameCheckMessage(`اسم العميل "${clientName}" موجود بالفعل.`);
      setClientSuggestions([]);
      setIsNewClient(false);
    } else if (data.suggestions && data.suggestions.length > 0) {
      setIsClientNameAvailable(true);
      setClientNameCheckMessage('توجد اقتراحات لعملاء متشابهين.');
      setClientSuggestions(data.suggestions);
      setIsNewClient(false);
    } else {
      setIsClientNameAvailable(true);
      setClientNameCheckMessage('اسم العميل متاح. سيتم إضافته كعميل جديد.');
      setClientSuggestions([]);
      setIsNewClient(true);
    }
  } catch (error) {
    setShowLoadingSpinner(false);
    console.error("فشل التحقق من اسم العميل:", error);
    setClientNameCheckMessage('حدث خطأ أثناء التحقق من اسم العميل.');
    setIsClientNameAvailable(false);
  }
};

  // دالة onChange لمدخل اسم العميل مع Debouncing
const handleClientNameChange = (e) => {
  const name = e.target.value;
  setNewAccountData(prev => ({ ...prev, clientName: name }));
  
  // إعادة تعيين حالة العميل الجديد
  setSelectedClientId(null);

  // استخدام debouncing لمنع استدعاء API كثيراً
  if (clientCheckTimeout.current) {
    clearTimeout(clientCheckTimeout.current);
  }
  
  clientCheckTimeout.current = setTimeout(() => {
    fetchClientSuggestions(name);
  }, 300); // انتظر 300ms قبل البحث
};


  // دالة للتحقق من توافر اسم المستخدم (مع Debouncing)
  const checkUsernameAvailability = async (username) => {
    if (!username.trim()) {
      setIsUsernameAvailable(true);
      setUsernameCheckMessage('');
      return;
    }
    if (/\s/.test(username)) {
      setIsUsernameAvailable(false);
      setUsernameCheckMessage('اسم المستخدم لا يجب أن يحتوي على فراغات.');
      return;
    }

    setShowLoadingSpinner(true);
    try {
      const token = localStorage.getItem('authToken');
      // استدعاء API للتحقق من اسم المستخدم
      const response = await fetch(`https://mcrm.com.tr/api.php?checkUsername&username=${username}&token=${token}`);
      const data = await response.json();
      setShowLoadingSpinner(false);

      if (data.exists) {
        setIsUsernameAvailable(false);
        setUsernameCheckMessage('اسم المستخدم هذا موجود بالفعل.');
      } else {
        setIsUsernameAvailable(true);
        setUsernameCheckMessage('اسم المستخدم متاح.');
      }
    } catch (error) {
      setShowLoadingSpinner(false);
      console.error("فشل التحقق من اسم المستخدم:", error);
      setUsernameCheckMessage('حدث خطأ أثناء التحقق من اسم المستخدم.');
      setIsUsernameAvailable(false);
    }
  };

  const handleUsernameChange = (e) => {
    // حذف المسافات وكل الأحرف غير الإنجليزية أو الأرقام
   const cleanedUsername = e.target.value.replace(/[^A-Za-z0-9.-]/g, '');


    setNewAccountData(prev => ({ ...prev, username: cleanedUsername }));

    if (usernameCheckTimeout.current) {
      clearTimeout(usernameCheckTimeout.current);
    }
    usernameCheckTimeout.current = setTimeout(() => {
      checkUsernameAvailability(cleanedUsername);
    }, 500); // تحقق بعد 500ms من التوقف عن الكتابة
  };

  // دالة للانتقال إلى الخطوة التالية في نموذج إضافة الحساب
  const handleNextStep = async () => {
    if (addAccountStep === 1) { // التحقق لخطوة اسم العميل
      if (!newAccountData.clientName.trim()) {
        showNotification("الرجاء إدخال اسم العميل.", "error");
        return;
      }
      // أعد التحقق النهائي للتأكد من الحالة الأخيرة
      await checkClientNameAvailability(newAccountData.clientName);
      if (!isClientNameAvailable) {
        showNotification(clientNameCheckMessage, "error");
        return;
      }
      // لا حاجة لـ window.confirm هنا، المنطق أعلاه يدير الاختيار
    }
    if (addAccountStep === 2) { // التحقق لخطوة اسم المستخدم
      if (!newAccountData.username.trim()) {
        showNotification("الرجاء إدخال اسم المستخدم.", "error");
        return;
      }
      if (/\s/.test(newAccountData.username)) {
        showNotification("اسم المستخدم لا يجب أن يحتوي على فراغات.", "error");
        return;
      }
      // أعد التحقق النهائي للتأكد من الحالة الأخيرة
      await checkUsernameAvailability(newAccountData.username);
      if (!isUsernameAvailable) {
        showNotification(usernameCheckMessage, "error");
        return;
      }
    }
    if (addAccountStep === 3) { // التحقق لخطوة كلمة المرور
      if (!newAccountData.password.trim()) {
        showNotification("الرجاء إدخال كلمة المرور.", "error");
        return;
      }
    }
    if (addAccountStep === 4) { // التحقق لخطوة الأيام/تاريخ الانتهاء
      if (!newAccountData.daysOrDate) {
        showNotification("الرجاء تحديد الأيام أو تاريخ الانتهاء.", "error");
        return;
      }
      if (newAccountData.expiryType === 'days' && (isNaN(newAccountData.daysOrDate) || parseInt(newAccountData.daysOrDate) <= 0)) {
        showNotification("عدد الأيام يجب أن يكون رقماً صحيحاً وموجباً.", "error");
        return;
      }
    }

    if (addAccountStep === 6) { // التحقق لخطوة السعر
      if (!newAccountData.price || isNaN(newAccountData.price) || parseFloat(newAccountData.price) < 0) {
        showNotification("الرجاء إدخال السعر بشكل صحيح.", "error");
        return;
      }
    }
if (addAccountStep === 7) { // للخطوة 7 (المبلغ المدفوع)
  if (newAccountData.paidAmount && (isNaN(newAccountData.paidAmount) || parseFloat(newAccountData.paidAmount) < 0)) {
    showNotification("المبلغ المدفوع يجب أن يكون رقماً موجباً.", "error");
    return;
  }
}
  if (addAccountStep === 8) { // التحقق لخطوة البروفايل
      if (!newAccountData.profile) {
        showNotification("الرجاء اختيار بروفايل.", "error");
        return;
      }
    }
    setAddAccountStep(prev => prev + 1); // الانتقال إلى الخطوة التالية
  };

  // دالة للعودة إلى الخطوة السابقة في نموذج إضافة الحساب
  const handlePrevStep = () => {
    setAddAccountStep(prev => prev - 1);
  };




  
  // دالة لإرسال بيانات حساب جديد إلى الخادم

const handleAddAccountSubmit = () => {
  const token = localStorage.getItem('authToken');
  setShowLoadingSpinner(true);

  const finalPayload = {
    client: newAccountData.clientName,
    username: newAccountData.username,
    password: newAccountData.password,
    limit: parseFloat(newAccountData.gigabytes),
    price: parseFloat(newAccountData.price),
    profile: newAccountData.profile,
    isNewClient: isNewClient,
    paidAmount: parseFloat(newAccountData.paidAmount) || 0
  };

  // إضافة clientId إذا تم اختيار عميل موجود
  if (selectedClientId && !isNewClient) {
    finalPayload.clientId = selectedClientId;
  }

  if (newAccountData.expiryType === 'days') {
    finalPayload.days = parseInt(newAccountData.daysOrDate);
  } else {
    finalPayload.expiry = Math.floor(new Date(newAccountData.daysOrDate).getTime() / 1000);
  }

  fetch(`https://mcrm.com.tr/api.php?addAccount&token=${token}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(finalPayload)
  })
    .then(res => res.json())
    .then(res => {
      setShowLoadingSpinner(false);
      if (res.success) {
        showNotification(res.message || "تمت إضافة الحساب بنجاح", "success");
        setShowAddAccountModal(false);
        // إعادة تحميل الحسابات
        fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`)
          .then(res => res.json())
          .then(data => setAccounts(data.accounts || []));
      } else {
        showNotification(res.message || "فشل إضافة الحساب.", "error");
      }
    })
    .catch(err => {
      setShowLoadingSpinner(false);
      console.error("فشل الإضافة:", err);
      showNotification("حدث خطأ أثناء إضافة الحساب.", "error");
    });
};
  

  // **NEW: Function to handle filter button clicks**
  const handleFilterChange = (filterType) => {
    setCurrentFilter(filterType);
  };

  // -----------------------------------------------------------
  // جزء JSX (العرض المرئي) للمكون
  // -----------------------------------------------------------

  // رسالة تحميل مبدئية للمكون بأكمله
 if (loading) return <LoadingSpinner text=" جاري تحميل  الحسابات..." />;

  // **UPDATED: Filtering logic to include new filters**
  const filteredAccounts = accounts.filter(acc => {
    // Search filter
    const matchesSearch = acc.client.toLowerCase().includes(search.toLowerCase()) ||
                          acc.username.toLowerCase().includes(search.toLowerCase());

    if (!matchesSearch) return false;

    // Date calculations for filters
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to compare dates only

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    const accountExpiryDate = new Date(acc.expiry * 1000);
    accountExpiryDate.setHours(0, 0, 0, 0);

    // Apply button filters
    switch (currentFilter) {
      case 'all':
        return true;
      case 'endsToday':
        return accountExpiryDate.getTime() === today.getTime();
      case 'endsTomorrow':
        return accountExpiryDate.getTime() === tomorrow.getTime();
      case 'active':
        return acc.status === 'نشط';
      case 'inactive':
        return acc.status === 'غير مفعل';
      default:
        return true;
    }
  });
 
  return (


    
    <div className="broadband-container">
     
     <MessageDisplay message={message} type={messageType} onClose={() => setMessage('')} /> 

      {showLoadingSpinner && <div className="loading-spinner-overlay"><div className="loading-spinner">{/* Your spinner SVG/CSS */}</div><p>جاري المعالجة...</p></div>}

<div  class="vgy">
      {/* حقل البحث */}
      <input
        type="text"
        placeholder="ابحث عن عميل أو اسم مستخدم..."
        className="search-input"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

   {/* زر إضافة حساب جديد */}
      <button className="add-new-account-button" onClick={handleAddNewAccountClick}>
        ➕
      </button>

</div>
      {/* --- Filter Buttons --- */}
      <div className="filter-buttons">
        <button
          className={`filter-button ${currentFilter === 'all' ? 'active-filter' : ''}`}
          onClick={() => handleFilterChange('all')}
        >
          الكل
        </button>
        <button
          className={`filter-button ${currentFilter === 'endsToday' ? 'active-filter' : ''}`}
          onClick={() => handleFilterChange('endsToday')}
        >
          ينتهي اليوم
        </button>
        <button
          className={`filter-button ${currentFilter === 'endsTomorrow' ? 'active-filter' : ''}`}
          onClick={() => handleFilterChange('endsTomorrow')}
        >
          ينتهي غداً
        </button>
        <button
          className={`filter-button ${currentFilter === 'active' ? 'active-filter' : ''}`}
          onClick={() => handleFilterChange('active')}
        >
          نشط
        </button>
        <button
          className={`filter-button ${currentFilter === 'inactive' ? 'active-filter' : ''}`}
          onClick={() => handleFilterChange('inactive')}
        >
          غير مفعل
        </button>
      </div>
      {/* --- End Filter Buttons --- */}
      <hr/> {/* Add a horizontal rule for separation */}


   

      {/* عرض بطاقات الحسابات */}
      {filteredAccounts.map((acc, index) => (
        <div className="account-card" key={index}>
          <div className="row-one">
         <span>
  <strong>👤 العميل:</strong> {acc.client}
    <span
    className="edit-client-icon"
    onClick={() => handleEditClientClick(acc)}
    title="تعديل اسم العميل"
  >
    ✏️
  </span>
</span>

            <span><strong>👨‍💻 المستخدم:</strong> {acc.username}</span>
            <span><strong>📊 الاستخدام:</strong> {acc.usage}</span>
            <span><strong>📅 الأيام:</strong> {acc.days}</span>
          </div>

          <div className="row-two">
            <span><strong>💰 السعر:</strong> {acc.price} ل.س</span>
            <span><strong>⚙️ البروفايل:</strong> {acc.profile}</span>
            <span><strong>⏱ الانتهاء:</strong> {new Date(acc.expiry * 1000).toLocaleDateString()}</span>
            <span>
              <strong>⚡ الحالة:</strong>{' '}
              <span className={`status ${acc.status === 'نشط' ? 'active' : 'inactive'}`}>
                {acc.status}
              </span>
            </span>
          </div>

          <div className="usage-bar-container">
            <div className="usage-labels full">
              <span className="left-label">{acc.limit}</span>
              <span className="center-label">{Math.round(getUsagePercent(acc.usage, acc.limit))}%</span>
              <span className="right-label">{acc.usage || 'غير محدد'}</span>
            </div>
            <div
              className="usage-bar"
              style={{
                width: `${getUsagePercent(acc.usage, acc.limit)}%`,
                backgroundColor: getUsageColor(acc.usage, acc.limit)
              }}
            ></div>
          </div>

          <button
            className="action-button"
            onClick={() => {
              console.log("الحساب المختار:", acc);
              setSelectedAccount(acc);
              setShowModal(true);
              setIsEditing(false);
              setShowRenewForm(false);
            }}
          >
            خيارات
          </button>
        </div>
      ))}

      {filteredAccounts.length === 0 && <div className="no-accounts">لا توجد نتائج مطابقة.</div>}
{showEditClientModal && (
  <div className="modal-overlay">
    <div className="modal-content animated-modal">
      <h4>تعديل اسم العميل</h4>
  
<input
  type="text"
  className="form-control"
  value={newClientName}
 onChange={handleEditClientNameChange}

/>


      {/* هنا ممكن تجيب اقتراحات عملاء من القاعدة وتعرضهم */}
{clientSuggestionsForEdit.length > 0 && (
  <div className="suggestions-list">
    {clientSuggestionsForEdit.map((suggestion, idx) => (
      <div
        key={idx}
        className="suggestion-item"
    onClick={() => {
  setNewClientName(suggestion.name);
  setNewClientId(suggestion.id);
  setClientSuggestionsForEdit([]);
}}

      >
        {suggestion.name || suggestion}
      </div>
    ))}
  </div>
)}


      <div className="modal-footer">
        <button className="btn btn-success" onClick={handleSaveClientName}>
          💾 حفظ
        </button>
        <button className="btn btn-secondary" onClick={() => setShowEditClientModal(false)}>
          ❌ إلغاء
        </button>
      </div>
    </div>
  </div>
)}

      {/* مودال خيارات الحساب (تعديل، تجديد، تفعيل، تعطيل، حذف) */}
      {showModal && selectedAccount && (
        <div className="modal-overlay">
          <div className="modal-content animated-modal">
            <h4>{isEditing ? `تعديل الحساب: ${selectedAccount.username}` : `خيارات الحساب: ${selectedAccount.username}`}</h4>

            {isEditing ? (
              <>
                <div className="form-group">
                  <label>كلمة المرور</label>
                  <input type="text" className="form-control" value={editData.password || ''} onChange={e => setEditData({ ...editData, password: e.target.value })} />
                </div>


                <div className="form-group">
                  <label>تاريخ الانتهاء</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editData.expiry ? new Date(editData.expiry * 1000).toISOString().split('T')[0] : ''}
                    onChange={e => {
                      const ts = Math.floor(new Date(e.target.value).getTime() / 1000);
                      setEditData({ ...editData, expiry: ts });
                    }}
                  />
                </div>

                <div className='mn' >

                  <div className="form-group">
                    <label>الحجم</label>
                    <input type="text" className="form-control" value={editData.quantity || ''} onChange={e => setEditData({ ...editData, quantity: e.target.value })} />
                  </div>


                  <div className="form-group">
                    <label>السعر</label>
                    <input type="number" className="form-control" value={editData.price || ''} onChange={e => setEditData({ ...editData, price: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>البروفايل</label>
                    <select className="form-control" value={editData.profile || ''} onChange={e => setEditData({ ...editData, profile: e.target.value })}>
                      {(editData.profileList || []).map((p, i) => (
                        <option key={i} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                </div>
         

                  <div className='mn' >
                <div className="form-group">
                  <label>الحالة</label>
                  <select
                    className="form-control"
                    value={editData.status || ''}
                    onChange={e => setEditData({ ...editData, status: e.target.value })}
                  >
                    <option value="1">✅ مفعل</option>
                    <option value="0">⛔ معطل</option>
                  </select>
                </div>

<div className="form-group">
  <label>تجديد تلقائي</label>
  <select
    className="form-control"
    value={autoRenew ? "yes" : "no"}
    onChange={e => setAutoRenew(e.target.value === "yes")}
  >
    <option value="yes">نعم</option>
    <option value="no">لا</option>
  </select>
</div>

</div>

                <button className="btn btn-success mt-3" onClick={handleSaveEdit}>💾 حفظ التعديلات</button>

              </>

            ) : showRenewForm ? (
              <>
                <div className="renew-form">
                  <h5>🔄 تجديد الحساب: {selectedAccount.username}</h5>

                  <div className="form-group">
                    <label>نوع التجديد</label>
                    <select className="form-control" value={renewType} onChange={(e) => setRenewType(e.target.value)}>
                      <option value="">-- اختر --</option>
                      <option value="days">تجديد الأيام</option>
                      <option value="usage">تجديد الاستهلاك</option>
                      <option value="both">تجديد الاثنين معاً</option>
                    </select>
                  </div>

                  {(renewType === 'days' || renewType === 'both') && (
                    <>
                      <div className="form-group">
                        <label>تجديد الأيام</label>
                        <select className="form-control" value={dayOption} onChange={(e) => setDayOption(e.target.value)}>
                          <option value="">-- اختر الطريقة --</option>
                          <option value="setDate">تحديد تاريخ الانتهاء</option>
                          <option value="addDays">إضافة عدد أيام</option>
                        </select>
                      </div>

                      {dayOption === 'setDate' && (
                        <div className="form-group">
                          <label>تاريخ الانتهاء الجديد</label>
                          <input type="date" className="form-control" onChange={(e) => setNewExpiry(e.target.value)} />
                        </div>
                      )}

                      {dayOption === 'addDays' && (
                        <div className="form-group">
                          <label>عدد الأيام</label>
                          <input type="number" className="form-control" onChange={(e) => setDaysToAdd(e.target.value)} />
                        </div>
                      )}
                    </>
                  )}

                  {(renewType === 'usage' || renewType === 'both') && (
                    <>
                      <div className="form-group">
                        <label>تجديد الاستهلاك</label>
                        <select className="form-control" value={usageOption} onChange={(e) => setUsageOption(e.target.value)}>
                          <option value="">-- اختر الطريقة --</option>
                          <option value="add">إضافة على الرصيد الحالي</option>
                          <option value="reset">تصفير وتحديد كمية جديدة</option>
                        </select>
                      </div>

                      {usageOption === 'add' && (
                        <div className="form-group">
                          <label>الكمية المضافة</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              onChange={(e) => setAdditionalUsage(e.target.value)}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">GB</span>
                            </div>
                          </div>
                        </div>
                      )}

                      {usageOption === 'reset' && (
                        <div className="form-group">
                          <label>الكمية الجديدة</label>
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              onChange={(e) => setNewUsage(e.target.value)}
                            />
                            <div className="input-group-append">
                              <span className="input-group-text">GB</span>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}



            <div className="form-group">
                <label>سعر التجديد</label>
                <div className="input-group">
                    <input
                        type="number"
                        className="form-control"
                        value={renewPrice}
                        onChange={(e) => setRenewPrice(e.target.value)}
                        min="0"
                        placeholder="أدخل سعر التجديد"
                    />
                   
                </div>
                <small className="text-muted">السعر القديم: {selectedAccount.price}</small>
            </div>

            <div className="form-group">
                <label>المبلغ المدفوع</label>
                <div className="input-group">
                    <input
                        type="number"
                        className="form-control"
                        value={renewPaidAmount}
                        onChange={(e) => setRenewPaidAmount(e.target.value)}
                        min="0"
                        max={renewPrice || ''}
                        placeholder="المبلغ الذي دفعه العميل"
                    />
                   
                </div>
                {renewPrice && renewPaidAmount && (
                    <div className={`alert ${(parseFloat(renewPrice) - (parseFloat(renewPaidAmount) || 0)) > 0 ? 'alert-warning' : 'alert-success'} mt-2 p-2`}>
                        المتبقي: {parseFloat(renewPrice) - (parseFloat(renewPaidAmount) || 0)}
                    </div>
                )}
            </div>





                  <button className="btn btn-primary mt-3" onClick={handleRenew}>💾 تنفيذ التجديد</button>

         <button
    className="close-btn"
    onClick={() => {
        setShowModal(false);
        setIsEditing(false);
        setShowRenewForm(false);
        setRenewType('');
        setDayOption('');
        setUsageOption('');
        setRenewPrice('');
        setRenewPaidAmount('');
    }}
>
    ❌
</button>


                </div>
              </>





            ) : (



              
              <ul className="modal-actions">
                <li onClick={() => handleAction('edit')}><i className="fas fa-pen"></i> تعديل</li>
                <li onClick={() => handleAction('renew')}><i className="fas fa-sync-alt"></i> تجديد</li>


  <li onClick={() => handleAction('router')}>
    <i className="fas fa-network-wired"></i> تحكم بالراوتر
  </li>

 <li onClick={() => handleAction('sessions')}><i className="fas fa-history"></i> سجل الجلسات</li>

<li onClick={() => handleAction('whatsapp')}>
  <i className="fab fa-whatsapp" style={{ color: "green" }}></i> ارسال معلومات الحساب للعميل
</li>


                <li className="delete" onClick={() => handleAction('delete')}><i className="fas fa-trash-alt"></i> حذف</li>
              </ul>
            )}

            <button
              className="close-btn"
              onClick={() => {
                setShowModal(false);
                setIsEditing(false);
                setShowRenewForm(false);
                setRenewType('');
                setDayOption('');
                setUsageOption('');
              }}
            >
              ❌
            </button>
          </div>
        </div>
      )}

{showModal && sessions.length > 0 && (
  <div className="modal-overlay">
    <div className="modal-content animated-modal">
      <h4>📜 سجل الجلسات - {selectedAccount.username}</h4>

      {loadingSessions ? (
        <p>جاري تحميل الجلسات...</p>
      ) : (
        <div className="sessions-scroll">
          <table>
            <thead>
              <tr>
                <th>🕒 التاريخ</th>
              
                <th>📊 الاستهلاك</th>
              </tr>
            </thead>
            <tbody>
              {sessions.map((s, idx) => (
                <tr key={idx}>
                  <td>{s.date}</td>
                
                  <td>{s.usage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="modal-footer">
        <button
          className="btn btn-secondary"
          onClick={() => setSessions([])} // الرجوع لقائمة الخيارات
        >
          🔙 رجوع
        </button>
        <button
          className="btn btn-danger"
          onClick={() => {
            setSessions([]);
            setShowModal(false);
          }}
        >
          ❌ إغلاق
        </button>
      </div>
    </div>
  </div>
)}



      {/* مودال إضافة حساب جديد بنظام المراحل */}
      {showAddAccountModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-modal">
            <h4>إضافة حساب جديد - الخطوة {addAccountStep} من 8</h4>

            {/* Step 1: Client Name */}
   {addAccountStep === 1 && (
  <div className="form-group" style={{ position: 'relative' }}>
    <label>اسم العميل (ابحث أو أدخل اسم جديد)</label>
    
    {/* حقل إدخال اسم العميل */}
    <input
      type="text"
      className="form-control"
      value={newAccountData.clientName}
      onChange={handleClientNameChange}
      placeholder="اكتب للبحث عن عميل موجود..."
      autoFocus
    />
    
    {/* رسالة حالة العميل */}
    {newAccountData.clientName && (
      <div className={`alert ${isNewClient ? 'alert-info' : 'alert-success'} mt-2 p-2`}>
        {isNewClient ? 
          '⚠️ سيتم إضافة هذا العميل كعميل جديد' : 
          '✅ اختر عميلاً من القائمة أو استمر لإضافة عميل جديد'
        }
      </div>
    )}

    {/* قائمة اقتراحات العملاء */}
    {clientSuggestions.length > 0 && (
      <div className="suggestions-dropdown">
        <div className="dropdown-header">
          <small>العملاء المتاحين:</small>
        </div>
        
        {clientSuggestions.map((client, index) => (
          <div
            key={index}
            className="suggestion-item"
            onClick={() => {
              // إذا كان الاقتراح كائن يحتوي على id وname
              if (typeof client === 'object' && client.id && client.name) {
                setNewAccountData(prev => ({ ...prev, clientName: client.name }));
                setSelectedClientId(client.id);
              } else {
                // إذا كان نصاً عادياً
                setNewAccountData(prev => ({ ...prev, clientName: client }));
                setSelectedClientId(null);
              }
              setClientSuggestions([]);
              setIsNewClient(false);
            }}
          >
            {typeof client === 'object' ? client.name : client}
            <span className="badge badge-secondary float-right">
              {typeof client === 'object' ? 'موجود' : 'عميل'}
            </span>
          </div>
        ))}
        
        {/* خيار إضافة عميل جديد حتى مع وجود اقتراحات */}
        <div
          className="suggestion-item new-client"
          onClick={() => {
            setIsNewClient(true);
            setClientSuggestions([]);
          }}
        >
          <strong>➕ إضافة "{newAccountData.clientName}" كعميل جديد</strong>
        </div>
      </div>
    )}
  </div>
)}

            {/* Step 2: Username */}
            {addAccountStep === 2 && (
              <div className="form-group">
                <label>اسم المستخدم (إنجليزية فقط)</label>
                <input
                  type="text"
                  className="form-control"
                  value={newAccountData.username}
                  onChange={handleUsernameChange}
                 pattern="[A-Za-z0-9.-]*"
                  title="يجب أن يحتوي على أحرف إنجليزية وأرقام فقط، بدون مسافات."
                />
                {usernameCheckMessage && (
                  <p className={`message ${isUsernameAvailable ? 'success' : 'error'}`}>
                    {usernameCheckMessage}
                  </p>
                )}
              </div>
            )}

            {/* Step 3: Password */}
            {addAccountStep === 3 && (
              <div className="form-group">
                <label>كلمة المرور</label>
                <input
                  type="text"
                  className="form-control"
                  value={newAccountData.password}
                  onChange={(e) => setNewAccountData(prev => ({ ...prev, password: e.target.value }))}
                />
              </div>
            )}

            {/* Step 4: Expiry (Days or Date) */}
            {addAccountStep === 4 && (
              <>
                <div className="form-group">
                  <label>نوع انتهاء الصلاحية</label>
                  <select
                    className="form-control"
                    value={newAccountData.expiryType}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, expiryType: e.target.value, daysOrDate: '' }))}
                  >
                    <option value="days">عدد الأيام</option>
                    <option value="date">تاريخ محدد</option>
                  </select>
                </div>
                {newAccountData.expiryType === 'days' ? (
                  <div className="form-group">
                    <label>عدد الأيام</label>
                    <input
                      type="number"
                      className="form-control"
                      value={newAccountData.daysOrDate}
                      onChange={(e) => setNewAccountData(prev => ({ ...prev, daysOrDate: e.target.value }))}
                      min="1"
                    />
                  </div>
                ) : (
                  <div className="form-group">
                    <label>تاريخ الانتهاء</label>
                    <input
                      type="date"
                      className="form-control"
                      value={newAccountData.daysOrDate}
                      onChange={(e) => setNewAccountData(prev => ({ ...prev, daysOrDate: e.target.value }))}
                    />
                  </div>
                )}
              </>
            )}

            {/* Step 5: Gigabytes Limit */}
            {addAccountStep === 5 && (
              <div className="form-group">
                <label>حد الاستخدام (جيجابايت)</label>
                <div className="input-group">
                  <input
                    type="number"
                    className="form-control"
                    value={newAccountData.gigabytes}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, gigabytes: e.target.value }))}
                    min="0"
                  />
                  <div className="input-group-append">
                    <span className="input-group-text">GB</span>
                  </div>
                </div>
              </div>
            )}

            {/* Step 6: Price */}
            {addAccountStep === 6 && (
              <div className="form-group">
                <label>السعر</label>
                <input
                  type="number"
                  className="form-control"
                  value={newAccountData.price}
                  onChange={(e) => setNewAccountData(prev => ({ ...prev, price: e.target.value }))}
                  min="0"
                />
              </div>
            )}




{addAccountStep === 7 && (
  <div className="form-group">
    <label>المبلغ المدفوع</label>
    <div className="input-group">
      <input 
        type="number" 
        className="form-control" 
        value={newAccountData.paidAmount} 
        onChange={(e) => setNewAccountData(prev => ({ ...prev, paidAmount: e.target.value }))} 
        min="0" 
        max={newAccountData.price || ''}
        placeholder="المبلغ الذي دفعه العميل"
      />
      <div className="input-group-append"><span className="input-group-text">ل.س</span></div>
    </div>
    {newAccountData.price && newAccountData.paidAmount && (
      <div className={`alert ${(parseFloat(newAccountData.price) - (parseFloat(newAccountData.paidAmount) || 0)) > 0 ? 'alert-warning' : 'alert-success'} mt-2 p-2`}>
        المتبقي: {parseFloat(newAccountData.price) - (parseFloat(newAccountData.paidAmount) || 0)} ل.س
      </div>
    )}
  </div>
)}







            {/* Step 7: Profile */}
            {addAccountStep === 8 && (
              <div className="form-group">
                <label>البروفايل</label>
                <select
                  className="form-control"
                  value={newAccountData.profile}
                  onChange={(e) => setNewAccountData(prev => ({ ...prev, profile: e.target.value }))}
                >
                  <option value="">-- اختر بروفايل --</option>
                  {allProfiles.map((profileName, index) => (
                    <option key={index} value={profileName}>{profileName}</option>
                  ))}
                </select>
              </div>
            )}

            <div className="modal-footer">
              {addAccountStep > 1 && (
                <button className="btn btn-secondary" onClick={handlePrevStep}>السابق</button>
              )}
              {addAccountStep < 8 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>التالي</button>
              ) : (
                <button className="btn btn-success" onClick={handleAddAccountSubmit}>إضافة حساب</button>
              )}
            </div>

            <button className="close-btn" onClick={() => setShowAddAccountModal(false)}>❌</button>
          </div>
        </div>
      )}
    </div>
  );
}










function DeviceConfigPage() {
  const [devices, setDevices] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [loadingToggles, setLoadingToggles] = useState({});
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [editingDeviceId, setEditingDeviceId] = useState(null);
  const [currentEditData, setCurrentEditData] = useState({ name: '', username: '', password: '', port: '' });
  const [showBulkEdit, setShowBulkEdit] = useState(false);
  const [bulkEditData, setBulkEditData] = useState({ username: '', password: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [loadingBulkEdit, setLoadingBulkEdit] = useState(false);
  // إضافة حالتين جديدتين للرسائل
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);

  // دالة لعرض رسالة مؤقتة
  const showMessage = (msg, type = 'success') => {
    setMessage(msg);
    setMessageType(type);
    // إخفاء الرسالة بعد 5 ثوانٍ
    setTimeout(() => {
      setMessage(null);
      setMessageType(null);
    }, 5000);
  };

  const fetchDevices = async () => {
    const token = localStorage.getItem('authToken');
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?devices&token=${token}`);
      const json = await res.json();
      setDevices(json.data || []);
      // لا تعرض رسالة نجاح عند جلب البيانات الأولية إلا إذا كان هناك سبب محدد
    } catch (error) {
      console.error('فشل في جلب التجهيزات:', error);
      setDevices([]);
      showMessage('فشل في جلب التجهيزات. يرجى المحاولة مرة أخرى.', 'error');
    }
  };

  useEffect(() => {
    fetchDevices();
  }, []);

  const toggleMonitoring = async (deviceId, currentStatus) => {
    const token = localStorage.getItem('authToken');
    const newStatus = currentStatus ? 'off' : 'on';

    setLoadingToggles(prev => ({ ...prev, [deviceId]: true }));

    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?setMonitoring&token=${token}&id=${deviceId}&status=${newStatus}`);
      const json = await res.json(); // افترض أن API يعيد استجابة JSON
      if (json.success) {
        setDevices(prev =>
          prev.map(device =>
            device.id === deviceId ? { ...device, monitoring: newStatus === 'on' } : device
          )
        );
        showMessage(`تم تحديث حالة المتابعة للجهاز ${json.deviceName || deviceId} بنجاح.`, 'success');
      } else {
        showMessage(`فشل في تحديث حالة المتابعة للجهاز ${json.deviceName || deviceId}: ${json.message}`, 'error');
      }
    } catch (error) {
      console.error('فشل في تحديث حالة المتابعة:', error);
      showMessage('حدث خطأ أثناء تحديث حالة المتابعة. يرجى التحقق من اتصالك.', 'error');
    }

    setLoadingToggles(prev => ({ ...prev, [deviceId]: false }));
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(prev => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };

  const filteredDevices = devices?.filter(device => {
    const statusMatch = filterStatus === 'all' || device.status === filterStatus;
    const searchMatch = searchTerm === '' ||
      device.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.ip.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.mac.toLowerCase().includes(searchTerm.toLowerCase());
    return statusMatch && searchMatch;
  }) || [];

  const getSortedDevices = () => {
    if (!sortColumn) return filteredDevices;
    return [...filteredDevices].sort((a, b) => {
      let valA = a[sortColumn] ?? '';
      let valB = b[sortColumn] ?? '';
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  };

  const sortedDevices = getSortedDevices();

  const handleEditClick = (device) => {
    setEditingDeviceId(device.id);
    setCurrentEditData({
      name: device.name,
      username: device.username || '',
      password: device.password || '',
      port: device.port || '80',
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setCurrentEditData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveEdit = async () => {
    setLoadingEdit(true);
    const token = localStorage.getItem('authToken');
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?setDeviceDetails&token=${token}&id=${editingDeviceId}&name=${encodeURIComponent(currentEditData.name)}&username=${encodeURIComponent(currentEditData.username)}&password=${encodeURIComponent(currentEditData.password)}&port=${currentEditData.port}`);
      const json = await res.json();
      if (json.success) {
        setDevices(prev =>
          prev.map(device =>
            device.id === editingDeviceId
              ? { ...device, ...currentEditData }
              : device
          )
        );
        setEditingDeviceId(null);
        showMessage(`تم تحديث بيانات الجهاز ${currentEditData.name} بنجاح.`, 'success');
      } else {
        console.error('فشل في تحديث بيانات التجهيز:', json.message);
        showMessage(`فشل في تحديث بيانات التجهيز: ${json.message}`, 'error');
      }
    } catch (error) {
      console.error('خطأ في حفظ التعديلات:', error);
      showMessage('حدث خطأ أثناء حفظ التعديلات.', 'error');
    }
    setLoadingEdit(false);
  };

  const handleBulkEditChange = (e) => {
    const { name, value } = e.target;
    setBulkEditData(prev => ({ ...prev, [name]: value }));
  };

  const handleSaveBulkEdit = async () => {
    setLoadingBulkEdit(true);
    const token = localStorage.getItem('authToken');
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?setBulkCredentials&token=${token}&username=${encodeURIComponent(bulkEditData.username)}&password=${encodeURIComponent(bulkEditData.password)}`);
      const json = await res.json();
      if (json.success) {
        setDevices(prev =>
          prev.map(device => ({
            ...device,
            username: bulkEditData.username,
            password: bulkEditData.password,
          }))
        );
        setShowBulkEdit(false);
        showMessage('تم تحديث بيانات الاعتماد لجميع التجهيزات بنجاح.', 'success');
      } else {
        console.error('فشل في تحديث بيانات الاعتماد بالجملة:', json.message);
        showMessage(`فشل في تحديث بيانات الاعتماد بالجملة: ${json.message}`, 'error');
      }
    } catch (error) {
      console.error('خطأ في حفظ التعديلات بالجملة:', error);
      showMessage('حدث خطأ أثناء حفظ التعديلات بالجملة.', 'error');
    }
    setLoadingBulkEdit(false);
  };


  if (!devices) return <LoadingSpinner text="📡 جاري تحميل التجهيزات..." />;

  return (
    <div className="container py-4" style={{ direction: 'rtl' }}>
      {/* تضمين مكون MessageDisplay في أعلى الصفحة */}
      <MessageDisplay message={message} type={messageType} onClose={() => setMessage(null)} />

      <h2 className="mb-4 text-center text-primary">
        <i className="bi bi-tools me-2"></i>صفحة إدارة التجهيزات
      </h2>

      {/* فلترة حسب الحالة والبحث */}
      <div className="card shadow-sm mb-4 border-0">
        <div className="card-body">
          <div className="row g-3 align-items-center">
            <div className="col-md-auto">
              <label htmlFor="statusFilter" className="form-label fw-bold mb-0">
                <i className="bi bi-funnel-fill me-2"></i>فلترة حسب الحالة:
              </label>
            </div>
            <div className="col-md-3">
              <select
                id="statusFilter"
                className="form-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">الكل</option>
                <option value="online">متصل</option>
                <option value="offline">غير متصل</option>
              </select>
            </div>
            <div className="col-md-auto ms-auto">
              <label htmlFor="searchFilter" className="form-label fw-bold mb-0">
                <i className="bi bi-search me-2"></i>بحث:
              </label>
            </div>
            <div className="col-md-4">
              <input
                type="text"
                id="searchFilter"
                className="form-control"
                placeholder="ابحث بالاسم، IP، أو MAC..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

      {/* زر تعديل الكل */}
      <div className="mb-4 text-center">
        <button
          className="btn btn-info me-2"
          onClick={() => setShowBulkEdit(prev => !prev)}
        >
          <i className="bi bi-pencil-square me-2"></i>
          {showBulkEdit ? 'إخفاء تعديل الكل' : 'تعديل بيانات الاعتماد للكل'}
        </button>
      </div>

      {/* نموذج تعديل الكل (مخفي/يظهر عند الضغط على الزر) */}
      {showBulkEdit && (
        <div className="card shadow-sm mb-4 border-0">
          <div className="card-header bg-info text-white">
            <h5 className="mb-0">تعديل بيانات الاعتماد لجميع التجهيزات</h5>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label htmlFor="bulkUsername" className="form-label">اسم المستخدم:</label>
              <input
                type="text"
                className="form-control"
                id="bulkUsername"
                name="username"
                value={bulkEditData.username}
                onChange={handleBulkEditChange}
              />
            </div>
            <div className="mb-3">
              <label htmlFor="bulkPassword" className="form-label">كلمة المرور:</label>
              <input
                type="password"
                className="form-control"
                id="bulkPassword"
                name="password"
                value={bulkEditData.password}
                onChange={handleBulkEditChange}
              />
            </div>
            <button
              className="btn btn-success"
              onClick={handleSaveBulkEdit}
              disabled={loadingBulkEdit}
            >
              {loadingBulkEdit ? 'جاري الحفظ...' : 'حفظ التغييرات للكل'}
            </button>
            <button
              className="btn btn-secondary ms-2"
              onClick={() => setShowBulkEdit(false)}
            >
              إلغاء
            </button>
          </div>
        </div>
      )}


      {/* جدول التجهيزات على الشاشات الكبيرة */}
      <div className="d-none d-md-block">
        <div className="table-responsive shadow-sm rounded-3 overflow-hidden">
          <table className="table table-hover table-striped text-center align-middle mb-0">
            <thead className="table-dark">
              <tr>
                <th onClick={() => handleSort('name')} style={{ cursor: 'pointer' }}>
                  الاسم {sortColumn === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('type')} style={{ cursor: 'pointer' }}>
                  النوع {sortColumn === 'type' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('ip')} style={{ cursor: 'pointer' }}>
                  IP {sortColumn === 'ip' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('mac')} style={{ cursor: 'pointer' }}>
                  MAC {sortColumn === 'mac' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('uptime')} style={{ cursor: 'pointer' }}>
                  مدة التشغيل {sortColumn === 'uptime' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
                  الحالة {sortColumn === 'status' && (sortDirection === 'asc' ? '▲' : '▼')}
                </th>
                <th>تحكم 80</th>
                <th>تحكم 443</th>
                <th>المتابعة</th>
                <th>تعديل</th>
              </tr>
            </thead>
            <tbody>
              {sortedDevices.length > 0 ? (
                sortedDevices.map(device => (
                  <React.Fragment key={device.id}>
                    <tr>
<td>
  <a href={`/remotdx/${device.id}`} target="_blank" rel="noopener noreferrer">
    {device.name}
  </a>
</td>
                      <td>{device.type === 'mikrotik' ? 'ميكروتك' : 'يوبنتي'}</td>
                      <td>{device.ip}</td>
                      <td>{device.mac}</td>
                      <td>{device.uptime || '--'}</td>
                      <td>
                        <span className={`badge rounded-pill ${device.status === 'online' ? 'bg-success' : 'bg-danger'}`}>
                          {device.status === 'online' ? 'متصل' : 'غير متصل'}
                        </span>
                      </td>
                      <td>
                        <a href={`/remotd/${device.id}/80`} target="_blank" rel="noreferrer" className="btnx btn-sm btn-outline-primary">
                          80
                        </a>
                      </td>
                      <td>
                        <a href={`/remotd/${device.id}/443`} target="_blank" rel="noreferrer" className="btnx btn-sm btn-outline-secondary">
                          443
                        </a>
                      </td>
                      <td>
                        <div className="form-check form-switch d-flex justify-content-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`monitoringSwitch-${device.id}-desktop`}
                            checked={!!device.monitoring}
                            disabled={loadingToggles[device.id]}
                            onChange={() => toggleMonitoring(device.id, device.monitoring)}
                          />
                        </div>
                      </td>
                      <td>
                        <button
                          className="btnx btn-sm btn-warning"
                          onClick={() => handleEditClick(device)}
                        >
                          <i className="bi bi-pencil">🖊</i>
                        </button>
                      </td>
                    </tr>
                    {editingDeviceId === device.id && (
                      <tr>
                        <td colSpan="10">
                          <div className="card bg-light mt-2 mb-2">
                            <div className="card-body">
                              <h6 className="card-title text-start mb-3">تعديل بيانات الجهاز: {device.name}</h6>
                              <div className="row g-3">
                                <div className="col-md-3">
                                  <label htmlFor={`editName-${device.id}`} className="form-label">الاسم</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`editName-${device.id}`}
                                    name="name"
                                    value={currentEditData.name}
                                    onChange={handleEditFormChange}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label htmlFor={`editUsername-${device.id}`} className="form-label">اسم المستخدم</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id={`editUsername-${device.id}`}
                                    name="username"
                                    value={currentEditData.username}
                                    onChange={handleEditFormChange}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label htmlFor={`editPassword-${device.id}`} className="form-label">كلمة المرور</label>
                                  <input
                                    type="password"
                                    className="form-control"
                                    id={`editPassword-${device.id}`}
                                    name="password"
                                    value={currentEditData.password}
                                    onChange={handleEditFormChange}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label htmlFor={`editPort-${device.id}`} className="form-label">البورت</label>
                                  <select
                                    className="form-select"
                                    id={`editPort-${device.id}`}
                                    name="port"
                                    value={currentEditData.port}
                                    onChange={handleEditFormChange}
                                  >
                                    <option value="80">80</option>
                                    <option value="443">443</option>
                                  </select>
                                </div>
                              </div>
                              <div className="d-flex justify-content-end mt-3">
                                <button
                                  className="btn btn-success me-2"
                                  onClick={handleSaveEdit}
                                  disabled={loadingEdit}
                                >
                                  {loadingEdit ? 'جاري الحفظ...' : 'حفظ'}
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setEditingDeviceId(null)}
                                >
                                  إلغاء
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center text-muted py-3">لا توجد نتائج حسب الفلتر المحدد</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* عرض البطاقة على الشاشات الصغيرة (موبايل) */}
      <div className="d-block d-md-none">
        {sortedDevices.length > 0 ? (
          sortedDevices.map(device => (
            <div key={device.id} className="card mb-3 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-primary">{device.name}</h5>
                <p className="mb-2">
                  <strong>النوع:</strong> {device.type === 'mikrotik' ? 'ميكروتك' : 'يوبنتي'}<br />
                  <strong>IP:</strong> {device.ip}<br />
                  <strong>MAC:</strong> {device.mac}<br />
                  <strong>مدة التشغيل:</strong> {device.uptime || '--'}<br />
                  <strong>الحالة:</strong>{" "}
                  <span className={`badge ${device.status === 'online' ? 'bg-success' : 'bg-danger'}`}>
                    {device.status === 'online' ? 'متصل' : 'غير متصل'}
                  </span>
                </p>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <a href={`/remotd/${device.id}/80`} target="_blank" rel="noreferrer" className="btnx btn-sm btn-outline-primary">
                    تحكم 80
                  </a>
                  <a href={`/remotd/${device.id}/443`} target="_blank" rel="noreferrer" className="btnx btn-sm btn-outline-secondary">
                    تحكم 443
                  </a>
                     <a href={`/remotdx/${device.id}`} target="_blank" rel="noreferrer" className="btnx btn-sm btn-outline-secondary">
                   عرض مباشر
                  </a>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id={`monitoringSwitch-${device.id}-mobile`}
                      checked={!!device.monitoring}
                      disabled={loadingToggles[device.id]}
                      onChange={() => toggleMonitoring(device.id, device.monitoring)}
                    />
                  </div>
                </div>
                <button
                  className="btn btn-sm btn-warning w-100"
                  onClick={() => handleEditClick(device)}
                >
                  <i className="bi bi-pencil me-2"></i>تعديل
                </button>

                {editingDeviceId === device.id && (
                  <div className="card bg-light mt-3">
                    <div className="card-body">
                      <h6 className="card-title text-start mb-3">تعديل بيانات الجهاز: {device.name}</h6>
                      <div className="mb-3">
                        <label htmlFor={`editName-mobile-${device.id}`} className="form-label">الاسم</label>
                        <input
                          type="text"
                          className="form-control"
                          id={`editName-mobile-${device.id}`}
                          name="name"
                          value={currentEditData.name}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor={`editUsername-mobile-${device.id}`} className="form-label">اسم المستخدم</label>
                        <input
                          type="text"
                          className="form-control"
                          id={`editUsername-mobile-${device.id}`}
                          name="username"
                          value={currentEditData.username}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor={`editPassword-mobile-${device.id}`} className="form-label">كلمة المرور</label>
                        <input
                          type="password"
                          className="form-control"
                          id={`editPassword-mobile-${device.id}`}
                          name="password"
                          value={currentEditData.password}
                          onChange={handleEditFormChange}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor={`editPort-mobile-${device.id}`} className="form-label">البورت</label>
                        <select
                          className="form-select"
                          id={`editPort-mobile-${device.id}`}
                          name="port"
                          value={currentEditData.port}
                          onChange={handleEditFormChange}
                        >
                          <option value="80">80</option>
                          <option value="443">443</option>
                        </select>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-success me-2"
                          onClick={handleSaveEdit}
                          disabled={loadingEdit}
                        >
                          {loadingEdit ? 'جاري الحفظ...' : 'حفظ'}
                        </button>
                        <button
                          className="btn btn-secondary"
                          onClick={() => setEditingDeviceId(null)}
                        >
                          إلغاء
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <p className="text-center text-muted">لا توجد نتائج حسب الفلتر المحدد</p>
        )}
      </div>
    </div>
  );
}







function DailySalesPage() {
  const [sales, setSales] = useState([]);
  const [fromDate, setFromDate] = useState(() => new Date().toISOString().split("T")[0]);
  const [toDate, setToDate] = useState(() => new Date().toISOString().split("T")[0]);
  const [loading, setLoading] = useState(false);

  const fetchSales = async () => {
    setLoading(true);
    const token = localStorage.getItem('authToken');
    try {
      const response = await fetch(`https://mcrm.com.tr/api.php?sales&from=${fromDate}&to=${toDate}&token=${token}`);
      const json = await response.json();
      setSales(json.data || []);
    } catch (error) {
      console.error('فشل في جلب المبيعات:', error);
      setSales([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSales();
  }, [fromDate, toDate]);

  const total = sales.reduce((acc, item) => acc + Number(item.price), 0);

  return (
    <div className="container py-4" style={{ direction: 'rtl' }}>
      <h3 className="text-center mb-4 text-primary">
        <i className="fas fa-coins me-2"></i> جدول المبيعات اليومية
      </h3>

      {/* فلترة بالتاريخ */}
      <div className="row g-3 mb-4">
        <div className="col-md-5">
          <label className="form-label fw-bold">من تاريخ</label>
          <input
            type="date"
            className="form-control"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </div>
        <div className="col-md-5">
          <label className="form-label fw-bold">إلى تاريخ</label>
          <input
            type="date"
            className="form-control"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button onClick={fetchSales} className="btn btn-primary w-100">
            <i className="fas fa-search me-2"></i> عرض
          </button>
        </div>
      </div>

      {/* عرض جدول على الشاشات الكبيرة */}
   {loading ? (
  <LoadingSpinner text="📦 جاري تحميل البيانات..." />
) : (
        <div className="d-none d-md-block">
          <div className="table-responsive shadow-sm rounded">
            <table className="table table-bordered table-striped text-center align-middle">
              <thead className="table-dark">
                <tr>
                  <th>التاريخ</th>
                  <th>اسم المستخدم</th>
                  <th>النوع</th>
                  <th>السعر</th>
                </tr>
              </thead>
              <tbody>
                {sales.length > 0 ? (
                  sales.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.username}</td>
                      <td>{item.type === 'hotspot' ? 'هوت سبوت' : 'برودباند'}</td>
                      <td>{item.price} ل.س</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-muted">لا توجد مبيعات في هذه الفترة</td>
                  </tr>
                )}
              </tbody>
              {sales.length > 0 && (
                <tfoot>
                  <tr className="fw-bold table-info">
                    <td colSpan="3">الإجمالي</td>
                    <td>{total.toLocaleString()} ل.س</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}

      {/* عرض المبيعات كبطاقات على الموبايل */}
      <div className="d-block d-md-none">
        {sales.length > 0 ? (
          sales.map((item, index) => (
            <div key={index} className="card mb-3 shadow-sm border-start border-4 border-primary">
              <div className="card-body">
                <h5 className="card-title text-primary mb-2">
                  <i className="fas fa-user me-2"></i> {item.username}
                </h5>
                <p className="mb-1"><strong>📅 التاريخ:</strong> {item.date}</p>
                <p className="mb-1"><strong>📡 النوع:</strong> {item.type === 'hotspot' ? 'هوت سبوت' : 'برودباند'}</p>
                <p className="mb-0"><strong>💰 السعر:</strong> {item.price} ل.س</p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted text-center">لا توجد مبيعات في هذه الفترة</p>
        )}

        {/* الإجمالي للموبايل */}
        {sales.length > 0 && (
          <div className="card mt-3 shadow-sm border-2 border-success">
            <div className="card-body text-center fw-bold text-success fs-5">
              💵 الإجمالي: {total.toLocaleString()} ل.س
            </div>
          </div>
        )}
      </div>
    </div>
  );
}




function GeneralSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [loadingToggles, setLoadingToggles] = useState({});

  const fetchSettings = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?generalSettings&token=${token}`);
      const json = await res.json();
      setSettings(json.data || []);
    } catch (err) {
      console.error("فشل في جلب الإعدادات:", err);
      setSettings([]);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const toggleSetting = async (settingId, currentStatus) => {
    const token = localStorage.getItem("authToken");
    const newStatus = currentStatus ? 0 : 1;

    setLoadingToggles(prev => ({ ...prev, [settingId]: true }));

    try {
      await fetch(`https://mcrm.com.tr/api.php?toggleSetting&id=${settingId}&status=${newStatus}&token=${token}`);
      setSettings(prev =>
        prev.map(item =>
          item.id === settingId ? { ...item, active: newStatus } : item
        )
      );
    } catch (err) {
      console.error("فشل في تحديث الحالة:", err);
    }

    setLoadingToggles(prev => ({ ...prev, [settingId]: false }));
  };

  if (!settings) return <div className="text-center mt-5">جاري تحميل الإعدادات...</div>;

  return (
    <div className="container py-4" style={{ direction: "rtl" }}>
      <h3 className="text-center text-primary mb-4">
        <i className="bi bi-gear-fill me-2"></i>الإعدادات العامة
      </h3>

      <div className="table-responsive shadow-sm rounded-3">
        <table className="table table-striped text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>الاسم</th>
              <th>التفعيل</th>
            </tr>
          </thead>
          <tbody>
            {settings.length > 0 ? (
              settings.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>
                    <div className="form-check form-switch d-flex justify-content-center">
                      <input
                        className="form-check-input fs-5"
                        type="checkbox"
                        role="switch"
                        id={`settingSwitch-${item.id}`}
                        checked={!!item.active}
                        disabled={loadingToggles[item.id]}
                        onChange={() => toggleSetting(item.id, item.active)}
                      />
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="2" className="text-muted py-3">لا توجد إعدادات متاحة</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}



function EditableSettingsPage() {
  const [settings, setSettings] = useState(null);
  const [message, setMessage] = useState('');
  const [loadingIds, setLoadingIds] = useState({});

  const fetchSettings = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?generalSettingsx&token=${token}`);
      const json = await res.json();
      setSettings(json.data || []);
    } catch (err) {
      console.error("فشل في جلب الإعدادات:", err);
      setSettings([]);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (id, newValue) => {
    setSettings(prev =>
      prev.map(item =>
        item.id === id ? { ...item, value: newValue } : item
      )
    );
  };

  const handleSave = async (id, value) => {
    const token = localStorage.getItem("authToken");

    setLoadingIds(prev => ({ ...prev, [id]: true }));

    try {
      await fetch(`https://mcrm.com.tr/api.php?saveSettingx&id=${id}&value=${encodeURIComponent(value)}&token=${token}`);
      setMessage('✅ تم التعديل بنجاح');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error("فشل في حفظ التعديل:", err);
      setMessage('❌ حدث خطأ أثناء الحفظ');
    }

    setLoadingIds(prev => ({ ...prev, [id]: false }));
  };

  if (!settings) return <div className="text-center mt-5">⏳ جاري تحميل الإعدادات...</div>;

  return (
    <div className="container py-4" style={{ direction: "rtl" }}>
      <h3 className="text-center text-primary mb-4">
        <i className="bi bi-sliders2-vertical me-2"></i>تعديل القيم العامة
      </h3>

      <div className="table-responsive shadow-sm rounded-3">
        <table className="table table-striped text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>الاسم</th>
              <th>القيمة</th>
              <th>حفظ</th>
            </tr>
          </thead>
          <tbody>
            {settings.length > 0 ? (
              settings.map(item => (
                <tr key={item.id}>
                  <td>{item.name}</td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={item.value}
                      onChange={(e) => handleChange(item.id, e.target.value)}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-success"
                      disabled={loadingIds[item.id]}
                      onClick={() => handleSave(item.id, item.value)}
                    >
                      <i className="fas fa-save me-1"></i>
                      {loadingIds[item.id] ? "جاري..." : "حفظ"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-muted py-3">لا توجد إعدادات متاحة</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <MessageDisplay message={message} type="success" onClose={() => setMessage('')} />
    </div>
  );
}




function BackupFilesPage() {
  const [backups, setBackups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBackups = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const res = await fetch(`https://mcrm.com.tr/api.php?getBackups&token=${token}`);
        const json = await res.json();
        setBackups(json.data || []);
      } catch (err) {
        console.error('فشل تحميل النسخ الاحتياطية:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchBackups();
  }, []);

  if (loading) return <LoadingSpinner text="💾 جاري تحميل النسخ الاحتياطية..." />;

  return (
    <div className="container py-4" style={{ direction: 'rtl' }}>
      <h2 className="mb-4 text-center text-primary">
        <i className="bi bi-cloud-download me-2"></i>النسخ الاحتياطية
      </h2>

      {/* Cards on Mobile */}
      <div className="d-block d-md-none">
        {backups.map((file, index) => (
          <div className="card mb-3 shadow-sm" key={index}>
            <div className="card-body">
              <h5 className="card-title">
                <i className="bi bi-file-earmark-text me-2"></i>{file.filename}
              </h5>
              <ul className="list-group list-group-flush mb-3">
                <li className="list-group-item d-flex justify-content-between">
                  <strong>تاريخ الإنشاء:</strong> <span>{file.date}</span>
                </li>
                <li className="list-group-item d-flex justify-content-between">
                  <strong>اللاحقة:</strong> <span>{file.extension}</span>
                </li>
              </ul>
              <a href={file.url} download className="btn btn-outline-success w-100">
                <i className="bi bi-download me-2"></i>تنزيل
              </a>
            </div>
          </div>
        ))}
      </div>

      {/* Table on Desktop */}
      <div className="d-none d-md-block">
        <div className="table-responsive shadow-sm rounded-3 overflow-hidden">
          <table className="table table-striped table-hover text-center align-middle">
            <thead className="table-dark">
              <tr>
                <th>اسم الملف</th>
                <th>تاريخ الإنشاء</th>
                <th>اللاحقة</th>
                <th>تنزيل</th>
              </tr>
            </thead>
            <tbody>
              {backups.map((file, index) => (
                <tr key={index}>
                  <td>{file.filename}</td>
                  <td>{file.date}</td>
                  <td>{file.extension}</td>
                  <td>
                    <a href={file.url} download className="btn btn-sm btn-outline-success">
                      <i className="bi bi-download"></i>
                    </a>
                  </td>
                </tr>
              ))}
              {backups.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-muted py-3">لا توجد نسخ احتياطية</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}



function HotspotAccounts() {

 const { customerId } = useParams();

  const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [selectedAccount, setSelectedAccount] = useState(null); // للحساب المختار في مودال الخيارات
  const [showModal, setShowModal] = useState(false); // للتحكم في مودال الخيارات (تعديل، تجديد، حذف)
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({});

  const [showRenewForm, setShowRenewForm] = useState(false);
  const [renewType, setRenewType] = useState('');
  const [dayOption, setDayOption] = useState('');
  const [daysToAdd, setDaysToAdd] = useState('');
  const [newExpiry, setNewExpiry] = useState('');
  const [usageOption, setUsageOption] = useState('');
  const [newUsage, setNewUsage] = useState('');
  const [additionalUsage, setAdditionalUsage] = useState('');

  // حالات الرسائل والسبينر العام
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showLoadingSpinner, setShowLoadingSpinner] = useState(false); // هذه هي الحالة الرئيسية للسبينر

const [renewPrice, setRenewPrice] = useState('');
const [renewPaidAmount, setRenewPaidAmount] = useState('');



  // حالات مودال إضافة حساب جديد
  const [showAddAccountModal, setShowAddAccountModal] = useState(false);
  const [addAccountStep, setAddAccountStep] = useState(1);
  const [newAccountData, setNewAccountData] = useState({
    clientName: '',
    username: '',
    password: '',
    expiryType: 'days', // 'days' or 'date'
    daysOrDate: '', // number of days or expiry date timestamp
    gigabytes: '',
    price: '',
    profile: ''
  });
  const [clientSuggestions, setClientSuggestions] = useState([]);
  const [isNewClient, setIsNewClient] = useState(false); // لتحديد ما إذا كان العميل المُدخل جديداً
  const [allProfiles, setAllProfiles] = useState([]); // لتخزين البروفايلات المحملة

const [selectedClientId, setSelectedClientId] = useState(null);

  // حالات التحقق من التوافر لاسم العميل واسم المستخدم
  const [isClientNameAvailable, setIsClientNameAvailable] = useState(true);
  const [clientNameCheckMessage, setClientNameCheckMessage] = useState('');
  const clientCheckTimeout = useRef(null); // Debounce ref for client name

  const [isUsernameAvailable, setIsUsernameAvailable] = useState(true);
  const [usernameCheckMessage, setUsernameCheckMessage] = useState('');
  const usernameCheckTimeout = useRef(null); // Debounce ref for username

  // حالات جديدة لمودال عرض التفاصيل
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailedAccountData, setDetailedAccountData] = useState(null); // لتخزين البيانات المفصلة للحساب المعروض

// دالة لجلب اقتراحات العملاء (مخصصة لـ Hotspot)
const fetchClientSuggestions = async (query) => {
  if (!query.trim()) {
    setClientSuggestions([]);
    return;
  }

  try {
    const token = localStorage.getItem('authToken');
    const res = await fetch(
      `https://mcrm.com.tr/api.php?checkClient&clientName=${encodeURIComponent(query)}&token=${token}`
    );
    const data = await res.json();

    if (data.suggestions && data.suggestions.length > 0) {
      setClientSuggestions(data.suggestions);
    } else {
      setClientSuggestions([]);
    }
  } catch (err) {
    console.error("فشل جلب اقتراحات العملاء:", err);
    setClientSuggestions([]);
  }
};






  // دالة لعرض رسالة تنبيه مؤقتة
  const showNotification = (msg, type) => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => {
      setMessage('');
      setMessageType('');
    }, 5000); // تختفي الرسالة بعد 5 ثوانٍ
  };

  // دالة لجلب البيانات عند تحميل المكون
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    setShowLoadingSpinner(true); // 👈 إظهار السبينر عند بدء التحميل الأولي

    // جلب الحسابات
    const fetchAccounts = fetch(`https://mcrm.com.tr/api.php?hotspotAccounts&token=${token}`)
      .then(res => res.json())
      .then(data => {
        setAccounts(data.accounts || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("فشل تحميل الحسابات:", err);
        showNotification("فشل تحميل الحسابات.", "error");
      });

    // جلب البروفايلات لاستخدامها في نموذج إضافة حساب جديد
    const fetchProfiles = fetch(`https://mcrm.com.tr/api.php?getProfilesh&token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.profiles) {
          setAllProfiles(data.profiles);
        } else {
          console.error("فشل تحميل البروفايلات:", data.message);
        }
      })
      .catch(err => {
        console.error("فشل تحميل البروفايلات:", err);
      });

    // انتظر حتى تكتمل كلا عمليتي الجلب ثم أخفِ السبينر
    Promise.all([fetchAccounts, fetchProfiles])
      .finally(() => {
        setShowLoadingSpinner(false); // 👈 إخفاء السبينر بعد اكتمال جميع عمليات الجلب الأولية
      });

  }, []); // يتم تشغيله مرة واحدة عند تحميل المكون

  // دوال مساعدة لحساب الاستهلاك والأيام
  const parseUsage = (value) => {
    if (!value || (typeof value !== 'string' && typeof value !== 'number')) return 0;
    return parseFloat(value.toString().replace(/[^\d.]/g, '')) || 0;
  };

  function getUsagePercent(usage, limit) {
    const used = parseUsage(usage);
    const total = parseUsage(limit);
    if (!total || total === 0) return 0; // تجنب القسمة على صفر
    return Math.min((used / total) * 100, 100);
  }

  function getUsageColor(usage, limit) {
    const percent = getUsagePercent(usage, limit);
    if (percent < 50) return '#28a745'; // أخضر
    if (percent < 80) return '#ffc107'; // أصفر
    return '#dc3545'; // أحمر
  }

  const calculateDaysRemaining = (expiryTimestamp) => {
    if (!expiryTimestamp) return 'غير محدد';
    const expiryDate = new Date(expiryTimestamp * 1000);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // تطبيع تاريخ اليوم لبداية اليوم
    expiryDate.setHours(0, 0, 0, 0); // تطبيع تاريخ الانتهاء لبداية اليوم

    const diffTime = expiryDate.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `${diffDays} يوم متبقي`;
    } else if (diffDays === 0) {
      return 'ينتهي اليوم';
    } else {
      return `${Math.abs(diffDays)} يوم منتهي`;
    }
  };

const getFormattedDate = (timestamp) => {
  if (!timestamp) return 'غير متوفر';

  const date = new Date(timestamp * 1000);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


  // دالة لمعالجة الإجراءات على الحسابات (تعديل، تجديد، تفعيل، تعطيل، حذف)
  function handleAction(action) {
    if (!selectedAccount || !selectedAccount.id) {
      console.error("لم يتم تحديد الحساب");
      showNotification("الرجاء تحديد حساب للقيام بالإجراء.", "error");
      return;
    }

    const id = selectedAccount.id;
    const token = localStorage.getItem("authToken");

    switch (action) {
      case 'edit':
        setShowLoadingSpinner(true);
        fetch(`https://mcrm.com.tr/api.php?getAccounth&id=${id}&token=${token}`)
          .then(res => res.json())
          .then(data => {
            setShowLoadingSpinner(false);
            if (data.success) {
              setEditData(data.account);
              setIsEditing(true);
              setShowRenewForm(false); // إخفاء نموذج التجديد إذا كان ظاهرًا
            } else {
              showNotification(data.message || "فشل في تحميل بيانات الحساب", "error");
            }
          })
          .catch(err => {
            setShowLoadingSpinner(false);
            console.error("فشل جلب بيانات التعديل:", err);
            showNotification("حدث خطأ أثناء جلب بيانات التعديل.", "error");
          });
        break;

      case 'renew':
        setRenewType('');
        setDayOption('');
        setDaysToAdd('');
        setNewExpiry('');
        setUsageOption('');
        setNewUsage('');
        setAdditionalUsage('');
        setIsEditing(false);
        setShowRenewForm(true);
        break;

      case 'enable':
        setShowLoadingSpinner(true);
        fetch(`https://mcrm.com.tr/api.php?enableAccounth=${id}&token=${token}`, {
          method: 'POST',
        })
          .then(response => response.json())
          .then(data => {
            setShowLoadingSpinner(false);
            if (data.success) {
              showNotification(`تم تفعيل الحساب ID: ${id}`, "success");
              setShowModal(false);
              // تحديث قائمة الحسابات
              fetch(`https://mcrm.com.tr/api.php?hotspotAccounts&token=${token}`)
                .then(res => res.json())
                .then(data => setAccounts(data.accounts || []));
            } else {
              showNotification(`فشل التفعيل: ${data.message || 'خطأ غير معروف'}`, "error");
            }
          })
          .catch(error => {
            setShowLoadingSpinner(false);
            showNotification(`حدث خطأ أثناء التفعيل: ${error.message}`, "error");
          });
        break;

      case 'disable':
        setShowLoadingSpinner(true);
        fetch(`https://mcrm.com.tr/api.php?disableAccounth=${id}&token=${token}`, {
          method: 'POST',
        })
          .then(response => response.json())
          .then(data => {
            setShowLoadingSpinner(false);
            if (data.success) {
              showNotification(`تم تعطيل الحساب ID: ${id}`, "success");
              setShowModal(false);
              // تحديث قائمة الحسابات
              fetch(`https://mcrm.com.tr/api.php?hotspotAccounts&token=${token}`)
                .then(res => res.json())
                .then(data => setAccounts(data.accounts || []));
            } else {
              showNotification(`فشل التعطيل: ${data.message || 'خطأ غير معروف'}`, "error");
            }
          })
          .catch(error => {
            setShowLoadingSpinner(false);
            showNotification(`حدث خطأ أثناء التعطيل: ${error.message}`, "error");
          });
        break;

      case 'delete':
        if (window.confirm("هل أنت متأكد من الحذف؟")) {
          setShowLoadingSpinner(true);
          fetch(`https://mcrm.com.tr/api.php?deleteh=${id}&token=${token}`, {
            method: 'POST', // أو 'DELETE' إذا كانت API تدعمها
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}` // إذا كان التوكن مطلوبًا
            }
          })
            .then(response => response.json())
            .then(data => {
              setShowLoadingSpinner(false);
              if (data.success) {
                showNotification(`تم حذف الحساب ID: ${id}`, "success");
                setShowModal(false);
                setAccounts(prev => prev.filter(acc => acc.id !== id));
              } else {
                showNotification(`فشل الحذف: ${data.message || 'خطأ غير معروف'}`, "error");
              }
            })
            .catch(error => {
              setShowLoadingSpinner(false);
              showNotification(`حدث خطأ أثناء الحذف: ${error.message}`, "error");
            });
        }
        break;
    }
  }

  // دالة لحفظ تعديلات الحساب
  function handleSaveEdit() {
    const token = localStorage.getItem('authToken');
    setShowLoadingSpinner(true);
    fetch(`https://mcrm.com.tr/api.php?updateAccounth&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: selectedAccount.id,
        ...editData,
        // تأكد من إرسال expiry كتاريخ Unix timestamp إذا تم تعديله
        expiry: editData.expiry ? Math.floor(new Date(editData.expiry * 1000).getTime() / 1000) : undefined,
        // تأكد من إرسال quantity كـ limit إذا كان هذا هو الاسم المتوقع في الـ API
        limit: editData.quantity ? parseFloat(editData.quantity) : undefined,
      })
    })
      .then(res => res.json())
      .then(res => {
        setShowLoadingSpinner(false);
        if (res.success) {
          showNotification(res.message || "تم حفظ التعديلات بنجاح", "success");
        } else {
          showNotification(res.message || "فشل حفظ التعديلات.", "error");
        }
        setShowModal(false);
        setIsEditing(false);
        // إعادة جلب الحسابات لتحديث الواجهة
        fetch(`https://mcrm.com.tr/api.php?hotspotAccounts&token=${token}`)
          .then(res => res.json())
          .then(data => setAccounts(data.accounts || []))
          .catch(err => console.error("فشل تحديث الحسابات بعد التعديل:", err));
      })
      .catch(err => {
        setShowLoadingSpinner(false);
        console.error("فشل التعديل:", err);
        showNotification("حدث خطأ أثناء حفظ التعديلات.", "error");
      });
  }

  // دالة لتجديد الحساب

function handleRenew() {
    const token = localStorage.getItem("authToken");

    const payload = {
        id: selectedAccount.id,
        renewType,
    };

    if (renewType === "days" || renewType === "both") {
        if (dayOption === "setDate") {
            payload.newExpiry = Math.floor(new Date(newExpiry).getTime() / 1000);
            payload.dayOption = "setDate";
        } else if (dayOption === "addDays") {
            payload.daysToAdd = parseInt(daysToAdd);
            payload.dayOption = "addDays";
        }
    }

    if (renewType === "usage" || renewType === "both") {
        if (usageOption === "add") {
            payload.usageOption = "add";
            payload.additionalUsage = parseFloat(additionalUsage);
        } else if (usageOption === "reset") {
            payload.usageOption = "reset";
            payload.newUsage = parseFloat(newUsage);
        }
    }

    // إضافة السعر والمبلغ المدفوع إلى payload
    if (renewPrice) {
        payload.price = parseFloat(renewPrice);
    }
    
    if (renewPaidAmount) {
        payload.paidAmount = parseFloat(renewPaidAmount);
    }

    setShowLoadingSpinner(true);
    fetch("https://mcrm.com.tr/api.php?renewAccounth&token=" + token, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
    })
        .then((res) => res.json())
        .then((data) => {
            setShowLoadingSpinner(false);
            if (data.success) {
                showNotification(data.message || "تم تجديد الحساب بنجاح", "success");
            } else {
                showNotification(data.message || "فشل تجديد الحساب.", "error");
            }
            setShowModal(false);
            setShowRenewForm(false);
            // إعادة جلب الحسابات لتحديث الواجهة
            fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`)
                .then(res => res.json())
                .then(data => setAccounts(data.accounts || []))
                .catch(err => console.error("فشل تحديث الحسابات بعد التجديد:", err));
        })
        .catch((err) => {
            setShowLoadingSpinner(false);
            console.error("فشل التجديد:", err);
            showNotification("حدث خطأ أثناء التجديد.", "error");
        });
}







  // دالة لفتح مودال عرض التفاصيل
  const handleViewDetails = (account) => {
    const token = localStorage.getItem("authToken");
    setShowLoadingSpinner(true);
    // جلب تفاصيل الحساب الكاملة
    fetch(`https://mcrm.com.tr/api.php?getAccounth&id=${account.id}&token=${token}`)
      .then(res => res.json())
      .then(data => {
        setShowLoadingSpinner(false);
        if (data.success) {
          setDetailedAccountData(data.account);
          setShowDetailsModal(true);
        } else {
          showNotification(data.message || "فشل في تحميل تفاصيل الحساب", "error");
        }
      })
      .catch(err => {
        setShowLoadingSpinner(false);
        console.error("فشل جلب تفاصيل الحساب:", err);
        showNotification("حدث خطأ أثناء جلب تفاصيل الحساب.", "error");
      });
  };

  // -----------------------------------------------------------
  // دوال ومراحل إضافة حساب جديد
  // -----------------------------------------------------------

  // دالة لفتح مودال إضافة حساب جديد وإعادة تهيئة الحالات
  const handleAddNewAccountClick = () => {
    setShowAddAccountModal(true);
    setAddAccountStep(1);
    setNewAccountData({ // إعادة تعيين بيانات النموذج
      clientName: '',
      username: '',
      password: '',
      expiryType: 'days', // 'days' or 'date'
      daysOrDate: '', // number of days or expiry date timestamp
      gigabytes: '',
      price: '',
      paidAmount: '',
      profile: ''
    });
    setClientSuggestions([]);
 setSelectedClientId(null);

    setIsNewClient(false);
    setIsClientNameAvailable(true);
    setClientNameCheckMessage('');
    setIsUsernameAvailable(true);
    setUsernameCheckMessage('');
  };

  // دالة للتحقق من توافر اسم العميل (مع Debouncing)
 

// دالة للتحقق من توافر اسم العميل (مع Debouncing)
const checkClientNameAvailability = async (clientName) => {
  if (!clientName.trim()) {
    setIsClientNameAvailable(true);
    setClientNameCheckMessage('');
    setClientSuggestions([]);
    setIsNewClient(false);
    return;
  }

  setShowLoadingSpinner(true);
  try {
    const token = localStorage.getItem('authToken');
    // استدعاء API للتحقق من العميل
    const response = await fetch(`https://mcrm.com.tr/api.php?checkClient&clientName=${clientName}&token=${token}`);
    const data = await response.json();
    setShowLoadingSpinner(false);

    if (data.exists) {
      setIsClientNameAvailable(true); // متاح للاستخدام لأنه موجود
      setClientNameCheckMessage(`اسم العميل "${clientName}" موجود بالفعل.`);
      setClientSuggestions([]);
      setIsNewClient(false); // ليس عميلاً جديداً
    } else if (data.suggestions && data.suggestions.length > 0) {
      setIsClientNameAvailable(true); // متاح ولكن مع اقتراحات
      setClientNameCheckMessage('عملاء موجودون قد تقصدهم:');
      setClientSuggestions(data.suggestions);
      setIsNewClient(false); // ليس جديداً لأن هناك اقتراحات
    } else {
      setIsClientNameAvailable(true); // متاح ولا توجد اقتراحات
      setClientNameCheckMessage('اسم العميل متاح. سيتم إضافته كعميل جديد.');
      setClientSuggestions([]);
      setIsNewClient(true); // عميل جديد تماماً
    }
  } catch (error) {
    setShowLoadingSpinner(false);
    console.error("فشل التحقق من اسم العميل:", error);
    setClientNameCheckMessage('حدث خطأ أثناء التحقق من اسم العميل.');
    setIsClientNameAvailable(false); // نفترض عدم التوافر في حالة الخطأ
    setClientSuggestions([]);
  }
};




  // دالة onChange لمدخل اسم العميل مع Debouncing
const handleClientNameChange = (e) => {
  const name = e.target.value;
  setNewAccountData(prev => ({ ...prev, clientName: name }));

  // إعادة تعيين حالة العميل الجديد
  setSelectedClientId(null);

  // استخدام debouncing لمنع استدعاء API كثيراً
  if (clientCheckTimeout.current) {
    clearTimeout(clientCheckTimeout.current);
  }
  
  clientCheckTimeout.current = setTimeout(() => {
    fetchClientSuggestions(name);
  }, 300); // انتظر 300ms قبل البحث
};


  // دالة للتحقق من توافر اسم المستخدم (مع Debouncing)
  const checkUsernameAvailability = async (username) => {
    if (!username.trim()) {
      setIsUsernameAvailable(true);
      setUsernameCheckMessage('');
      return;
    }
    if (/\s/.test(username)) {
      setIsUsernameAvailable(false);
      setUsernameCheckMessage('اسم المستخدم لا يجب أن يحتوي على فراغات.');
      return;
    }

    setShowLoadingSpinner(true);
    try {
      const token = localStorage.getItem('authToken');
      // استدعاء API للتحقق من اسم المستخدم
      const response = await fetch(`https://mcrm.com.tr/api.php?checkUsernamehot&username=${username}&token=${token}`);
      const data = await response.json();
      setShowLoadingSpinner(false);

      if (data.exists) {
        setIsUsernameAvailable(false);
        setUsernameCheckMessage('اسم المستخدم هذا موجود بالفعل.');
      } else {
        setIsUsernameAvailable(true);
        setUsernameCheckMessage('اسم المستخدم متاح.');
      }
    } catch (error) {
      setShowLoadingSpinner(false);
      console.error("فشل التحقق من اسم المستخدم:", error);
      setUsernameCheckMessage('حدث خطأ أثناء التحقق من اسم المستخدم.');
      setIsUsernameAvailable(false);
    }
  };

  const handleUsernameChange = (e) => {
    // حذف المسافات وكل الأحرف غير الإنجليزية أو الأرقام
    const cleanedUsername = e.target.value.replace(/[^A-Za-z0-9]/g, '');

    setNewAccountData(prev => ({ ...prev, username: cleanedUsername }));

    if (usernameCheckTimeout.current) {
      clearTimeout(usernameCheckTimeout.current);
    }
    usernameCheckTimeout.current = setTimeout(() => {
      checkUsernameAvailability(cleanedUsername);
    }, 500); // تحقق بعد 500ms من التوقف عن الكتابة
  };

  // دالة للانتقال إلى الخطوة التالية في نموذج إضافة الحساب
  const handleNextStep = async () => {
    if (addAccountStep === 1) { // التحقق لخطوة اسم العميل
      if (!newAccountData.clientName.trim()) {
        showNotification("الرجاء إدخال اسم العميل.", "error");
        return;
      }
      // أعد التحقق النهائي للتأكد من الحالة الأخيرة
      await checkClientNameAvailability(newAccountData.clientName);
      if (!isClientNameAvailable) {
        showNotification(clientNameCheckMessage, "error");
        return;
      }
      // لا حاجة لـ window.confirm هنا، المنطق أعلاه يدير الاختيار
    }
    if (addAccountStep === 2) { // التحقق لخطوة اسم المستخدم
      if (!newAccountData.username.trim()) {
        showNotification("الرجاء إدخال اسم المستخدم.", "error");
        return;
      }
      if (/\s/.test(newAccountData.username)) {
        showNotification("اسم المستخدم لا يجب أن يحتوي على فراغات.", "error");
        return;
      }
      // أعد التحقق النهائي للتأكد من الحالة الأخيرة
      await checkUsernameAvailability(newAccountData.username);
      if (!isUsernameAvailable) {
        showNotification(usernameCheckMessage, "error");
        return;
      }
    }
    if (addAccountStep === 3) { // التحقق لخطوة كلمة المرور
      if (!newAccountData.password.trim()) {
        showNotification("الرجاء إدخال كلمة المرور.", "error");
        return;
      }
    }
    if (addAccountStep === 4) { // التحقق لخطوة الأيام/تاريخ الانتهاء
      if (!newAccountData.daysOrDate) {
        showNotification("الرجاء تحديد الأيام أو تاريخ الانتهاء.", "error");
        return;
      }
      if (newAccountData.expiryType === 'days' && (isNaN(newAccountData.daysOrDate) || parseInt(newAccountData.daysOrDate) <= 0)) {
        showNotification("عدد الأيام يجب أن يكون رقماً صحيحاً وموجباً.", "error");
        return;
      }
    }

    if (addAccountStep === 6) { // التحقق لخطوة السعر
      if (!newAccountData.price || isNaN(newAccountData.price) || parseFloat(newAccountData.price) < 0) {
        showNotification("الرجاء إدخال السعر بشكل صحيح.", "error");
        return;
      }
    }


if (addAccountStep === 7) { // للخطوة 7 (المبلغ المدفوع)
  if (newAccountData.paidAmount && (isNaN(newAccountData.paidAmount) || parseFloat(newAccountData.paidAmount) < 0)) {
    showNotification("المبلغ المدفوع يجب أن يكون رقماً موجباً.", "error");
    return;
  }
}

    if (addAccountStep === 8) { // التحقق لخطوة البروفايل
      if (!newAccountData.profile) {
        showNotification("الرجاء اختيار بروفايل.", "error");
        return;
      }
    }

    setAddAccountStep(prev => prev + 1); // الانتقال إلى الخطوة التالية
  };

  // دالة للعودة إلى الخطوة السابقة في نموذج إضافة الحساب
  const handlePrevStep = () => {
    setAddAccountStep(prev => prev - 1);
  };

  // دالة لإرسال بيانات حساب جديد إلى الخادم
 

// دالة لإرسال بيانات حساب جديد إلى الخادم
const handleAddAccountSubmit = () => {
  const token = localStorage.getItem('authToken');
  setShowLoadingSpinner(true);

  const finalPayload = {
    client: newAccountData.clientName,
    username: newAccountData.username,
    password: newAccountData.password,
    limit: parseFloat(newAccountData.gigabytes),
    price: parseFloat(newAccountData.price),
    profile: newAccountData.profile,
    isNewClient: isNewClient // نمرر ما إذا كان العميل جديداً ليتعامل معه الـ Backend
  };

  // إضافة clientId إذا تم اختيار عميل موجود
  if (selectedClientId && !isNewClient) {
    finalPayload.clientId = selectedClientId;
  }

  if (newAccountData.expiryType === 'days') {
    finalPayload.days = parseInt(newAccountData.daysOrDate);
  } else {
    finalPayload.expiry = Math.floor(new Date(newAccountData.daysOrDate).getTime() / 1000);
  }

  // إضافة المبلغ المدفوع إذا تم إدخاله
  if (newAccountData.paidAmount && parseFloat(newAccountData.paidAmount) > 0) {
    finalPayload.paidAmount = parseFloat(newAccountData.paidAmount);
  }

  fetch(`https://mcrm.com.tr/api.php?addAccounth&token=${token}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(finalPayload)
  })
    .then(res => res.json())
    .then(res => {
      setShowLoadingSpinner(false);
      if (res.success) {
        showNotification(res.message || "تمت إضافة الحساب بنجاح", "success");
        setShowAddAccountModal(false); // إغلاق المودال
        // إعادة جلب الحسابات لتحديث الواجهة
        fetch(`https://mcrm.com.tr/api.php?hotspotAccounts&token=${token}`)
          .then(res => res.json())
          .then(data => setAccounts(data.accounts || []))
          .catch(err => console.error("فشل تحديث الحسابات بعد الإضافة:", err));
      } else {
        showNotification(res.message || "فشل إضافة الحساب.", "error");
      }
    })
    .catch(err => {
      setShowLoadingSpinner(false);
      console.error("فشل الإضافة:", err);
      showNotification("حدث خطأ أثناء إضافة الحساب.", "error");
    });
};



  // -----------------------------------------------------------
  // جزء JSX (العرض المرئي) للمكون
  // -----------------------------------------------------------

  // تصفية الحسابات بناءً على البحث
  const filteredAccounts = accounts.filter(acc =>
    acc.client.toLowerCase().includes(search.toLowerCase()) ||
    acc.username.toLowerCase().includes(search.toLowerCase())
  );


useEffect(() => {
  const token = localStorage.getItem('authToken');

  if (search.trim() !== '' && filteredAccounts.length === 0 && !loading) {
    setShowLoadingSpinner(true);
    fetch(`https://mcrm.com.tr/api.php?advancedSearchHotspot&token=${token}&query=${encodeURIComponent(search)}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && data.accounts) {
          setAccounts(data.accounts);
        } else {
          showNotification(data.message || "لا توجد نتائج في البحث المتقدم.", "error");
        }
      })
      .catch(err => {
        console.error("فشل البحث المتقدم:", err);
        showNotification("حدث خطأ أثناء البحث المتقدم.", "error");
      })
      .finally(() => {
        setShowLoadingSpinner(false);
      });
  }
}, [search, filteredAccounts.length, loading]);

  
  return (
    <div className="broadband-container">
    

     
      <MessageDisplay message={message} type={messageType} onClose={() => setMessage('')} />


   {showLoadingSpinner && <LoadingSpinner text="جاري تحميل الحسابات..." />}
<div  class="vgy">
      {/* حقل البحث */}
      <input
        type="text"
        placeholder="ابحث عن عميل أو اسم مستخدم..."
        className="search-input"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {/* زر إضافة حساب جديد */}
      <button className="add-new-account-button" onClick={handleAddNewAccountClick}>
        ➕
      </button>
</div>
      {/* عرض بطاقات الحسابات */}
      {filteredAccounts.map((acc, index) => (
        <div className="account-card" key={index}>
          <div className="row-one">
            <span><strong>👤 العميل:</strong> {acc.client}</span>
            <span><strong>👨‍💻 المستخدم:</strong> {acc.username}</span>
            <span><strong>📊 الاستخدام:</strong> {acc.usage}</span>
            <span><strong>📅 تاريخ البداية:</strong> {acc.start_date ? getFormattedDate(acc.start_date) : 'غير متوفر'}</span>
            <span><strong>⏱ تاريخ الانتهاء:</strong> {getFormattedDate(acc.expiry)}</span>
            <span><strong>⏳ الأيام:</strong> {calculateDaysRemaining(acc.expiry)}</span>
          </div>



          <div className="card-actionst">
            <button
              className="action-button view-details-button"
              onClick={() => handleViewDetails(acc)}
              title="عرض التفاصيل"
            >
              👁️
            </button>
            <button
              className="action-button options-button"
              onClick={() => {
                setSelectedAccount(acc);
                setShowModal(true);
                setIsEditing(false);
                setShowRenewForm(false);
              }}
              title="خيارات الحساب"
            >
              خيارات
            </button>
          </div>
        </div>
      ))}

      {filteredAccounts.length === 0 && !showLoadingSpinner && <div className="no-accounts">لا توجد نتائج مطابقة.</div>}
      {/* إذا كان السبينر ظاهرًا، فانتظر حتى تختفي قبل عرض رسالة "لا توجد نتائج" */}

      {/* مودال خيارات الحساب (تعديل، تجديد، تفعيل، تعطيل، حذف) */}
      {showModal && selectedAccount && (
        <div className="modal-overlay">
          <div className="modal-content animated-modal">
            <h4>{isEditing ? `تعديل الحساب: ${selectedAccount.username}` : `خيارات الحساب: ${selectedAccount.username}`}</h4>

            {isEditing ? (
              <>
                <div className="form-group">
                  <label>كلمة المرور</label>
                  <input type="text" className="form-control" value={editData.password || ''} onChange={e => setEditData({ ...editData, password: e.target.value })} />
                </div>

                <div className="form-group">
                  <label>تاريخ الانتهاء</label>
                  <input
                    type="date"
                    className="form-control"
                    // تحويل timestamp إلى صيغة YYYY-MM-DD للتاريخ
                    value={editData.expiry ? new Date(editData.expiry * 1000).toISOString().split('T')[0] : ''}
                    onChange={e => {
                      // تحويل التاريخ المدخل إلى Unix timestamp
                      const ts = Math.floor(new Date(e.target.value).getTime() / 1000);
                      setEditData({ ...editData, expiry: ts });
                    }}
                  />
                </div>

                <div className='mn'> {/* تأكد من أن هذا الـ div له تنسيق مناسب */}
                  <div className="form-group">
                    <label>الحجم </label>
                    <input type="text" className="form-control" value={editData.quantity || ''} onChange={e => setEditData({ ...editData, quantity: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>السعر</label>
                    <input type="number" className="form-control" value={editData.price || ''} onChange={e => setEditData({ ...editData, price: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>البروفايل</label>
                    <select className="form-control" value={editData.profile || ''} onChange={e => setEditData({ ...editData, profile: e.target.value })}>
                      {/* استخدم allProfiles بدلاً من editData.profileList إذا كانت البروفايلات محملة عالمياً */}
                      {allProfiles.map((p, i) => (
                        <option key={i} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>رقم الهاتف</label>
                  <input type="tel" className="form-control" value={editData.phone || ''} onChange={e => setEditData({ ...editData, phone: e.target.value })} />
                </div>
                <div className="form-group">
                  <label>الحالة</label>
                  <select
                    className="form-control"
                    value={editData.status || ''}
                    onChange={e => setEditData({ ...editData, status: e.target.value })}
                  >
                    <option value="1">✅ مفعل</option>
                    <option value="0">⛔ معطل</option>
                  </select>
                </div>

                <button className="btn btn-success mt-3" onClick={handleSaveEdit}>💾 حفظ التعديلات</button>
                <button className="btn btn-secondary mt-2" onClick={() => setIsEditing(false)}>🔙 رجوع</button>
              </>

            ) : showRenewForm ? (
              
  <>
        <div className="renew-form">
            <h5>🔄 تجديد الحساب: {selectedAccount.username}</h5>

            <div className="form-group">
                <label>نوع التجديد</label>
                <select className="form-control" value={renewType} onChange={(e) => setRenewType(e.target.value)}>
                    <option value="">-- اختر --</option>
                    <option value="days">تجديد الأيام</option>
                    <option value="usage">تجديد الاستهلاك</option>
                    <option value="both">تجديد الاثنين معاً</option>
                </select>
            </div>

            {(renewType === 'days' || renewType === 'both') && (
                <>
                    <div className="form-group">
                        <label>تجديد الأيام</label>
                        <select className="form-control" value={dayOption} onChange={(e) => setDayOption(e.target.value)}>
                            <option value="">-- اختر الطريقة --</option>
                            <option value="setDate">تحديد تاريخ الانتهاء</option>
                            <option value="addDays">إضافة عدد أيام</option>
                        </select>
                    </div>

                    {dayOption === 'setDate' && (
                        <div className="form-group">
                            <label>تاريخ الانتهاء الجديد</label>
                            <input type="date" className="form-control" onChange={(e) => setNewExpiry(e.target.value)} />
                        </div>
                    )}

                    {dayOption === 'addDays' && (
                        <div className="form-group">
                            <label>عدد الأيام</label>
                            <input type="number" className="form-control" onChange={(e) => setDaysToAdd(e.target.value)} />
                        </div>
                    )}
                </>
            )}

            {(renewType === 'usage' || renewType === 'both') && (
                <>
                    <div className="form-group">
                        <label>تجديد الاستهلاك</label>
                        <select className="form-control" value={usageOption} onChange={(e) => setUsageOption(e.target.value)}>
                            <option value="">-- اختر الطريقة --</option>
                            <option value="add">إضافة على الرصيد الحالي</option>
                            <option value="reset">تصفير وتحديد كمية جديدة</option>
                        </select>
                    </div>

                    {usageOption === 'add' && (
                        <div className="form-group">
                            <label>الكمية المضافة</label>
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control"
                                    onChange={(e) => setAdditionalUsage(e.target.value)}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">GB</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {usageOption === 'reset' && (
                        <div className="form-group">
                            <label>الكمية الجديدة</label>
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control"
                                    onChange={(e) => setNewUsage(e.target.value)}
                                />
                                <div className="input-group-append">
                                    <span className="input-group-text">GB</span>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* إضافة حقلي السعر والمبلغ المدفوع */}
            <div className="form-group">
                <label>سعر التجديد</label>
                <div className="input-group">
                    <input
                        type="number"
                        className="form-control"
                        value={renewPrice}
                        onChange={(e) => setRenewPrice(e.target.value)}
                        min="0"
                        placeholder="أدخل سعر التجديد"
                    />
                    
                </div>
                <small className="text-muted">السعر القديم: {selectedAccount.price} </small>
            </div>

            <div className="form-group">
                <label>المبلغ المدفوع</label>
                <div className="input-group">
                    <input
                        type="number"
                        className="form-control"
                        value={renewPaidAmount}
                        onChange={(e) => setRenewPaidAmount(e.target.value)}
                        min="0"
                        max={renewPrice || ''}
                        placeholder="المبلغ الذي دفعه العميل"
                    />
                
                </div>
                {renewPrice && renewPaidAmount && (
                    <div className={`alert ${(parseFloat(renewPrice) - (parseFloat(renewPaidAmount) || 0)) > 0 ? 'alert-warning' : 'alert-success'} mt-2 p-2`}>
                        المتبقي: {parseFloat(renewPrice) - (parseFloat(renewPaidAmount) || 0)} ل.س
                    </div>
                )}
            </div>

            <button className="btn btn-primary mt-3" onClick={handleRenew}>💾 تنفيذ التجديد</button>

            <button
                className="close-btn"
                onClick={() => {
                    setShowModal(false);
                    setIsEditing(false);
                    setShowRenewForm(false);
                    setRenewType('');
                    setDayOption('');
                    setUsageOption('');
                    setRenewPrice('');
                    setRenewPaidAmount('');
                }}
            >
                ❌
            </button>
        </div>
    </>

            ) : (
              <>
                <button className="btn btn-primary mb-2" onClick={() => handleAction('edit')}>✏️ تعديل</button>
                <button className="btn btn-info mb-2" onClick={() => handleAction('renew')}>🔄 تجديد</button>
            
                <button className="btn btn-danger mb-2" onClick={() => handleAction('delete')}>🗑️ حذف</button>
                <button className="btn btn-secondary mt-3" onClick={() => setShowModal(false)}>إلغاء</button>
              </>
            )}
          </div>
        </div>
      )}

      {/* مودال عرض التفاصيل الكاملة للحساب */}
      {showDetailsModal && detailedAccountData && (
        <div className="modal-overlay">
          <div className="modal-content animated-modal">
            <h4>تفاصيل الحساب: {detailedAccountData.username}</h4>
            <div className="details-grid">
              <div><strong>ID:</strong> {detailedAccountData.id}</div>
              <div><strong>العميل:</strong> {detailedAccountData.client}</div>
              <div><strong>اسم المستخدم:</strong> {detailedAccountData.username}</div>
              <div><strong>كلمة المرور:</strong> {detailedAccountData.password}</div>
              <div><strong>البروفايل:</strong> {detailedAccountData.profile}</div>
              <div><strong>تاريخ البداية:</strong> {detailedAccountData.start_date ? getFormattedDate(detailedAccountData.start_date) : 'غير متوفر'}</div>
              <div><strong>تاريخ الانتهاء:</strong> {getFormattedDate(detailedAccountData.expiry)}</div>
              <div><strong>الأيام المتبقية:</strong> {calculateDaysRemaining(detailedAccountData.expiry)}</div>
              <div><strong>الاستخدام الكلي:</strong> {detailedAccountData.usage}</div>
              <div><strong>حد الاستخدام:</strong> {detailedAccountData.limit}</div>
              <div><strong>التعليقات:</strong> {detailedAccountData.comment || 'لا يوجد'}</div>
              <div><strong>حالة الحساب:</strong> {detailedAccountData.status == '1' ? 'مفعل' : 'معطل'}</div>
              <div><strong>رقم الهاتف:</strong> {detailedAccountData.phone || 'لا يوجد'}</div>
              <div><strong>السعر:</strong> {detailedAccountData.price || 'لا يوجد'}</div>
            </div>
            <button className="btn btn-secondary mt-3" onClick={() => setShowDetailsModal(false)}>إغلاق</button>
          </div>
        </div>
      )}

      {/* مودال إضافة حساب جديد */}
      {showAddAccountModal && (
        <div className="modal-overlay">
          <div className="modal-content animated-modal add-account-modal">
            <h4>إضافة حساب جديد - الخطوة {addAccountStep} من 7</h4>


   {addAccountStep === 1 && (
  <div className="form-group" style={{ position: 'relative' }}>
    <label>اسم العميل (ابحث أو أدخل اسم جديد)</label>
    
    {/* حقل إدخال اسم العميل */}
    <input
      type="text"
      className="form-control"
      value={newAccountData.clientName}
      onChange={handleClientNameChange}
      placeholder="اكتب للبحث عن عميل موجود..."
      autoFocus
    />
    
    {/* رسالة حالة العميل */}
    {newAccountData.clientName && (
      <div className={`alert ${isNewClient ? 'alert-info' : 'alert-success'} mt-2 p-2`}>
        {isNewClient ? 
          '⚠️ سيتم إضافة هذا العميل كعميل جديد' : 
          '✅ اختر عميلاً من القائمة أو استمر لإضافة عميل جديد'
        }
      </div>
    )}

    {/* قائمة اقتراحات العملاء */}
    {clientSuggestions.length > 0 && (
      <div className="suggestions-dropdown">
        <div className="dropdown-header">
          <small>العملاء المتاحين:</small>
        </div>
        
        {clientSuggestions.map((client, index) => (
          <div
            key={index}
            className="suggestion-item"
            onClick={() => {
              // إذا كان الاقتراح كائن يحتوي على id وname
              if (typeof client === 'object' && client.id && client.name) {
                setNewAccountData(prev => ({ ...prev, clientName: client.name }));
                setSelectedClientId(client.id);
              } else {
                // إذا كان نصاً عادياً
                setNewAccountData(prev => ({ ...prev, clientName: client }));
                setSelectedClientId(null);
              }
              setClientSuggestions([]);
              setIsNewClient(false);
            }}
          >
            {typeof client === 'object' ? client.name : client}
            <span className="badge badge-secondary float-right">
              {typeof client === 'object' ? 'موجود' : 'عميل'}
            </span>
          </div>
        ))}
        
        {/* خيار إضافة عميل جديد حتى مع وجود اقتراحات */}
        <div
          className="suggestion-item new-client"
          onClick={() => {
            setIsNewClient(true);
            setClientSuggestions([]);
          }}
        >
          <strong>➕ إضافة "{newAccountData.clientName}" كعميل جديد</strong>
        </div>
      </div>
    )}
  </div>
)}

            {addAccountStep === 2 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>اسم المستخدم:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newAccountData.username}
                    onChange={handleUsernameChange}
                    placeholder="أدخل اسم المستخدم"
                  />
                  {usernameCheckMessage && (
                    <small className={isUsernameAvailable ? "text-success" : "text-danger"}>
                      {usernameCheckMessage}
                    </small>
                  )}
                </div>
              </div>
            )}

            {addAccountStep === 3 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>كلمة المرور:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newAccountData.password}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, password: e.target.value }))}
                    placeholder="أدخل كلمة المرور"
                  />
                </div>
              </div>
            )}

            {addAccountStep === 4 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>نوع انتهاء الصلاحية:</label>
                  <select
                    className="form-control"
                    value={newAccountData.expiryType}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, expiryType: e.target.value, daysOrDate: '' }))}
                  >
                    <option value="days">عدد الأيام</option>
                    <option value="date">تاريخ محدد</option>
                  </select>
                </div>
                <div className="form-group mt-3">
                  <label>{newAccountData.expiryType === 'days' ? 'عدد الأيام:' : 'تاريخ الانتهاء:'}</label>
                  {newAccountData.expiryType === 'days' ? (
                    <input
                      type="number"
                      className="form-control"
                      value={newAccountData.daysOrDate}
                      onChange={(e) => setNewAccountData(prev => ({ ...prev, daysOrDate: e.target.value }))}
                      placeholder="أدخل عدد الأيام"
                    />
                  ) : (
                    <input
                      type="date"
                      className="form-control"
                      value={newAccountData.daysOrDate}
                      onChange={(e) => setNewAccountData(prev => ({ ...prev, daysOrDate: e.target.value }))}
                    />
                  )}
                </div>
              </div>
            )}

            {addAccountStep === 5 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>حد الاستهلاك (جيجابايت):</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={newAccountData.gigabytes}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, gigabytes: e.target.value }))}
                    placeholder="أدخل حد الاستهلاك بالجيجابايت (مثال: 50.00)"
                  />
                </div>
              </div>
            )}

            {addAccountStep === 6 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>السعر:</label>
                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    value={newAccountData.price}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, price: e.target.value }))}
                    placeholder="أدخل سعر الحساب"
                  />
                </div>
              </div>
            )}

{addAccountStep === 7 && (
  <div className="form-group">
    <label>المبلغ المدفوع</label>
    <div className="input-group">
      <input 
        type="number" 
        className="form-control" 
        value={newAccountData.paidAmount} 
        onChange={(e) => setNewAccountData(prev => ({ ...prev, paidAmount: e.target.value }))} 
        min="0" 
        max={newAccountData.price || ''}
        placeholder="المبلغ الذي دفعه العميل"
      />
      <div className="input-group-append"><span className="input-group-text">ل.س</span></div>
    </div>
    {newAccountData.price && newAccountData.paidAmount && (
      <div className={`alert ${(parseFloat(newAccountData.price) - (parseFloat(newAccountData.paidAmount) || 0)) > 0 ? 'alert-warning' : 'alert-success'} mt-2 p-2`}>
        المتبقي: {parseFloat(newAccountData.price) - (parseFloat(newAccountData.paidAmount) || 0)} ل.س
      </div>
    )}
  </div>
)}


            {addAccountStep === 8 && (
              <div className="add-account-step">
                <div className="form-group">
                  <label>البروفايل:</label>
                  <select
                    className="form-control"
                    value={newAccountData.profile}
                    onChange={(e) => setNewAccountData(prev => ({ ...prev, profile: e.target.value }))}
                  >
                    <option value="">اختر بروفايل</option>
                    {allProfiles.map((p, i) => (
                      <option key={i} value={p}>{p}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div className="modal-actions">
              {addAccountStep > 1 && (
                <button className="btn btn-secondary" onClick={handlePrevStep}>السابق</button>
              )}
              {addAccountStep < 8 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>التالي</button>
              ) : (
                <button className="btn btn-success" onClick={handleAddAccountSubmit}>إضافة الحساب</button>
              )}
              <button className="btn btn-danger" onClick={() => setShowAddAccountModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}








function MikroTikProfileManager() {
  const [profiles, setProfiles] = useState([]);
  const [profileName, setProfileName] = useState('');
  const [uploadSpeed, setUploadSpeed] = useState('');
  const [downloadSpeed, setDownloadSpeed] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success'); // success or error
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [currentProfileId, setCurrentProfileId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?getMikroTikProfiles&token=${token}`);
      const data = await response.json();

      if (response.ok && data.profiles) {
        setProfiles(data.profiles);
      } else {
        showMessage(data.error || 'فشل تحميل البروفايلات.', 'error');
        setProfiles([]);
      }
    } catch (err) {
      console.error("خطأ في جلب البروفايلات:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

  const clearForm = () => {
    setProfileName('');
    setUploadSpeed('');
    setDownloadSpeed('');
    setIsEditing(false);
    setCurrentProfileId(null);
    setShowModal(false);
    setMessage('');
  };

  const handleAddEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!profileName || !uploadSpeed || !downloadSpeed) {
      showMessage('يرجى ملء جميع الحقول.', 'error');
      setLoading(false);
      return;
    }

    const profileData = {
      profileName,
      uploadSpeed,
      downloadSpeed,
      id: currentProfileId,
    };

    try {
      const token = localStorage.getItem('authToken');
      const endpoint = isEditing ? `editMikroTikProfile` : `addMikroTikProfile`;
      const response = await fetch(`https://mcrm.com.tr/api.php?${endpoint}&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(profileData),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || `تم ${isEditing ? 'تعديل' : 'إضافة'} البروفايل بنجاح.`, 'success');
        clearForm();
        fetchProfiles();
      } else {
        showMessage(data.error || 'فشل العملية، حاول مجددًا.', 'error');
      }
    } catch (err) {
      console.error("خطأ في العملية:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (profile) => {
    setProfileName(profile.profileName);
    setUploadSpeed(profile.uploadSpeed);
    setDownloadSpeed(profile.downloadSpeed);
    setCurrentProfileId(profile.id);
    setIsEditing(true);
    setShowModal(true);
    setMessage('');
  };

  const handleDeleteClick = async (profileId) => {
    if (!window.confirm('هل أنت متأكد أنك تريد حذف هذا البروفايل؟')) return;

    setLoading(true);
    setMessage('');

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?deleteMikroTikProfile&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: profileId }),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || 'تم حذف البروفايل.', 'success');
        fetchProfiles();
      } else {
        showMessage(data.error || 'فشل حذف البروفايل.', 'error');
      }
    } catch (err) {
      console.error("خطأ في الحذف:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mikrotik-profile-manager-container">
      <h2 className="main-title">إدارة بروفايلات MikroTik</h2>

      <button className="btn btn-primary add-profile-btn" onClick={() => {
        clearForm();
        setIsEditing(false);
        setShowModal(true);
      }}>
        ➕ إضافة بروفايل جديد
      </button>

      {/* ✅ رسالة الخطأ أو النجاح */}
      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage('')}
      />

      <h3 className="section-title">البروفايلات الحالية</h3>

      {/* ✅ سبينر التحميل */}
      {loading ? (
        <LoadingSpinner />
      ) : profiles.length === 0 ? (
        <p className="no-profiles-message">لا توجد بروفايلات.</p>
      ) : (
        <div className="profiles-list">
          {profiles.map((profile) => (
            <div key={profile.id} className="profile-card">
              <p><strong>الاسم:</strong> {profile.profileName}</p>
              <p><strong>الرفع:</strong> {profile.uploadSpeed} | <strong>التحميل:</strong> {profile.downloadSpeed}</p>
              <div className="profile-actions">
                <button className="btn btn-info btn-sm" onClick={() => handleEditClick(profile)}>✏️ تعديل</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(profile.id)}>🗑️ حذف</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* ✅ النافذة المنبثقة */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{isEditing ? '✏️ تعديل البروفايل' : '➕ إضافة بروفايل جديد'}</h3>
            <form onSubmit={handleAddEditSubmit} className="profile-form">
              <div className="form-group">
                <label>اسم البروفايل:</label>
                <input
                  type="text"
                  value={profileName}
                  onChange={(e) => setProfileName(e.target.value.replace(/[^A-Za-z0-9-]/g, ''))}
                  placeholder="Premium-5M-1M"
                  required
                />
              </div>
              <div className="form-group">
                <label>سرعة الرفع:</label>
                <input
                  type="text"
                  value={uploadSpeed}
                  onChange={(e) => setUploadSpeed(e.target.value)}
                  placeholder="مثال: 5M"
                  required
                />
              </div>
              <div className="form-group">
                <label>سرعة التحميل:</label>
                <input
                  type="text"
                  value={downloadSpeed}
                  onChange={(e) => setDownloadSpeed(e.target.value)}
                  placeholder="مثال: 10M"
                  required
                />
              </div>
              <div className="modal-actions">
                <button type="submit" className={`btn ${isEditing ? 'btn-warning' : 'btn-success'}`}>
                  {loading ? 'جارٍ الحفظ...' : isEditing ? '💾 تعديل' : '💾 إضافة'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={clearForm}>
                  إغلاق
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}


function HotspotProfileManager() {
  const [profiles, setProfiles] = useState([]);
  const [profileName, setProfileName] = useState('');
  const [uploadSpeed, setUploadSpeed] = useState('');
  const [downloadSpeed, setDownloadSpeed] = useState('');
  const [maxUsers, setMaxUsers] = useState('');
  const [isShared, setIsShared] = useState(false);

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [currentProfileId, setCurrentProfileId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?getMikroTikProfilesh&token=${token}`);
      const data = await response.json();

      if (response.ok && data.profiles) {
        setProfiles(data.profiles);
      } else {
        showMessage(data.error || 'فشل تحميل البروفايلات.', 'error');
        setProfiles([]);
      }
    } catch (err) {
      console.error("خطأ في جلب البروفايلات:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

  const clearForm = () => {
    setProfileName('');
    setUploadSpeed('');
    setDownloadSpeed('');
    setMaxUsers('');
    setIsShared(false);
    setIsEditing(false);
    setCurrentProfileId(null);
    setShowModal(false);
    setMessage('');
  };

  const handleAddEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!profileName || !uploadSpeed || !downloadSpeed || !maxUsers) {
      showMessage('يرجى ملء جميع الحقول.', 'error');
      setLoading(false);
      return;
    }

    const profileData = {
      profileName,
      uploadSpeed,
      downloadSpeed,
      maxUsers,
      isShared,
      id: currentProfileId,
    };

    try {
      const token = localStorage.getItem('authToken');
      const endpoint = isEditing ? `editMikroTikProfileh` : `addMikroTikProfileh`;
      const response = await fetch(`https://mcrm.com.tr/api.php?${endpoint}&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(profileData),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || `تم ${isEditing ? 'تعديل' : 'إضافة'} البروفايل بنجاح.`, 'success');
        clearForm();
        fetchProfiles();
      } else {
        showMessage(data.error || 'فشل العملية، حاول مجددًا.', 'error');
      }
    } catch (err) {
      console.error("خطأ في العملية:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleEditClick = (profile) => {
    setProfileName(profile.profileName);
    setUploadSpeed(profile.uploadSpeed);
    setDownloadSpeed(profile.downloadSpeed);
    setMaxUsers(profile.maxUsers || '');
    setIsShared(profile.isShared || false);
    setCurrentProfileId(profile.id);
    setIsEditing(true);
    setShowModal(true);
    setMessage('');
  };

  const handleDeleteClick = async (profileId) => {
    if (!window.confirm('هل أنت متأكد أنك تريد حذف هذا البروفايل؟')) return;

    setLoading(true);
    setMessage('');

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?deleteMikroTikProfileh&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: profileId }),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || 'تم حذف البروفايل.', 'success');
        fetchProfiles();
      } else {
        showMessage(data.error || 'فشل حذف البروفايل.', 'error');
      }
    } catch (err) {
      console.error("خطأ في الحذف:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mikrotik-profile-manager-container">
      <h2 className="main-title">إدارة بروفايلات الهوت سبوت</h2>

      <button className="btn btn-primary add-profile-btn" onClick={() => {
        clearForm();
        setIsEditing(false);
        setShowModal(true);
      }}>
        ➕ إضافة بروفايل جديد
      </button>

      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage('')}
      />

      <h3 className="section-title">البروفايلات الحالية</h3>

      {loading ? (
        <LoadingSpinner />
      ) : profiles.length === 0 ? (
        <p className="no-profiles-message">لا توجد بروفايلات.</p>
      ) : (
        <div className="profiles-list">
          {profiles.map((profile) => (
            <div key={profile.id} className="profile-card">
              <p><strong>الاسم:</strong> {profile.profileName}</p>
              <p><strong>الرفع:</strong> {profile.uploadSpeed} | <strong>التحميل:</strong> {profile.downloadSpeed}</p>
              <p><strong>عدد المستخدمين:</strong> {profile.maxUsers || 'غير محدد'}</p>
              <p><strong>النوع:</strong> {profile.isShared ? 'تشاركي' : 'غير تشاركي'}</p>
              {!profile.scriptsLinked && (
                <p className="profile-warning">⚠️  غير مرتبط !</p>
              )}
              <div className="profile-actions">
                <button className="btn btn-info btn-sm" onClick={() => handleEditClick(profile)}>✏️ تعديل</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(profile.id)}>🗑️ حذف</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>{isEditing ? '✏️ تعديل البروفايل' : '➕ إضافة بروفايل جديد'}</h3>
            <form onSubmit={handleAddEditSubmit} className="profile-form">
              <div className="form-group">
                <label>اسم البروفايل:</label>
                <input
                  type="text"
                  value={profileName}
                  onChange={(e) => setProfileName(e.target.value.replace(/[^A-Za-z0-9-]/g, ''))}
                  placeholder="Premium-5M-1M"
                  required
                />
              </div>
              <div className="form-group">
                <label>سرعة الرفع:</label>
                <input
                  type="text"
                  value={uploadSpeed}
                  onChange={(e) => setUploadSpeed(e.target.value)}
                  placeholder="مثال: 5M"
                  required
                />
              </div>
              <div className="form-group">
                <label>سرعة التحميل:</label>
                <input
                  type="text"
                  value={downloadSpeed}
                  onChange={(e) => setDownloadSpeed(e.target.value)}
                  placeholder="مثال: 10M"
                  required
                />
              </div>
              <div className="form-group">
                <label>عدد المستخدمين:</label>
                <input
                  type="number"
                  value={maxUsers}
                  onChange={(e) => setMaxUsers(e.target.value)}
                  placeholder="مثال: 5"
                  min="1"
                  required
                />
              </div>
              <div className="form-group">
                <label>نوع البروفايل:</label><br />
                <button
                  type="button"
                  className={`btn ${isShared ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                  onClick={() => setIsShared(!isShared)}
                >
                  {isShared ? '✅ تشاركي' : '🚫 غير تشاركي'}
                </button>
              </div>

              <div className="modal-actions">
                <button type="submit" className={`btn ${isEditing ? 'btn-warning' : 'btn-success'}`}>
                  {loading ? 'جارٍ الحفظ...' : isEditing ? '💾 تعديل' : '💾 إضافة'}
                </button>
                <button type="button" className="btn btn-secondary" onClick={clearForm}>
                  إغلاق
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}




function AddAccountForm() {
   const [accounts, setAccounts] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const [step, setStep] = useState(0);
  const [showAddForm, setShowAddForm] = useState(false);

  const [formData, setFormData] = useState({
    clientName: '',
    username: '',
    password: '',
    days: '',
    expiryDate: '',
    dataQuota: '',
    price: '',
    subscriptionType: ''
  });

  const [existingClients, setExistingClients] = useState([]);
  const [showAddClientOption, setShowAddClientOption] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`https://mcrm.com.tr/api.php?pppoeAccounts&token=${token}`)
      .then(res => res.json())
      .then(data => {
        setAccounts(data.accounts || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("فشل تحميل الحسابات:", err);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    if (formData.clientName.length >= 2) {
      fetch(`https://mcrm.com.tr/api.php?searchClient&query=${formData.clientName}`)
        .then(res => res.json())
        .then(data => {
          setExistingClients(data.clients || []);
          const found = data.clients?.some(name => name === formData.clientName);
          setShowAddClientOption(!found);
        });
    }
  }, [formData.clientName]);

  function handleSubmit() {
    const token = localStorage.getItem('authToken');
    fetch(`https://mcrm.com.tr/api.php?addAccount&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(res => res.json())
      .then(data => {
        alert(data.message || 'تمت إضافة الحساب بنجاح');
        setShowAddForm(false);
        setStep(0);
      })
      .catch(() => alert('فشل الإرسال'));
  }

  function renderStep() {
    switch (step) {
      case 1:
        return (
          <>
            <label>اسم العميل (بالعربية):</label>
            <input
              type="text"
              className="form-control"
              value={formData.clientName}
              onChange={(e) => setFormData({ ...formData, clientName: e.target.value })}
            />
            {existingClients.length > 0 && (
              <ul className="suggestions">
                {existingClients.map((client, idx) => (
                  <li key={idx} onClick={() => setFormData({ ...formData, clientName: client })}>
                    {client}
                  </li>
                ))}
              </ul>
            )}
            {showAddClientOption && <p>🆕 العميل غير موجود، هل تريد إضافته كعميل جديد؟</p>}
            <button disabled={!formData.clientName} onClick={() => setStep(2)}>التالي</button>
          </>
        );

      case 2:
        return (
          <>
            <label>اسم المستخدم (بالإنجليزية، بدون فراغات):</label>
    <input
  type="text"
  className="form-control"
  value={formData.username}
  onChange={(e) => {
    // يسمح فقط بالحروف الإنجليزية الكبيرة والصغيرة والأرقام
    const value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
    setFormData({ ...formData, username: value });
  }}
/>
            <button disabled={!formData.username} onClick={() => setStep(3)}>التالي</button>
          </>
        );

      case 3:
        return (
          <>
            <label>كلمة المرور:</label>
            <input
              type="text"
              className="form-control"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            />
            <button disabled={!formData.password} onClick={() => setStep(4)}>التالي</button>
          </>
        );

      case 4:
        return (
          <>
            <label>مدة الاشتراك:</label>
            <select
              className="form-control"
              value={formData.subscriptionType}
              onChange={(e) => setFormData({ ...formData, subscriptionType: e.target.value })}
            >
              <option value="">-- اختر --</option>
              <option value="days">عدد الأيام</option>
              <option value="date">تاريخ الانتهاء</option>
            </select>

            {formData.subscriptionType === 'days' && (
              <input
                type="number"
                className="form-control"
                placeholder="عدد الأيام"
                value={formData.days}
                onChange={(e) => setFormData({ ...formData, days: e.target.value })}
              />
            )}

            {formData.subscriptionType === 'date' && (
              <input
                type="date"
                className="form-control"
                value={formData.expiryDate}
                onChange={(e) => setFormData({ ...formData, expiryDate: e.target.value })}
              />
            )}

            <button
              disabled={
                (formData.subscriptionType === 'days' && !formData.days) ||
                (formData.subscriptionType === 'date' && !formData.expiryDate)
              }
              onClick={() => setStep(5)}
            >
              التالي
            </button>
          </>
        );

      case 5:
        return (
          <>
            <label>الجيغايات:</label>
            <input
              type="number"
              className="form-control"
              value={formData.dataQuota}
              onChange={(e) => setFormData({ ...formData, dataQuota: e.target.value })}
            />
            <button disabled={!formData.dataQuota} onClick={() => setStep(6)}>التالي</button>
          </>
        );

      case 6:
        return (
          <>
            <label>السعر:</label>
            <input
              type="number"
              className="form-control"
              value={formData.price}
              onChange={(e) => setFormData({ ...formData, price: e.target.value })}
            />
            <button disabled={!formData.price} className="btn btn-success mt-3" onClick={handleSubmit}>💾 حفظ الحساب</button>
          </>
        );

      default:
        return null;
    }
  }

  if (loading) return <div className="text-center mt-5">جاري تحميل الحسابات...</div>;

  const filteredAccounts = accounts.filter(acc =>
    acc.client.toLowerCase().includes(search.toLowerCase()) ||
    acc.username.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="broadband-container">
      <h2 className="title">حسابات البرودباند</h2>

      <button className="btn btn-primary" onClick={() => { setShowAddForm(true); setStep(1); }}>
        ➕ إنشاء حساب جديد
      </button>

      {showAddForm && (
        <div className="add-account-modal">
          <h4>🆕 إضافة حساب جديد</h4>
          {renderStep()}
        </div>
      )}

      <input
        type="text"
        placeholder="ابحث عن عميل أو اسم مستخدم..."
        className="search-input"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {filteredAccounts.map((acc, index) => (
        <div key={index} className="account-card">
          <p>👤 {acc.client} | 👨‍💻 {acc.username}</p>
        </div>
      ))}
    </div>
  );
}






function Print() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [confirmingId, setConfirmingId] = useState(null);
  const [formErrors, setFormErrors] = useState({});

const [sentToTelegram, setSentToTelegram] = useState({});






const [apiLoading, setApiLoading] = useState(false);



  const [formData, setFormData] = useState({
    batch_name: '',
    profile: '',
    template: '',
    count: '',
    days: '',
    quota: '',
    hours: '',
    card_name: '',
     card_add: '',
    price: '',
    prefix: '',
    password_option: '1',
    linkemac_option: '0'
  });

  const isValid = () => {
    const namePattern = /^[A-Za-z0-9]+$/;
    const prefixPattern = /^[A-Za-z0-9]+$/;
    const quotaPattern = /^[0-9]+(G|M)$/i;
    let errors = {};
    let formIsValid = true;

    if (!formData.batch_name.trim()) {
      errors.batch_name = "⚠️ يجب إدخال **اسم الطبعة**.";
      formIsValid = false;
    }
    if (!formData.profile) {
      errors.profile = "⚠️ يجب اختيار **البروفايل**.";
      formIsValid = false;
    }
    if (!formData.template) {
      errors.template = "⚠️ يجب اختيار **القالب**.";
      formIsValid = false;
    }
    if (!formData.count || Number(formData.count) <= 0 || Number(formData.count) >= 1000) {
      errors.count = "⚠️ يجب إدخال **عدد** صحيح بين 1 و 999.";
      formIsValid = false;
    }
    if (!formData.days || !/^\d+$/.test(formData.days)) {
      errors.days = "⚠️ يجب إدخال **عدد صحيح للأيام**.";
      formIsValid = false;
    }
    if (formData.quota.trim() && !quotaPattern.test(formData.quota)) {
      errors.quota = "⚠️ يجب أن تكون الكمية رقمًا متبوعًا بـ G أو M، مثل 500M أو 1G.";
      formIsValid = false;
    }
    if (!formData.card_name.trim()) {
      errors.card_name = "⚠️ يجب إدخال **الاسم على الكرت**.";
      formIsValid = false;
    }

if (!/^[3-5]$/.test(formData.card_add)) {
  errors.card_add = "⚠️ يجب أن يكون الرقم 3 أو 4 أو 5 فقط.";
  formIsValid = false;
}




    
    if (!formData.price || Number(formData.price) <= 0) {
      errors.price = "⚠️ يجب إدخال **السعر** ويجب أن يكون أكبر من 0.";
      formIsValid = false;
    }
    if (!formData.prefix.trim()) {
      errors.prefix = "⚠️ يجب إدخال **البادئة**.";
      formIsValid = false;
    }
    if (formData.batch_name.trim() && !namePattern.test(formData.batch_name)) {
      errors.batch_name = "⚠️ اسم الطبعة يجب أن يحتوي على أحرف وأرقام فقط (بالإنجليزية).";
      formIsValid = false;
    }
    if (formData.prefix.trim() && !prefixPattern.test(formData.prefix)) {
      errors.prefix = "⚠️ البادئة يجب أن تحتوي على أحرف إنجليزية وأرقام فقط.";
      formIsValid = false;
    }
    if (!formData.password_option) {
      errors.password_option = "⚠️ يجب اختيار خيار لكلمة المرور.";
      formIsValid = false;
    }
    if (!formData.linkemac_option) {
      errors.linkemac_option = "⚠️ يجب اختيار خيار لربط الماك أدرس.";
      formIsValid = false;
    }

if (formData.profile.includes(' ')) {
  errors.profile = "⚠️ لا يسمح بوجود مسافات في اسم البروفايل.";
  formIsValid = false;
}


    setFormErrors(errors);
    if (!formIsValid) {
      setMessageType('error');
      setMessage("⚠️ يرجى تصحيح الأخطاء في النموذج.");
    } else {
      setMessage('');
    }
    return formIsValid;
  };


const handleSendTelegram = async (id) => {
  if (sentToTelegram[id]) return;

  setSentToTelegram(prev => ({ ...prev, [id]: true }));

  const token = localStorage.getItem('authToken');
  if (!token) {
    setMessageType('error');
    setMessage("❌ لا يوجد رمز مصادقة.");
    return;
  }

  try {
    const res = await fetch(`https://mcrm.com.tr/api.php?sendTelegramCard&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });

    const json = await res.json();
    if (json.success) {
      setMessageType('success');
      setMessage('✅ تم إرسال الملف إلى التلغرام');
    } else {
      setMessageType('error');
      setMessage(json.message || '❌ فشل في الإرسال إلى التلغرام');
      setSentToTelegram(prev => ({ ...prev, [id]: false })); // إعادة السماح بالضغط
    }
  } catch {
    setMessageType('error');
    setMessage('❌ خطأ في الاتصال بالخادم');
    setSentToTelegram(prev => ({ ...prev, [id]: false }));
  }
};






  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === 'checkbox' ? checked : value;

    setFormData(prev => {
      let newState = { ...prev };

      if (name === 'batch_name') {
        newState.batch_name = value.replace(/[^A-Za-z0-9-]/g, '');
      } else if (name === 'prefix') {
        newState.prefix = value.replace(/[^A-Za-z0-9]/g, '');
      } else if (name === 'count') {
        newState.count = value.replace(/\D/g, '');
      } else if (name === 'days') {
        newState.days = value.replace(/\D/g, '');
      } else if (name === 'quota') {
        newState.quota = value.toUpperCase();
        
      } else if (name === 'profile') {
  newState.profile = value.replace(/\s+/g, '');

      } else {

        newState[name] = newValue;
      }
      return newState;
    });

    if (formErrors[name]) {
      setFormErrors(prevErrors => ({ ...prevErrors, [name]: '' }));
    }
  };

  
  const handleAddCard = () => {
    console.log("Attempting to add card with formData:", formData);
    if (!isValid()) {
      console.log("Validation failed.");
      return;
    }

    const token = localStorage.getItem('authToken');
    if (!token) {
      setMessageType('error');
      setMessage("⚠️ لا يوجد رمز مصادقة (token). يرجى تسجيل الدخول.");
      return;
    }
  setApiLoading(true); // ← بدء التحميل
    fetch(`https://mcrm.com.tr/api.php?addCardh&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
      .then(res => {
        console.log("API Response Status:", res.status);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(json => {
        console.log("API Response JSON:", json);
        if (json.success) {
          setMessageType('success');
          setMessage("✅ تم إضافة البطاقة بنجاح");
          setCards(prev => [json.data, ...prev]);
          setShowForm(false);
          setFormData({
            batch_name: '',
            profile: '',
            template: '',
            count: '',
            days: '',
            quota: '',
            hours: '',
            card_name: '',
             card_add: '',
            price: '',
            prefix: '',
            password_option: '1',
            linkemac_option: '0'
          });
          setFormErrors({});
        } else {
          setMessageType('error');
          setMessage(json.message || "فشل في إضافة البطاقة.");
        }
      })
      .catch(err => {
        console.error("Error adding card:", err);
        setMessageType('error');
        setMessage("خطأ في الاتصال بالسيرفر أو معالجة البيانات.");
      })

 .finally(() => {
      setApiLoading(false); // ← إيقاف التحميل
    });

  };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setLoading(false);
      setMessageType('error');
      setMessage("⚠️ لا يوجد رمز مصادقة (token). يرجى تسجيل الدخول أولاً.");
      return;
    }

    fetch(`https://mcrm.com.tr/api.php?getCards&token=${token}`)
      .then(res => res.json())
      .then(json => {
        if (json.success) setCards(json.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching cards:", err);
        setLoading(false);
        setMessageType('error');
        setMessage("فشل في تحميل البطاقات.");
      });

    fetch(`https://mcrm.com.tr/api.php?getProfilesh&token=${token}`)
      .then(res => res.json())
      .then(json => {
        if (json.success && Array.isArray(json.profiles)) {
          setProfiles(json.profiles);
        } else {
          setProfiles([]);
        }
      })
      .catch(err => console.error("Error fetching profiles:", err));

    fetch(`https://mcrm.com.tr/api.php?getTemplates&token=${token}`)
      .then(res => res.json())
      .then(json => {
        if (json.success && Array.isArray(json.data)) {
          setTemplates(json.data);
        } else {
          setTemplates([]);
        }
      })
      .catch(err => console.error("Error fetching templates:", err));
  }, []);

 const handleView = (id) => {
  window.open(`/cards/view?batch_id=${id}`, '_blank');
};


const handleDelete = async (id) => {
  if (!window.confirm('هل أنت متأكد من حذف هذه الطبعة؟')) return;

  const token = localStorage.getItem('authToken');
  if (!token) {
    setMessageType('error');
    setMessage("❌ لا يوجد رمز مصادقة (token).");
    return;
  }

  try {
    setApiLoading(true); // ← بدء التحميل

    const res = await fetch(`https://mcrm.com.tr/api.php?deleteCardh&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id })
    });

    const json = await res.json();

    if (json.success) {
      setCards(prev => prev.filter(card => card.id !== id));
      setMessageType('success');
      setMessage('✅ تم حذف البطاقة بنجاح');
    } else {
      setMessageType('error');
      setMessage(json.message || '❌ فشل في حذف البطاقة.');
    }
  } catch (err) {
    setMessageType('error');
    setMessage('❌ فشل الاتصال بالخادم.');
    console.error(err);
  } finally {
    setApiLoading(false); // ← إيقاف التحميل
  }
};




  const handlePrint = (id) => {
  const url = `https://mcrm.com.tr/new/print.php?id=${id}`; // عدّل الرابط حسب موقعك
  window.open(url, '_blank');
};

 
const handleConfirm = async (id) => {
  setConfirmingId(id);
  setMessageType('info');

  const attemptConfirm = async (round) => {
    setMessage(`⏳ محاولة التأكيد رقم ${round}...`);
    const res = await sendApiCommand('confirmCardh', { id });
    if (!res.success) {
      setConfirmingId(null);
      setMessageType('error');
      setMessage(`❌ فشل التأكيد رقم ${round}: ${res.message || 'حدث خطأ.'}`);
      return false;
    }
    return true;
  };

  for (let i = 1; i <= 3; i++) {
    const success = await attemptConfirm(i);
    if (!success) return;
    if (i < 3) await new Promise(resolve => setTimeout(resolve, 5000));
  }

  setMessageType('success');
  setMessage('✅ تم تأكيد البطاقة 3 مرات بنجاح.');
  setConfirmingId(null);
};



  const sendApiCommand = async (endpoint, body = {}) => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      return { success: false, message: '❌ لا يوجد رمز مصادقة (token).' };
    }
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?${endpoint}&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      return await res.json();
    } catch {
      return { success: false, message: '❌ خطأ في الاتصال بالسيرفر' };
    }
  };

  const getPasswordOptionText = (optionValue) => {
    switch (String(optionValue)) {
      case '0': return 'بدون ';
      case '1': return 'عشوائية';
      case '3': return 'موحدة';
      default: return 'غير محدد';
    }
  };

  const getLinkEmacOptionText = (optionValue) => {
    switch (String(optionValue)) {
      case '0': return 'لا';
      case '1': return 'نعم';
      default: return 'غير محدد';
    }
  };

  return (
    <div className="x-print-container">


    {apiLoading && (
      <div className="x-overlay-loading">
        <LoadingSpinner text="⏳ يرجى الانتظار..." />
      </div>
    )}


      {/* استخدام MessageDisplay هنا */}
      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage('')}
      />

      <button className="x-btn x-btn-add" onClick={() => {
        setShowForm(!showForm);
        setFormErrors({});
        setMessage('');
      }}>
        {showForm ? "❌ إغلاق النموذج" : "➕ إضافة بطاقة"}
      </button>

      {showForm && (
        <div className="x-form">
          <div className="x-form-grid">
            <div>
              <input type="text" name="batch_name" placeholder="اسم الطبعة (بالإنجليزية)" value={formData.batch_name} onChange={handleInputChange} />
              {formErrors.batch_name && <p className="x-error-message">{formErrors.batch_name}</p>}
            </div>
            <div>
              <select name="profile" value={formData.profile} onChange={handleInputChange}>
                <option value="">اختر البروفايل</option>
                {profiles.map((p, i) => <option key={i} value={p}>{p}</option>)}
              </select>
              {formErrors.profile && <p className="x-error-message">{formErrors.profile}</p>}
            </div>
         <div>
  <select name="template" value={formData.template} onChange={handleInputChange}>
    <option value="">اختر القالب</option>
    {Array.isArray(templates) && templates.map((t) => (
      <option key={t.id} value={t.id}>{t.name}</option>
    ))}
  </select>
  {formErrors.template && <p className="x-error-message">{formErrors.template}</p>}
</div>

            <div>
              <input type="number" name="count" placeholder="العدد" value={formData.count} onChange={handleInputChange} />
              {formErrors.count && <p className="x-error-message">{formErrors.count}</p>}
            </div>
            <div>
              <input type="text" name="days" placeholder="عدد الأيام" value={formData.days} onChange={handleInputChange} />
              {formErrors.days && <p className="x-error-message">{formErrors.days}</p>}
            </div>
         <div>
  <input
    type="text"
    name="quota"
    placeholder="الكمية (GB)"
    value={formData.quota}
    onChange={handleInputChange}
  />
  {formErrors.quota && <p className="x-error-message">{formErrors.quota}</p>}
</div>

            <div>
              <input type="text" name="hours" placeholder="عدد الساعات (اختياري)" value={formData.hours} onChange={handleInputChange} />
            </div>
            <div>
              <input type="text" name="card_name" placeholder="الاسم على الكرت" value={formData.card_name} onChange={handleInputChange} />
              {formErrors.card_name && <p className="x-error-message">{formErrors.card_name}</p>}
            </div>
                <div>
              <input type="text" name="card_add" placeholder="عدد الخانات" value={formData.card_add} onChange={handleInputChange} />
              {formErrors.card_add && <p className="x-error-message">{formErrors.card_add}</p>}
            </div>
            <div>
              <input type="number" name="price" placeholder="السعر" value={formData.price} onChange={handleInputChange} />
              {formErrors.price && <p className="x-error-message">{formErrors.price}</p>}
            </div>
            <div>
              <input type="text" name="prefix" placeholder="البادئة (بالإنجليزية)" value={formData.prefix} onChange={handleInputChange} />
              {formErrors.prefix && <p className="x-error-message">{formErrors.prefix}</p>}
            </div>

            <div>
              <select name="password_option" value={formData.password_option} onChange={handleInputChange}>
                <option value="1">مع كلمة مرور (عشوائية)</option>
                <option value="0">بدون كلمة مرور</option>
                <option value="3">كلمة مرور موحدة</option>
              </select>
              {formErrors.password_option && <p className="x-error-message">{formErrors.password_option}</p>}
            </div>

            <div>
              <select name="linkemac_option" value={formData.linkemac_option} onChange={handleInputChange}>
                <option value="0">ربط الماك أدرس: لا</option>
                <option value="1">ربط الماك أدرس: نعم</option>
              </select>
              {formErrors.linkemac_option && <p className="x-error-message">{formErrors.linkemac_option}</p>}
            </div>

          </div>
          <button className="x-btn x-btn-save" onClick={handleAddCard}>💾 حفظ</button>
        </div>
      )}

      {loading ? (
        <LoadingSpinner text="⏳ جاري تحميل البطاقات..." />
      ) : cards.length === 0 ? (
        <p className="x-no-cards">لا توجد كروت حالياً</p>
      ) : (
        <div className="x-card-grid">
          {cards.map((card) => (
            <div className="x-card" key={card.id}>
              <div className="x-card-body">
                <div className="x-card-row">
                  <div className="x-card-col">
                    <p><b>🆔 ID:</b> {card.id}</p>
                    <p><b>📦 الطبعة:</b> {card.batch_name}</p>
                    <p><b>📄 البروفايل:</b> {card.profile}</p>
                    <p><b>📜 القالب:</b> {card.template}</p>
                    <p><b>🔢 العدد:</b> {card.count}</p>
                    <p><b>📅 الأيام:</b> {card.days}</p>
                    <p><b>🔒 خيار كلمة المرور:</b> {getPasswordOptionText(String(card.password_option))}</p>
                  </div>
                  <div className="x-card-col">
                    <p><b>⏱️ الساعات:</b> {card.hours || 'غير محدد'}</p>
                    <p><b>📶 الكمية:</b> {card.quota}</p>
                    <p><b>🏷️ الاسم:</b> {card.card_name}</p>
                    <p><b>💰 السعر:</b> {card.price} ل.س</p>
                    <p><b>🔖 البادئة:</b> {card.prefix}</p>
                    <p><b>🔗 ربط الماك:</b> {getLinkEmacOptionText(String(card.linkemac_option))}</p>
                  </div>
                </div>
              </div>
              <div className="x-card-actions">
                <button className="x-btn x-btn-view" onClick={() => handleView(card.id)} disabled={confirmingId !== null}>👁️ عرض</button>
                <button className="x-btn x-btn-delete" onClick={() => handleDelete(card.id)} disabled={confirmingId !== null}>🗑️ حذف</button>
                <button className="x-btn x-btn-confirm" onClick={() => handleConfirm(card.id)} disabled={confirmingId !== null}>
                  {confirmingId === card.id ? "⏳ جاري التأكيد..." : "✅ تأكيد"}
                </button>

<button
  className="x-btn x-btn-telegram"
  onClick={() => handleSendTelegram(card.id)}
  disabled={!!sentToTelegram[card.id]}
>
  📁 ملف تلغرام
</button>


                <button className="x-btn x-btn-print" onClick={() => handlePrint(card.id)} disabled={confirmingId !== null}>🖨️ طباعة</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}








function SharedSpeeds() {
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState('');
  const [sharedSpeeds, setSharedSpeeds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  useEffect(() => {
    fetchProfiles();
    fetchSharedSpeeds();
  }, []);

  const showMessage = (msg, type = 'success') => {
    setMessage(msg);
    setMessageType(type);
    setTimeout(() => setMessage(''), 4000);
  };

  const fetchProfiles = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?getProfileshs&token=${token}`);
      const json = await res.json();
      setProfiles(json.data || []);
    } catch (err) {
      showMessage("فشل تحميل البروفايلات", 'error');
    }
  };

  const fetchSharedSpeeds = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?getSharedSpeeds&token=${token}`);
      const json = await res.json();
      setSharedSpeeds(json.data || []);
    } catch (err) {
      showMessage("فشل تحميل السرعات التشاركية", 'error');
    }
    setLoading(false);
  };

  const addSharedSpeed = async () => {
    if (!selectedProfile) return;
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?addSharedSpeed&token=${token}&profile=${selectedProfile}`);
      const json = await res.json();
      if (json.status === true || json.status === 1 || json.status === 'success') {
        await fetchSharedSpeeds();
        setSelectedProfile('');
        showMessage("تمت إضافة البروفايل بنجاح", 'success');
      } else {
        showMessage(json.message || "فشل في الإضافة", 'error');
      }
    } catch (err) {
      showMessage("خطأ في الاتصال بالخادم", 'error');
    }
  };

  const deleteSharedSpeed = async (id) => {
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?deleteSharedSpeed&token=${token}&id=${id}`);
      const json = await res.json();
      if (json.status === true || json.status === 1 || json.status === 'success') {
        await fetchSharedSpeeds();
        showMessage("تم حذف البروفايل بنجاح", 'success');
      } else {
        showMessage(json.message || "فشل في الحذف", 'error');
      }
    } catch (err) {
      showMessage("فشل الاتصال بالخادم", 'error');
    }
  };

  return (
    <div className="container py-4" style={{ direction: 'rtl' }}>
      <MessageDisplay message={message} type={messageType} onClose={() => setMessage('')} />

      <h2 className="mb-4 text-center text-primary">
        <i className="bi bi-speedometer2 me-2"></i>إدارة السرعات التشاركية
      </h2>

      <div className="card shadow-sm mb-4 border-0">
        <div className="card-body d-flex flex-column flex-md-row align-items-center gap-3">
          <select
            className="form-select"
            value={selectedProfile}
            onChange={(e) => setSelectedProfile(e.target.value)}
          >
            <option value="">اختر بروفايل</option>
            {profiles.map((profile, i) => (
              <option key={i} value={profile.name}>
                {profile.name}
              </option>
            ))}
          </select>
          <button
            className="btn btn-success"
            onClick={addSharedSpeed}
            disabled={!selectedProfile}
          >
            <i className="bi bi-plus-circle me-1"></i>إضافة
          </button>
        </div>
      </div>

      {loading ? (
        <div className="text-center text-muted">📡 جاري التحميل...</div>
      ) : sharedSpeeds.length === 0 ? (
        <div className="alert alert-info text-center">لا توجد سرعات مضافة</div>
      ) : (
        <>
          <div className="d-none d-md-block">
            <div className="table-responsive shadow-sm rounded-3 overflow-hidden">
              <table className="table table-striped text-center">
                <thead className="table-dark">
                  <tr>
                    <th>الاسم</th>
                    <th>الإجراء</th>
                  </tr>
                </thead>
                <tbody>
                  {sharedSpeeds.map((s) => (
                    <tr key={s.id}>
                      <td>{s.name}</td>
                      <td>
                        <button className="btn btn-sm btn-danger" onClick={() => deleteSharedSpeed(s.id)}>
                          <i className="bi bi-trash"></i> حذف
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="d-block d-md-none">
            {sharedSpeeds.map((s) => (
              <div className="card shadow-sm mb-3" key={s.id}>
                <div className="card-body d-flex justify-content-between align-items-center">
                  <strong>{s.name}</strong>
                  <button className="btn btn-sm btn-danger" onClick={() => deleteSharedSpeed(s.id)}>
                    <i className="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}





function HotspotCardDesigner({ onClose, onTemplateAdded }) {
  const [bgImage, setBgImage] = useState(null);
  const [cardSize, setCardSize] = useState({ width: 400, height: 250 });
  const [templateName, setTemplateName] = useState('');
  const [cardsPerPage, setCardsPerPage] = useState(25);
  const [variables, setVariables] = useState({
    username: { visible: true, x: 20, y: 20, color: '#000', fontSize: 16 },
    password: { visible: true, x: 20, y: 50, color: '#000', fontSize: 16 },
    price: { visible: true, x: 20, y: 80, color: '#000', fontSize: 16 },
    category: { visible: true, x: 20, y: 110, color: '#000', fontSize: 16 },
    days: { visible: true, x: 20, y: 140, color: '#000', fontSize: 16 },
  });

  const [customTexts, setCustomTexts] = useState([]);
  const [newText, setNewText] = useState({ text: '', color: '#000', fontSize: 16 });

  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState('success');

  // Using URLSearchParams directly in a useEffect can be cleaner
  const templateId = new URLSearchParams(window.location.search).get('id');

  // Helper function for showing messages
  const showMessage = (msg, type = 'success') => {
    setMessage(msg);
    setMessageType(type);
    // Optionally, clear message after some time
    // setTimeout(() => setMessage(null), 5000);
  };
  const closeMessage = () => setMessage(null);

  useEffect(() => {
    // Only fetch if templateId exists
    if (templateId) {
      const fetchTemplate = async () => {
        try {
          const token = localStorage.getItem('authToken');
          if (!token) {
            showMessage('❌ لا يوجد توكن مصادقة. يرجى تسجيل الدخول.', 'error');
            return;
          }

          const res = await fetch(`https://mcrm.com.tr/api.php?getTemplateById&id=${templateId}&token=${token}`);
          // Check for HTTP errors first
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          const data = await res.json();

          if (data.success) {
            const t = data.template;
            setTemplateName(t.name || ''); // Ensure default if null/undefined
            setBgImage(t.background || null);
            setCardSize(t.size || { width: 400, height: 250 });
            // Merge existing variables with fetched ones to ensure all keys are present
            setVariables(prevVariables => {
              const fetchedVariables = t.variables || {};
              return Object.keys(prevVariables).reduce((acc, key) => {
                acc[key] = { ...prevVariables[key], ...fetchedVariables[key] };
                return acc;
              }, {});
            });
            setCardsPerPage(t.cardsPerPage || 25);
            setCustomTexts(t.customTexts || []);
          } else {
            showMessage('❌ القالب غير موجود أو حدث خطأ.', 'error');
          }
        } catch (err) {
          console.error('Fetch error:', err);
          showMessage(`❌ فشل تحميل القالب: ${err.message}`, 'error');
        }
      };
      fetchTemplate();
    }
  }, [templateId]); // Dependency array includes templateId

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Basic file size validation (e.g., max 2MB)
      if (file.size > 2 * 1024 * 1024) {
        showMessage('❌ حجم الصورة كبير جداً (الحد الأقصى 2MB).', 'error');
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => setBgImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const toggleVariableVisibility = (key) => {
    setVariables((prev) => ({
      ...prev,
      [key]: { ...prev[key], visible: !prev[key].visible },
    }));
  };

  const handleVariableStyleChange = (key, field, value) => {
    setVariables((prev) => ({
      ...prev,
      [key]: { ...prev[key], [field]: value },
    }));
  };

  const addCustomText = () => {
    if (newText.text.trim() === '') {
      showMessage('الرجاء إدخال نص لإضافته.', 'error');
      return;
    }
    setCustomTexts([
      ...customTexts,
      { ...newText, x: 10, y: 10, id: Date.now() }, // Use Date.now() for a simple unique ID
    ]);
    setNewText({ text: '', color: '#000', fontSize: 16 }); // Reset newText state
    showMessage('✅ تم إضافة النص بنجاح!', 'success');
  };

  const updateCustomTextPosition = (id, x, y) => {
    setCustomTexts((prev) =>
      prev.map((txt) => (txt.id === id ? { ...txt, x, y } : txt))
    );
  };

  const updateVariablePosition = (key, x, y) => {
    setVariables((prev) => ({
      ...prev,
      [key]: { ...prev[key], x, y },
    }));
  };

  const handleSaveTemplate = async () => {
    if (!templateName.trim()) {
      showMessage('يرجى إدخال اسم القالب', 'error');
      return;
    }

    // Basic validation for card size
    if (cardSize.width <= 0 || cardSize.height <= 0) {
      showMessage('أبعاد البطاقة غير صالحة. يجب أن تكون أكبر من صفر.', 'error');
      return;
    }

    const templateData = {
      id: templateId || undefined, // Use undefined if no ID for creation
      name: templateName.trim(),
      background: bgImage,
      size: cardSize,
      variables,
      cardsPerPage,
      customTexts,
    };

    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        showMessage('❌ لا يوجد توكن مصادقة. يرجى تسجيل الدخول.', 'error');
        return;
      }

      const url = `https://mcrm.com.tr/api.php?${templateId ? 'updateTemplate' : 'saveTemplate'}&token=${token}`;
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(templateData),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const result = await res.json();
      if (result.success) {
        showMessage('✅ تم حفظ القالب بنجاح', 'success');
        // If it's a new template, you might want to redirect or update URL
        if (!templateId && result.newTemplateId) {
          // Optional: history.push(`/designer?id=${result.newTemplateId}`);
          window.history.pushState({}, '', `?id=${result.newTemplateId}`); // Update URL without full reload
        }
        if (onTemplateAdded) onTemplateAdded(); // Callback to refresh list in parent
      } else {
        // More specific error from API if available
        showMessage(`❌ حدث خطأ أثناء الحفظ: ${result.message || 'خطأ غير معروف'}`, 'error');
      }
    } catch (err) {
      console.error('API Error:', err);
      showMessage(`❌ فشل الاتصال بالسيرفر: ${err.message}`, 'error');
    }
  };

  const variableLabels = {
    username: '{{username}}',
    password: '{{password}}',
    price: '{{price}}',
    category: '{{category}}',
    days: '{{days}}',
  };

  return (
    <div className="hotspot-container p-6 bg-gray-50 min-h-screen" style={{ direction: 'rtl' }}>
      <h2 className="hotspot-title text-3xl font-bold text-center mb-8 text-blue-700">
        🎨 مصمم بطاقة هوت سبوت
      </h2>

      <MessageDisplay message={message} type={messageType} onClose={closeMessage} />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {/* تصميمات الادخال */}
        <div className="section-box bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">إعدادات البطاقة</h3>
          <div className="mb-4">
            <label htmlFor="bgImageUpload" className="input-label block text-gray-700 text-sm font-bold mb-2">
              🖼️ صورة الخلفية:
            </label>
            <input
              type="file"
              id="bgImageUpload"
              accept="image/*"
              onChange={handleImageChange}
              className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
         
          </div>

          <div className="mb-4">
            <label htmlFor="cardWidth" className="input-label block text-gray-700 text-sm font-bold mb-2">
              📏 عرض البطاقة (px):
            </label>
            <input
              type="number"
              id="cardWidth"
              value={cardSize.width}
              onChange={(e) => setCardSize({ ...cardSize, width: +e.target.value })}
              className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              min="100" // sensible min
              max="1000" // sensible max
            />
          </div>

          <div className="mb-4">
            <label htmlFor="cardHeight" className="input-label block text-gray-700 text-sm font-bold mb-2">
              📐 ارتفاع البطاقة (px):
            </label>
            <input
              type="number"
              id="cardHeight"
              value={cardSize.height}
              onChange={(e) => setCardSize({ ...cardSize, height: +e.target.value })}
              className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              min="100" // sensible min
              max="1000" // sensible max
            />
          </div>

          <div className="mb-4">
            <label htmlFor="cardsPerPage" className="input-label block text-gray-700 text-sm font-bold mb-2">
              عدد الكروت في الصفحة:
            </label>
            <input
              type="number"
              id="cardsPerPage"
              value={cardsPerPage}
              onChange={(e) => setCardsPerPage(+e.target.value)}
              className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              min="1"
              max="100" // sensible max
            />
          </div>
        </div>

        {/* المتغيرات */}
        <div className="section-box bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">🧩 المتغيرات:</h3>
          {Object.keys(variables).map((key) => (
            <div key={key} className="variable-item flex items-center justify-between mb-3 p-2 border rounded-md bg-gray-50">
              <label className="flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={variables[key].visible}
                  onChange={() => toggleVariableVisibility(key)}
                  className="form-checkbox h-5 w-5 text-blue-600 rounded"
                />
                <span className="ml-2 text-gray-700">{variableLabels[key]}</span>
              </label>
              <div className="flex items-center space-x-2">
                <input
                  type="color"
                  value={variables[key].color}
                  onChange={(e) => handleVariableStyleChange(key, 'color', e.target.value)}
                  className="h-8 w-8 rounded-md border-gray-300 cursor-pointer"
                />
                <input
                  type="number"
                  min="8"
                  max="40"
                  value={variables[key].fontSize}
                  onChange={(e) => handleVariableStyleChange(key, 'fontSize', +e.target.value)}
                  className="input-field w-20 px-2 py-1 border rounded-md text-gray-700 text-sm focus:outline-none focus:shadow-outline"
                  aria-label={`حجم خط ${variableLabels[key]}`}
                />
              </div>
            </div>
          ))}
        </div>

        {/* إضافة نص جديد */}
        <div className="section-box bg-white p-6 rounded-lg shadow-md">
          <h3 className="text-xl font-semibold mb-4 text-gray-800">✍️ إضافة نص ثابت:</h3>
          <div className="mb-4">
            <input
              type="text"
              placeholder="النص المراد إضافته"
              className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
              value={newText.text}
              onChange={(e) => setNewText({ ...newText, text: e.target.value })}
            />
            <div className="flex items-center space-x-2 mb-2">
              <input
                type="color"
                value={newText.color}
                onChange={(e) => setNewText({ ...newText, color: e.target.value })}
                className="h-8 w-8 rounded-md border-gray-300 cursor-pointer"
              />
              <input
                type="number"
                min="8"
                max="40"
                value={newText.fontSize}
                onChange={(e) => setNewText({ ...newText, fontSize: +e.target.value })}
                className="input-field w-20 px-2 py-1 border rounded-md text-gray-700 text-sm focus:outline-none focus:shadow-outline"
                aria-label="حجم الخط للنص الجديد"
              />
            </div>
            <button
              className="add-text-btn bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
              onClick={addCustomText}
            >
              ➕ إضافة نص
            </button>
          </div>
          {customTexts.length > 0 && (
            <div className="mt-4">
              <h4 className="text-lg font-medium mb-2">النصوص المضافة:</h4>
              <ul className="list-disc list-inside text-gray-700">
                {customTexts.map((txt) => (
                  <li key={txt.id} className="text-sm">
                    "{txt.text}" (حجم: {txt.fontSize}, لون: {txt.color})
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* منطقة المعاينة */}
      <div className="flex justify-center mb-8">
        <div
          className="preview-card relative border-2 border-dashed border-gray-400 overflow-hidden bg-gray-100 flex-shrink-0"
          style={{
            width: cardSize.width,
            height: cardSize.height,
            backgroundImage: bgImage ? `url(${bgImage})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}
        >
          {Object.entries(variables).map(([key, val]) =>
            val.visible ? (
     <Rnd
  key={key}
  position={{ x: val.x, y: val.y }}
  bounds="parent"
  enableResizing={false}
  onDragStop={(e, d) => updateVariablePosition(key, d.x, d.y)}
>
  <div
    className="preview-text p-1 cursor-grab"
    style={{ color: val.color, fontSize: `${val.fontSize}px`, fontWeight: 'bold' }}
  >
    {variableLabels[key]}
  </div>
</Rnd>
            ) : null
          )}

          {customTexts.map((txt) => (
<Rnd
  key={txt.id}
  position={{ x: txt.x, y: txt.y }}
  bounds="parent"
  enableResizing={false}
  onDragStop={(e, d) => updateCustomTextPosition(txt.id, d.x, d.y)}
>
  <div
    className="preview-text p-1 cursor-grab"
    style={{ color: txt.color, fontSize: `${txt.fontSize}px` }}
  >
    {txt.text}
  </div>
</Rnd>
          ))}
        </div>
      </div>

      {/* حفظ / تحديث القالب */}
      <div className="section-box bg-white p-6 rounded-lg shadow-md max-w-lg mx-auto">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">
          💾 {templateId ? 'تحديث القالب' : 'حفظ القالب'}
        </h3>
        <div className="mb-4">
          <label htmlFor="templateName" className="input-label block text-gray-700 text-sm font-bold mb-2">
            اسم القالب:
          </label>
          <input
            type="text"
            id="templateName"
            className="input-field w-full px-3 py-2 border rounded-md text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="مثال: قالب الفئة الذهبية"
            maxLength="50" // Add a max length for template name
          />
        </div>
        <button
          className="add-text-btn bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
          onClick={handleSaveTemplate}
        >
          💾 {templateId ? 'تحديث القالب' : 'حفظ القالب'}
        </button>
      </div>

      {/* Close button for modal scenario */}
      {onClose && (
        <div className="flex justify-center mt-6">
          <button
            onClick={onClose}
            className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            إغلاق
          </button>
        </div>
      )}
    </div>
  );
}

 


function TemplateList() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState('success');

  const navigate = useNavigate();

  const showMessage = (msg, type = 'success') => {
    setMessage(msg);
    setMessageType(type);
  };

  const closeMessage = () => setMessage(null);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?getTemplatesx&token=${token}`);
      const data = await res.json();
      if (data.success) {
        setTemplates(data.templates || []);
      } else {
        showMessage(`❌ فشل تحميل القوالب: ${data.message || 'خطأ غير معروف'}`, 'error');
      }
    } catch (err) {
      console.error(err);
      showMessage(`❌ فشل الاتصال بالسيرفر: ${err.message}`, 'error');
    } finally {
      setLoading(false);
    }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا القالب؟')) return;
    try {
      const token = localStorage.getItem('authToken');
      const res = await fetch(`https://mcrm.com.tr/api.php?deleteTemplate&id=${id}&token=${token}`);
      const data = await res.json();
      if (data.success) {
        setTemplates((prev) => prev.filter((t) => t.id !== id));
        showMessage('✅ تم حذف القالب بنجاح!');
      } else {
        showMessage(`❌ فشل حذف القالب: ${data.message || 'خطأ غير معروف'}`, 'error');
      }
    } catch (err) {
      showMessage(`❌ حصل خطأ في الاتصال بالسيرفر: ${err.message}`, 'error');
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return (
    <div className="p-6 max-w-6xl mx-auto" style={{ direction: 'rtl' }}>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-3xl font-bold text-gray-800">📋 قائمة القوالب</h2>
        <button
          onClick={() => navigate('/designer')}
          className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 flex items-center"
        >
          <i className="fas fa-plus mr-2"></i> ➕ إضافة قالب
        </button>
      </div>

      <MessageDisplay message={message} type={messageType} onClose={closeMessage} />

      {loading ? (
        <div className="text-center text-gray-600 py-8">
          ⏳ جاري تحميل القوالب...
        </div>
      ) : templates.length === 0 ? (
        <div className="text-center text-gray-500 mt-6 text-lg p-4 bg-gray-100 rounded-md">
          😕 لا توجد قوالب محفوظة بعد. ابدأ بإضافة قالب جديد!
        </div>
      ) : (
        <div className="gridx">
          {templates.map((template) => (
            <div
              key={template.id}
              className="template-card relative border p-4 rounded-lg shadow-md bg-white hover:shadow-lg transition-shadow duration-200"
            >
              <h3
                className="cursor-pointer text-blue-600 hover:underline font-semibold mb-2 text-xl truncate"
                onClick={() => navigate(`/designer?id=${template.id}`)}
              >
                {template.name}
              </h3>

              {template.background ? (
                <img
                  src={template.background}
                  alt="خلفية"
                  className="w-full h-32 object-cover rounded"
                />
              ) : (
                <div className="w-full h-32 bg-gray-200 flex items-center justify-center text-gray-500 rounded">
                  لا توجد صورة
                </div>
              )}

              <p className="text-sm text-gray-600 mt-2">
                العرض: {template.size?.width || 'غير معروف'}px، الارتفاع: {template.size?.height || 'غير معروف'}px
              </p>

              <button
                onClick={() => deleteTemplate(template.id)}
                className="absolute top-2 left-2 text-red-500 hover:text-red-700"
              >
                🗑️
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}




function CardPreviewer() {
  const [data, setData] = useState(null);
  const [cardsPerPage, setCardsPerPage] = useState(6);
  const [cardWidth, setCardWidth] = useState(0);
  const [cardHeight, setCardHeight] = useState(0);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const template = queryParams.get("template") || 1;
  const card = queryParams.get("card") || 1;
  const perPage = parseInt(queryParams.get("perPage")) || 6;

  useEffect(() => {
    setCardsPerPage(perPage);
  }, [perPage]);

  useEffect(() => {
    fetch(`https://mcrm.com.tr/new/printx.php?template=${template}&card=${card}`)
      .then((res) => res.json())
      .then(setData)
      .catch((err) => console.error("Fetch error:", err));
  }, [template, card]);






  useEffect(() => {


 const mainContentDiv = document.querySelector('.main-content');
  if (mainContentDiv) {
    mainContentDiv.style.marginTop = "0px";
    // أضف أي ستايل آخر هنا
  }

    if (!data) return;

    const pageWidthPx = 794; // A4 width at 96dpi
    const pageHeightPx = 1123; // A4 height
    const spacing = 5;
    const aspectRatio = data.size.width / data.size.height;

    let bestWidth = 0;
    let bestHeight = 0;

    for (let rows = 1; rows <= cardsPerPage; rows++) {
      const cols = Math.ceil(cardsPerPage / rows);
      const totalSpacingX = spacing * (cols - 1);
      const totalSpacingY = spacing * (rows - 1);

      const maxWidth = (pageWidthPx - totalSpacingX) / cols;
      const maxHeight = (pageHeightPx - totalSpacingY) / rows;

      let width = Math.min(maxWidth, maxHeight * aspectRatio);
      let height = width / aspectRatio;

      if (
        width * cols + totalSpacingX <= pageWidthPx &&
        height * rows + totalSpacingY <= pageHeightPx
      ) {
        if (width > bestWidth) {
          bestWidth = width;
          bestHeight = height;
        }
      }
    }

    setCardWidth(bestWidth);
    setCardHeight(bestHeight);
  }, [data, cardsPerPage]);

  if (!data) return <p>جاري التحميل...</p>;

  const scale = cardWidth / data.size.width;
  const pages = [];
  for (let i = 0; i < data.cards.length; i += cardsPerPage) {
    pages.push(data.cards.slice(i, i + cardsPerPage));
  }

  return (
    <div style={{ fontFamily: "Cairo, sans-serif", direction: "rtl" }}>
      <div style={{ marginBottom: 20 }}>
        <label>عدد الكروت في الصفحة: </label>
        <input
          type="number"
          value={cardsPerPage}
          onChange={(e) => setCardsPerPage(Number(e.target.value))}
          min={1}
          max={50}
          style={{ marginLeft: 10, marginRight: 30 }}
        />
        <span style={{ marginRight: 20 }}>
          العرض: {Math.round(cardWidth)} px | الارتفاع: {Math.round(cardHeight)} px
        </span>
        <button onClick={() => window.print()} style={{ marginRight: 20 }}>
          🖨️ طباعة
        </button>
      </div>
{pages.map((cards, pageIndex) => (
  <div
    key={pageIndex}
    className="print-page"
    style={{
      width: `${794}px`, // A4 width in px
      height: `${1123}px`, // A4 height in px
      boxSizing: "border-box",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "flex-start",
      alignContent: "flex-start",
      gap: `${5}px`, // نفس قيمة spacing
      pageBreakAfter: "always",
      background: "#fff",
      margin: "0 auto",
      padding: 0,
    }}
  >
    {cards.map((card, idx) => (
      <div
        key={idx}
        className="card"
        style={{
          position: "relative",
          width: `${cardWidth}px`,
          height: `${cardHeight}px`,
          backgroundImage: `url(${data.background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          border: "1px solid #aaa",
          boxShadow: "0 0 6px rgba(0,0,0,0.1)",
          pageBreakInside: "avoid",
        }}
      >
              {Object.entries(data.variables).map(([key, value]) =>
                value.visible ? (
                  <div
                    key={key}
                    style={{
                      position: "absolute",
                      top: value.y * scale,
                      left: value.x * scale,
                      color: value.color,
                      fontSize: value.fontSize * scale,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {card[key]}
                  </div>
                ) : null
              )}

              {data.customTexts.map((txt, i) => (
                <div
                  key={i}
                  style={{
                    position: "absolute",
                    top: txt.y * scale,
                    left: txt.x * scale,
                    color: txt.color,
                    fontSize: txt.fontSize * scale,
                    whiteSpace: "nowrap",
                  }}
                >
                  {txt.text}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}


function DeviceDetails() {
  const { id } = useParams();
  const [device, setDevice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    if (loading) {
      const interval = setInterval(() => {
        setProgress((prev) => (prev < 95 ? prev + 5 : prev));
      }, 250);
      return () => clearInterval(interval);
    }
  }, [loading]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`https://mcrm.com.tr/api.php?device_detail&id=${id}&token=${token}`)
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          setDevice(json.data);
        } else {
          setError(json.message || 'فشل في جلب التفاصيل');
        }
        setProgress(100);
        setTimeout(() => setLoading(false), 2000);
      })
      .catch((err) => {
        console.error(err);
        setError('حدث خطأ في الاتصال بالخادم');
        setLoading(false);
      });
  }, [id]);

  const showValue = (value) => {
    return value !== null && value !== undefined && value !== 'N/A' ? value : 'غير متوفر';
  };

  const renderSignalBar = (value) => {
    const percentage = Math.min(Math.max(100 + parseInt(value), 0), 100);
    let colorClass = 'device-details-bar-low';
    if (percentage > 70) colorClass = 'device-details-bar-high';
    else if (percentage > 40) colorClass = 'device-details-bar-medium';

    return (
      <div className="device-details-item">
        <strong>📶 قوة الإشارة:</strong>
        <div className="device-details-bar">
          <div className={`device-details-bar-fill ${colorClass}`} style={{ width: `${percentage}%` }}>
            {value} dBm
          </div>
        </div>
      </div>
    );
  };

  const renderPercentageBar = (value, label) => {
    const percentage = Math.min(Math.max(parseInt(value), 0), 100);
    let colorClass = 'device-details-bar-low';
    if (percentage > 70) colorClass = 'device-details-bar-high';
    else if (percentage > 40) colorClass = 'device-details-bar-medium';

    return (
      <div className="device-details-item">
        <strong>{label}:</strong>
        <div className="device-details-bar">
          <div className={`device-details-bar-fill ${colorClass}`} style={{ width: `${percentage}%` }}>
            {percentage}%
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="device-details-loading">
        <p>⏳ جاري تحميل البيانات...</p>
        <ProgressBar animated now={progress} label={`${progress}%`} />
      </div>
    );
  }

  if (error) return <p>❌ {error}</p>;

  return (
    <div className="device-details-container">
      <h2>🛰️ تفاصيل الجهاز</h2>
      <div className="device-details-grid">
        <div className="device-details-item"><strong>📦 الموديل:</strong> {showValue(device.model)}</div>
        <div className="device-details-item"><strong>🏷️ الاسم:</strong> {showValue(device.hostname)}</div>
        <div className="device-details-item"><strong>📶 SSID:</strong> {showValue(device.ssid)}</div>
        <div className="device-details-item"><strong>🔐 الحماية:</strong> {showValue(device.security)}</div>
        <div className="device-details-item"><strong>🖥️ النسخة:</strong> {showValue(device.version)}</div>
        <div className="device-details-item"><strong>⏱️ التشغيل:</strong> {showValue(device.uptime_hours)} ساعة</div>
        <div className="device-details-item"><strong>📅 التاريخ:</strong> {showValue(device.date)}</div>
        <div className="device-details-item"><strong>🌐 الشبكة:</strong> {showValue(device.network_mode)}</div>
        <div className="device-details-item"><strong>📡 المود:</strong> {showValue(device.mode)}</div>
        <div className="device-details-item"><strong>🛰️ التردد:</strong> {showValue(device.frequency)}</div>
        <div className="device-details-item"><strong>📶 العرض:</strong> {showValue(device.channel_width)} MHz</div>
        <div className="device-details-item"><strong>📡 النطاق:</strong> {showValue(device.frequency_band)}</div>
        <div className="device-details-item"><strong>🧬 TX/RX:</strong> {showValue(device.tx_rx_chains)}</div>
        <div className="device-details-item"><strong>⚡ الطاقة:</strong> {showValue(device.tx_power)} dBm</div>
        <div className="device-details-item"><strong>📡 انتينا:</strong> {showValue(device.antenna)}</div>
        <div className="device-details-item"><strong>🧾 WLAN MAC:</strong> {showValue(device.wlan_mac)}</div>
        <div className="device-details-item"><strong>🧾 LAN MAC:</strong> {showValue(device.lan_mac)}</div>
        <div className="device-details-item"><strong>🌐 LAN:</strong> {showValue(device.lan)}</div>
        <div className="device-details-item"><strong>🧠 CPU:</strong> {showValue(device.cpu_load)}%</div>
        <div className="device-details-item"><strong>📊 RAM:</strong> {showValue(device.memory_usage)}%</div>
        {renderSignalBar(device.signal_strength)}
        <div className="device-details-item"><strong>📈 TX/RX:</strong> {showValue(device.tx_rate)} / {showValue(device.rx_rate)}</div>
        <div className="device-details-item"><strong>🔄 CCQ:</strong> {showValue(device.ccq)}%</div>
        <div className="device-details-item"><strong>📉 الضجيج:</strong> {showValue(device.noise_floor)}</div>
        <div className="device-details-item"><strong>🧭 الاتجاه:</strong> {showValue(device.horizontal_vertical)}</div>
        <div className="device-details-item"><strong>⚙️ airMAX:</strong> {device.airmax_enabled ? 'مفعل' : 'غير مفعل'}</div>
        {device.airmax_enabled && (
          <>
            {renderPercentageBar(device.airmax_quality, "📈 جودة AirMAX")}
            {renderPercentageBar(device.airmax_capacity, "📉 سعة AirMAX")}
          </>
        )}
      </div>
    </div>
  );
}



function AdminManager() {
  const [admins, setAdmins] = useState([]);
  const [permissionOptions, setPermissionOptions] = useState([]); // جلب من API
  const [managerName, setManagerName] = useState('');
  const [managerPhone, setManagerPhone] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [telegramId, setTelegramId] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchPermissions();
    fetchAdmins();
  }, []);

  // 🔥 جلب الصلاحيات من API
  const fetchPermissions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?getPermissions&token=${token}`);
      const data = await response.json();

      if (response.ok && data.permissions) {
        const formatted = data.permissions.map(p => ({
          value: p.id,
          label: p.name,
        }));
        setPermissionOptions(formatted);
      } else {
        showMessage(data.error || "فشل جلب الصلاحيات", "error");
      }
    } catch (err) {
      console.error("خطأ في جلب الصلاحيات:", err);
      showMessage("حدث خطأ أثناء الاتصال بالخادم.", "error");
    }
  };

  // 🔥 جلب المدراء
  const fetchAdmins = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?getManagers&token=${token}`);
      const data = await response.json();

      if (response.ok && data.admins) {
        setAdmins(data.admins);
      } else {
        showMessage(data.error || 'فشل تحميل المدراء.', 'error');
        setAdmins([]);
      }
    } catch (err) {
      console.error("خطأ:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const showMessage = (text, type = 'success') => {
    setMessage(text);
    setMessageType(type);
  };

  const clearForm = () => {
    setManagerName('');
    setManagerPhone('');
    setUsername('');
    setPassword('');
    setTelegramId('');
    setPermissions([]);
    setIsEditing(false);
    setCurrentId(null);
    setShowModal(false);
    setMessage('');
  };

  // 🔥 إضافة / تعديل مدير
  const handleAddEditSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!managerName || !username) {
      showMessage('يرجى ملء جميع الحقول المطلوبة.', 'error');
      setLoading(false);
      return;
    }

    const adminData = {
      managerName,
      managerPhone,
      username,
      password,
      telegramId,
      permissions: permissions.map(p => p.value),
      id: currentId,
    };

    try {
      const token = localStorage.getItem('authToken');
      const endpoint = isEditing ? `editManager` : `addManager`;

      const response = await fetch(`https://mcrm.com.tr/api.php?${endpoint}&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(adminData),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || 'تم الحفظ بنجاح.', 'success');
        clearForm();
        fetchAdmins();
      } else {
        showMessage(data.error || 'فشل العملية.', 'error');
      }
    } catch (err) {
      console.error("خطأ:", err);
      showMessage('حدث خطأ أثناء الاتصال بالخادم', 'error');
    } finally {
      setLoading(false);
    }
  };

  // 🔥 عند تعديل مدير
  const handleEditClick = (admin) => {
    setManagerName(admin.managerName);
    setManagerPhone(admin.managerPhone);
    setUsername(admin.username);
    setPassword('');
    setTelegramId(admin.telegramId);
    setCurrentId(admin.id);
    setIsEditing(true);
    setShowModal(true);
    setMessage('');

    if (admin.permissions && Array.isArray(admin.permissions)) {
      const selected = permissionOptions.filter(p =>
        admin.permissions.includes(p.value)
      );
      setPermissions(selected);
    } else {
      setPermissions([]);
    }
  };

  // 🔥 حذف مدير
  const handleDeleteClick = async (adminId) => {
    if (!window.confirm('هل تريد حذف هذا المدير؟')) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`https://mcrm.com.tr/api.php?deleteManager&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: adminId }),
      });

      const data = await response.json();

      if (response.ok) {
        showMessage(data.message || 'تم الحذف.', 'success');
        fetchAdmins();
      } else {
        showMessage(data.error || 'فشل الحذف.', 'error');
      }
    } catch (err) {
      console.error("خطأ:", err);
      showMessage('خطأ في الاتصال بالخادم', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-manager-container">
      <h2 className="main-title">إدارة المدراء</h2>

      <button className="btn btn-primary add-profile-btn" onClick={() => {
        clearForm();
        setIsEditing(false);
        setShowModal(true);
      }}>
        ➕ إضافة مدير جديد
      </button>

      {message && (
        <div className={`alert alert-${messageType}`}>
          {message}
        </div>
      )}

      <h3 className="section-title">المدراء الحاليون</h3>

      {loading ? (
        <p>جاري التحميل...</p>
      ) : admins.length === 0 ? (
        <p>لا يوجد مدراء.</p>
      ) : (
        <div className="profiles-list">
          {admins.map((admin) => (
            <div key={admin.id} className="profile-card">
              <p><strong>الاسم:</strong> {admin.managerName}</p>
              <p><strong>الهاتف:</strong> {admin.managerPhone}</p>
              <p><strong>اسم المستخدم:</strong> {admin.username}</p>
              <p><strong>التلغرام:</strong> {admin.telegramId}</p>
              <p><strong>الصلاحيات:</strong> {admin.permissions?.join(", ")}</p>

              <div className="profile-actions">
                <button className="btn btn-info btn-sm" onClick={() => handleEditClick(admin)}>✏️ تعديل</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(admin.id)}>🗑️ حذف</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* نافذة الإضافة / التعديل */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">

            <h3>{isEditing ? "✏️ تعديل المدير" : "➕ إضافة مدير جديد"}</h3>

            <form onSubmit={handleAddEditSubmit}>
              <div className="form-group">
                <label>اسم المدير:</label>
                <input type="text" value={managerName} onChange={(e) => setManagerName(e.target.value)} required />
              </div>

              <div className="form-group">
                <label>رقم الهاتف:</label>
                <input type="text" value={managerPhone} onChange={(e) => setManagerPhone(e.target.value)} />
              </div>

              <div className="form-group">
                <label>اسم المستخدم:</label>
                <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} required />
              </div>

              <div className="form-group">
                <label>كلمة المرور:</label>
                <input type="password" onChange={(e) => setPassword(e.target.value)} />
              </div>

              <div className="form-group">
                <label>معرف التلغرام:</label>
                <input type="text" value={telegramId} onChange={(e) => setTelegramId(e.target.value)} />
              </div>

              {/* الصلاحيات */}
              <div className="form-group">
                <label>صلاحيات المدير:</label>
                <Select
                  options={permissionOptions}
                  isMulti
                  value={permissions}
                  onChange={setPermissions}
                  placeholder="اختر الصلاحيات..."
                />
              </div>

              <div className="modal-actions">
                <button type="submit" className="btn btn-success">
                  {loading ? "جارٍ الحفظ..." : isEditing ? "💾 تعديل" : "💾 إضافة"}
                </button>
                <button type="button" className="btn btn-secondary" onClick={clearForm}>إغلاق</button>
              </div>

            </form>
          </div>
        </div>
      )}

    </div>
  );
}

function BroadbandOptions() {
  const [stopDate, setStopDate] = useState('');
  const [loadingAction, setLoadingAction] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('success');

  const token = localStorage.getItem('authToken');

  const confirmAndRun = async (messageText, endpoint) => {
    if (!window.confirm(messageText)) return;
    setLoadingAction(endpoint);
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?${endpoint}&token=${token}`);
      const json = await res.json();
      setMessage(json.message || 'تم التنفيذ');
      setMessageType(json.success === false ? 'error' : 'success'); // بناءً على محتوى الاستجابة
    } catch (err) {
      setMessage('حدث خطأ أثناء الاتصال بالخادم');
      setMessageType('error');
    } finally {
      setLoadingAction('');
    }
  };

  const handleSetStopDate = () => {
    if (!stopDate) return setMessage('يرجى اختيار التاريخ أولاً');
    confirmAndRun(
      `⚠️ هل أنت متأكد من تحديد هذا التاريخ لإيقاف الحسابات؟ لا يمكن التراجع!`,
      `stopAccounts&date=${stopDate}`
    );
  };

  return (
    <div className="broadband-container">
      <MessageDisplay
        message={message}
        type={messageType}
        onClose={() => setMessage('')}
      />

      <h2 className="title">
        <i className="fas fa-network-wired icon"></i> خيارات إدارة حسابات البروبداند
      </h2>

      <div className="date-section">
        <label>📅 تاريخ الإيقاف:</label>
        <input
          type="date"
          value={stopDate}
          onChange={(e) => setStopDate(e.target.value)}
        />
        <button
          className="btn red"
          onClick={handleSetStopDate}
          disabled={loadingAction === 'stopAccounts'}
        >
          <i className="fas fa-calendar-times"></i>
          {loadingAction === 'stopAccounts' ? 'جارٍ الإيقاف...' : 'تأكيد الإيقاف'}
        </button>
      </div>

      <div className="actions">
        <button
          className="btn blue"
          onClick={() =>
            confirmAndRun(
              'هل تريد استيراد الحسابات الموجودة في السيرفر وغير موجودة في المنصة؟',
              'importMissingAccounts'
            )
          }
          disabled={loadingAction === 'importMissingAccounts'}
        >
          <i className="fas fa-download"></i>
          {loadingAction === 'importMissingAccounts' ? 'جارٍ الاستيراد...' : 'استيراد الحسابات من السيرفر'}
        </button>

        <button
          className="btn orange"
          onClick={() =>
            confirmAndRun(
              '⚠️ سيتم حذف جميع الحسابات من المنصة واستيرادها مجددًا من السيرفر. هل أنت متأكد؟',
              'resetAccountsFromServer'
            )
          }
          disabled={loadingAction === 'resetAccountsFromServer'}
        >
          <i className="fas fa-sync-alt"></i>
          {loadingAction === 'resetAccountsFromServer' ? 'جارٍ التحديث...' : 'حذف وإعادة استيراد'}
        </button>

        <button
          className="btn green"
          onClick={() =>
            confirmAndRun(
              'هل تريد إرسال الحسابات الموجودة في المنصة إلى السيرفر؟',
              'syncAccountsToServer'
            )
          }
          disabled={loadingAction === 'syncAccountsToServer'}
        >
          <i className="fas fa-upload"></i>
          {loadingAction === 'syncAccountsToServer' ? 'جارٍ الإرسال...' : 'إرسال الحسابات إلى السيرفر'}
        </button>
      </div>
    </div>
  );
}



function WhatsAppConnection() {
  const [activated, setActivated] = useState(null);
  const [status, setStatus] = useState("loading");
  const [qr, setQr] = useState(null);
  const [qrImage, setQrImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [cooldown, setCooldown] = useState(0);

  // ✅ bot
  const [autoReply, setAutoReply] = useState(false);
  const [botText, setBotText] = useState("");
  const [savingBot, setSavingBot] = useState(false);

  const token = localStorage.getItem("authToken");

  const fetchStatus = async () => {
    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?waStatus&token=${token}`
      );
      const data = await res.json();

      if (!data.status) {
        setActivated(false);
        setStatus("loading");
      } else {
        setActivated(true);
        setStatus(data.status);
        setQr(data.qr || null);
      }
    } catch (err) {
      console.error("فشل التحقق من الحالة:", err);
    }
  };

  // ✅ جلب إعدادات البوت
  const fetchBotSettings = async () => {
    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?waBotGet&token=${token}`
      );
      const data = await res.json();

      setAutoReply(data.autoReply ?? false);
      setBotText(data.botText ?? "");
    } catch (err) {
      console.error("فشل جلب إعدادات البوت", err);
    }
  };

  const activateService = async () => {
    const lastActivation = localStorage.getItem("lastWaActivation");
    const now = Date.now();

    if (lastActivation && now - parseInt(lastActivation) < 60000 && !qr) {
      const secondsLeft = Math.ceil(
        (60000 - (now - parseInt(lastActivation))) / 1000
      );
      setCooldown(secondsLeft);
      return;
    }

    setLoading(true);
    setMessage("");
    localStorage.setItem("lastWaActivation", now.toString());
    if (!qr) setCooldown(60);

    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?waActivate&token=${token}`
      );
      const data = await res.json();
      setActivated(true);
      setStatus(data.status || "disconnected");
      setQr(data.qr || null);
    } catch (err) {
      console.error("فشل تفعيل الخدمة:", err);
    }

    setLoading(false);
  };

  const reconnect = async () => {
    await activateService();
  };

  const saveBotSettings = async () => {
    setSavingBot(true);

    try {
      await fetch(`https://mcrm.com.tr/api.php?waBotSave&token=${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          autoReply,
          botText,
        }),
      });

      setMessage("✅ تم حفظ إعدادات البوت");
    } catch {
      setMessage("❌ فشل حفظ إعدادات البوت");
    }

    setSavingBot(false);
  };

  useEffect(() => {
    if (cooldown > 0 && !qr) {
      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [cooldown, qr]);

  useEffect(() => {
    fetchStatus();
    fetchBotSettings();

    const interval = setInterval(fetchStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (qr) {
      QRCode.toDataURL(qr, { width: 256, margin: 2 })
        .then((url) => setQrImage(url))
        .catch(() => setQrImage(null));
    } else {
      setQrImage(null);
    }
  }, [qr]);

  return (
    <div className="container py-4 text-center" style={{ direction: "rtl" }}>
      <h2 className="mb-3 text-primary">
        <i className="bi bi-whatsapp me-2"></i>ربط واتساب
      </h2>

      {message && <p className="text-warning">{message}</p>}

      {activated === null ? (
        <p>🔄 جاري التحقق من الخدمة...</p>
      ) : !activated ? (
        <>
          <p className="text-warning">⚠️ لم تقم بتفعيل الخدمة بعد</p>
          <button
            className="btn btn-outline-success"
            onClick={activateService}
            disabled={loading || (cooldown > 0 && !qr)}
          >
            {loading
              ? "...جاري التفعيل"
              : cooldown > 0 && !qr
              ? `⏳ انتظر ${cooldown} ثانية`
              : "تفعيل الخدمة"}
          </button>
        </>
      ) : (
        <>
          {status === "connected" ? (
            <div className="alert alert-success">
              ✅ تم الربط بنجاح – يمكنك الآن استخدام الخدمة
            </div>
          ) : status === "disconnected" ? (
            <>
              <p className="text-danger">❌ غير متصل – امسح QR من الهاتف</p>

              {qrImage && (
                <div className="d-flex justify-content-center mt-3">
                  <img
                    src={qrImage}
                    alt="WhatsApp QR"
                    style={{
                      width: 256,
                      height: 256,
                      background: "#fff",
                      padding: 8,
                      borderRadius: 8,
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <p className="text-muted">🚫 حدث خطأ في الاتصال</p>
          )}

          <button
            onClick={reconnect}
            className="btn btn-outline-primary mt-3"
            disabled={loading || (cooldown > 0 && !qr)}
          >
            {loading
              ? "...جاري إعادة التفعيل"
              : cooldown > 0 && !qr
              ? `⏳ انتظر ${cooldown} ثانية`
              : "إعادة التفعيل"}
          </button>
        </>
      )}

      {/* ✅ BOT SETTINGS */}
      <hr className="my-4" />

      <h5 className="text-primary">🤖 إعدادات الرد التلقائي</h5>

<div className="d-flex justify-content-center gap-2 my-3">
  <button
    className={`btn ${autoReply ? "btn-success" : "btn-outline-secondary"}`}
    onClick={() => setAutoReply(true)}
  >
    تشغيل
  </button>

  <button
    className={`btn ${!autoReply ? "btn-danger" : "btn-outline-secondary"}`}
    onClick={() => setAutoReply(false)}
  >
    إيقاف
  </button>
</div>

<p className="text-muted">
  الحالة: {autoReply ? "🟢 مفعل" : "🔴 متوقف"}
</p>


      <textarea
        className="form-control"
        rows="4"
        placeholder="✍️ تعليمات البوت..."
        value={botText}
        onChange={(e) => setBotText(e.target.value)}
      />

      <button
        onClick={saveBotSettings}
        className="btn btn-success mt-3"
        disabled={savingBot}
      >
        {savingBot ? "⏳ جاري الحفظ..." : "💾 حفظ"}
      </button>
    </div>
  );
}



function LineDmg() {
  const [line1, setLine1] = useState('');
  const [line2, setLine2] = useState('');
  const [mode, setMode] = useState('equal');
  const [ratio1, setRatio1] = useState(50);
  const [ratio2, setRatio2] = useState(50);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const token = localStorage.getItem('authToken');

  // 🟢 جلب الإعدادات عند تحميل الصفحة
  useEffect(() => {
    fetch(`https://mcrm.com.tr/api.php?getline&token=${token}`)
      .then(res => res.json())
      .then(response => {
        if (response.success && response.data) {
          const data = response.data;
          console.log('📦 البيانات من السيرفر:', data);

          setLine1(data.line1 || '');
          setLine2(data.line2 || '');
          setMode((data.mode || 'equal').toLowerCase());
          setRatio1(Number(data.ratio1) || 50);
          setRatio2(Number(data.ratio2) || 50);
        } else {
          setMessage('⚠️ لا توجد بيانات محفوظة.');
        }
        setLoading(false);
      })
      .catch(() => {
        setMessage('❌ فشل في تحميل البيانات.');
        setLoading(false);
      });
  }, [token]);

  // 🟢 حفظ التعديلات
  const handleSave = async () => {
    const res = await fetch(`https://mcrm.com.tr/api.php?saveline&token=${token}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line1,
        line2,
        mode,
        ratio1: mode === 'equal' ? 50 : ratio1,
        ratio2: mode === 'equal' ? 50 : ratio2,
      }),
    });

    const result = await res.json();
    if (result.success) {
      setMessage(result.message || '✅ تم حفظ الإعدادات بنجاح.');
    } else {
      setMessage(`❌ فشل في الحفظ: ${result.message || 'غير معروف'}`);
    }
  };

  // 🕐 تحميل...
  if (loading) {
    return <div className="text-center my-5">⏳ جاري تحميل الإعدادات...</div>;
  }

  // ✅ واجهة النموذج
  return (
    <div className="container p-4 border rounded shadow-sm mt-4" style={{ direction: 'rtl', maxWidth: '600px' }}>
      <h4 className="text-primary mb-3">🧩 نموذج دمج الخطوط</h4>

      {message && <div className="alert alert-info">{message}</div>}

      {/* الخط الأول */}
      <div className="mb-3">
        <label className="form-label">📶 الخط الأول</label>
        <input
          type="text"
          className="form-control"
          value={line1}
          onChange={(e) => setLine1(e.target.value)}
          placeholder="مثال: 192.168.1.1 أو اسم الخط"
        />
      </div>

      {/* الخط الثاني */}
      <div className="mb-3">
        <label className="form-label">📶 الخط الثاني</label>
        <input
          type="text"
          className="form-control"
          value={line2}
          onChange={(e) => setLine2(e.target.value)}
          placeholder="مثال: 192.168.2.1 أو اسم الخط"
        />
      </div>

      {/* طريقة التوزيع */}
      <div className="mb-3">
        <label className="form-label">⚖️ طريقة توزيع السحب</label>
        <select
          className="form-select"
          value={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          <option value="equal">مناصفة (50%-50%)</option>
          <option value="custom">توزيع مخصص</option>
        </select>
      </div>

      {/* توزيع النسب إذا كان التوزيع مخصص */}
      {mode === 'custom' && (
        <div className="row mb-3">
          <div className="col">
            <label className="form-label">نسبة الخط الأول (%)</label>
            <input
              type="number"
              className="form-control"
              value={ratio1}
              onChange={(e) => {
                const val = parseInt(e.target.value);
                if (val >= 0 && val <= 100) {
                  setRatio1(val);
                  setRatio2(100 - val);
                }
              }}
            />
          </div>
          <div className="col">
            <label className="form-label">نسبة الخط الثاني (%)</label>
            <input type="number" className="form-control" value={ratio2} readOnly />
          </div>
        </div>
      )}

      <button className="btn btn-success mt-3" onClick={handleSave}>
        💾 حفظ الإعدادات
      </button>
    </div>
  );
}







function WidGet() {
  const accountNumber = localStorage.getItem("accountNumber");
  const serviceUrl = `https://mcrm.com.tr/screen.php?id=${accountNumber}`;
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(serviceUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div
      className="container mt-4 p-4 border rounded shadow-sm"
      style={{ direction: "rtl", maxWidth: "600px" }}
    >
      <h4 className="text-primary mb-3">💡 شرح الخدمة</h4>

      <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
       هذه الخدمة تتيح عرض تفاصيل الشبكة و السيرفر على شاشة الموبايل مباشرة دونفتح تطبيق او اغلاقه لمراقبة الشبكة يتم تحديث بيانات الشبكة كل 15 ثانية
      </p>

      <hr />

      <h5 className="mb-2">🔗 رابط الخدمة المخصص لك:</h5>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          value={serviceUrl}
          readOnly
        />
        <button className="btn btn-outline-primary" onClick={handleCopy}>
          {copied ? "✅ تم النسخ" : "📋 نسخ"}
        </button>
      </div>

      <hr />

      <h5 className="mb-2">📱 تحميل التطبيق:</h5>
      <a
        href="/widgetify.apk"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-success w-100 mb-3"
      >
        🌐 فتح صفحة التحميل في لسان جديد
      </a>

      <h5 className="mb-2">🎥 فيديو الشرح:</h5>
      <a
        href="https://www.youtube.com/watch?v=6S-aN34Q_Vs"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-danger w-100"
      >
        ▶️ مشاهدة الفيديو في لسان جديد
      </a>
    </div>
  );
}




function WhatsAppMessagesLog() {
  const [messages, setMessages] = useState([]);
  const [showRecipients, setShowRecipients] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [newMessage, setNewMessage] = useState('');
  const [sending, setSending] = useState(false);

  const token = localStorage.getItem('authToken');

  const fetchMessages = async () => {
    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?waMessages&token=${token}`);
      const data = await res.json();
      if (data.success) {
        setMessages(data.messages);
      }
    } catch (error) {
      console.error('فشل تحميل الرسائل:', error);
    }
  };

  const resendMessage = async (id) => {
    try {
      await fetch(`https://mcrm.com.tr/api.php?waResend&id=${id}&token=${token}`);
      fetchMessages();
    } catch (error) {
      console.error('فشل في إعادة الإرسال:', error);
    }
  };

  const handleSendNewMessage = async () => {
    if (!newMessage.trim()) return;
    setSending(true);
    try {
      const body = { text: newMessage };
      const res = await fetch(`https://mcrm.com.tr/api.php?waSendNew&token=${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (data.success) {
        setShowModal(false);
        setNewMessage('');
        fetchMessages();
      } else {
        alert('❌ فشل في الإرسال');
      }
    } catch (err) {
      console.error('خطأ في الإرسال:', err);
    }
    setSending(false);
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <div className="whatsapp-log">
      <div className="log-header">
        <h2>📢 سجل الرسائل الجماعية</h2>
        <button onClick={() => setShowModal(true)}>➕ إرسال جديد</button>
      </div>

      {messages.length === 0 ? (
        <p className="no-msg">لا توجد رسائل بعد</p>
      ) : (
        <div className="log-list">
          {messages.map((msg) => (
            <div className="log-card" key={msg.id}>
              <div className="log-content">
                <p className="log-text">{msg.text}</p>
                <button
                  className="recipients-btn"
                  onClick={() => setShowRecipients(showRecipients === msg.id ? null : msg.id)}
                >
                  👥 {msg.recipients.length} مستلم
                </button>

                {showRecipients === msg.id && (
                  <ul className="recipient-list">
                    {msg.recipients.map((r, i) => (
                      <li key={i}>📱 {r}</li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="log-footer">
                <button className="resend-btn" onClick={() => resendMessage(msg.id)}>
                  🔁 إعادة الإرسال
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="modal-header">
              <h4>✉️ رسالة جديدة</h4>
              <span onClick={() => setShowModal(false)}>❌</span>
            </div>
            <textarea
              placeholder="اكتب رسالتك هنا..."
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              rows={6}
            ></textarea>
            <button onClick={handleSendNewMessage} disabled={sending}>
              {sending ? '...جاري الإرسال' : '🚀 إرسال الرسالة'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}




function CardsCleanupPanel() {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("success");
  const [printedExpiredCount, setPrintedExpiredCount] = useState(0);
  const [manualExpiredCount, setManualExpiredCount] = useState(0);
  const [autoDeletePrinted, setAutoDeletePrinted] = useState(false);
  const [autoDeleteManual, setAutoDeleteManual] = useState(false);

  useEffect(() => {
    fetchStatus();
  }, []);

  const showMessage = (text, type = "success") => {
    setMessage(text);
    setMessageType(type);
    setTimeout(() => setMessage(""), 3200);
  };

  const fetchStatus = async () => {
    setLoading(true);
    setMessage("");
    try {
      const token = localStorage.getItem("authToken");
      const resp = await fetch(`https://mcrm.com.tr/api.php?getddelete=1&token=${token}`);
      const data = await resp.json();
      if (resp.ok && data.success !== false) {
        const d = data.data || {};
        setPrintedExpiredCount(Number(d.printedExpired || 0));
        setManualExpiredCount(Number(d.manualExpired || 0));
        setAutoDeletePrinted(Boolean(Number(d.autoDeletePrinted ?? 0)));
        setAutoDeleteManual(Boolean(Number(d.autoDeleteManual ?? 0)));
      } else {
        showMessage(data.message || "فشل جلب الحالة.", "error");
      }
    } catch (e) {
      showMessage("حدث خطأ أثناء الاتصال بالخادم.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteExpired = async () => {
    if (!window.confirm("هل أنت متأكد من حذف جميع البطاقات المنتهية؟")) return;
    setLoading(true);
    setMessage("");
    try {
      const token = localStorage.getItem("authToken");
      const resp = await fetch(
        `https://mcrm.com.tr/api.php?deleteExpiredCards=1&token=${token}`,
        { method: "POST", headers: { "Content-Type": "application/json" } }
      );
      const data = await resp.json();
      if (resp.ok && data.success !== false) {
        showMessage(data.message || "تم حذف البطاقات المنتهية بنجاح.", "success");
        await fetchStatus();
      } else {
        showMessage(data.message || "فشل حذف البطاقات.", "error");
      }
    } catch (e) {
      showMessage("حدث خطأ أثناء الاتصال بالخادم.", "error");
    } finally {
      setLoading(false);
    }
  };

  const updateAutoDelete = async (type, enabled) => {
    setLoading(true);
    setMessage("");
    try {
      const token = localStorage.getItem("authToken");
      const url =
        type === "printed"
          ? `https://mcrm.com.tr/api.php?setAutoDeletePrinted=1&enabled=${enabled ? 1 : 0}&token=${token}`
          : `https://mcrm.com.tr/api.php?setAutoDeleteManual=1&enabled=${enabled ? 1 : 0}&token=${token}`;
      const resp = await fetch(url, { method: "POST", headers: { "Content-Type": "application/json" } });
      const data = await resp.json();
      if (resp.ok && data.success !== false) {
        if (type === "printed") setAutoDeletePrinted(enabled);
        else setAutoDeleteManual(enabled);
        showMessage(data.message || "تم حفظ الإعدادات بنجاح.", "success");
      } else {
        showMessage(data.message || "فشل حفظ الإعدادات.", "error");
      }
    } catch (e) {
      showMessage("حدث خطأ أثناء الاتصال بالخادم.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mcrm-ccp" dir="rtl">
      <div className="mcrm-ccp__header">
        <div className="mcrm-ccp__title">
          <h2>إدارة حذف البطاقات المنتهية</h2>
          <p>تحكّم بالحذف الفوري والتلقائي مع عرض عدّادات دقيقة.</p>
        </div>
        <div className="mcrm-ccp__actions">
          <button className="mcrm-ccp__btn mcrm-ccp__btn--ghost" onClick={fetchStatus} disabled={loading} title="تحديث">
            <span className="mcrm-ccp__btn-ico">🔄</span>تحديث
          </button>
          <button className="mcrm-ccp__btn mcrm-ccp__btn--danger" onClick={handleDeleteExpired} disabled={loading} title="حذف المنتهية">
            <span className="mcrm-ccp__btn-ico">🗑️</span>حذف المنتهية
          </button>
        </div>
      </div>

      {message && (
        <div className={`mcrm-ccp__alert ${messageType === "success" ? "mcrm-ccp__alert--success" : "mcrm-ccp__alert--error"}`}>
          {message}
        </div>
      )}

      <div className="mcrm-ccp__stats">
        <div className="mcrm-ccp__card">
          <div className="mcrm-ccp__card-head">
            <span className="mcrm-ccp__card-ico">🖨️</span>
            <span className="mcrm-ccp__card-label">البطاقات المطبوعة المنتهية</span>
          </div>
          {loading ? <div className="mcrm-ccp__skel mcrm-ccp__skel--lg" /> : <div className="mcrm-ccp__card-value">{printedExpiredCount}</div>}
        </div>

        <div className="mcrm-ccp__card">
          <div className="mcrm-ccp__card-head">
            <span className="mcrm-ccp__card-ico">✍️</span>
            <span className="mcrm-ccp__card-label">البطاقات اليدوية المنتهية</span>
          </div>
          {loading ? <div className="mcrm-ccp__skel mcrm-ccp__skel--lg" /> : <div className="mcrm-ccp__card-value">{manualExpiredCount}</div>}
        </div>
      </div>

      <div className="mcrm-ccp__panel">
        <div className="mcrm-ccp__row">
          <div className="mcrm-ccp__row-text">
            <h4>تفعيل الحذف التلقائي — المطبوعة</h4>
            <p>عند انتهاء صلاحية البطاقة المطبوعة سيتم حذفها تلقائياً.</p>
          </div>
          <Switch checked={autoDeletePrinted} disabled={loading} onChange={(v) => updateAutoDelete("printed", v)} />
        </div>

        <div className="mcrm-ccp__divider" />

        <div className="mcrm-ccp__row">
          <div className="mcrm-ccp__row-text">
            <h4>تفعيل الحذف التلقائي — اليدوية</h4>
            <p>عند انتهاء صلاحية البطاقة المضافة يدوياً سيتم حذفها تلقائياً.</p>
          </div>
          <Switch checked={autoDeleteManual} disabled={loading} onChange={(v) => updateAutoDelete("manual", v)} />
        </div>
      </div>
    </div>
  );
}





function ErorrserVer() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState([]);

  const token = localStorage.getItem("authToken");

  const handleAnalysis = async () => {
    setLoading(true);
    setProgress(30);
    setResult([]);

    try {
      const res = await fetch(`https://mcrm.com.tr/api.php?erorrserver&token=${token}`);
      setProgress(70);
      const json = await res.json();

      if (json.masge) {
        // تقسيم المشاكل إلى عناصر منفصلة حسب الرقم أو سطر فارغ
        const problems = json.masge
          .split(/\n\s*\n|\d+\.\s/)
          .map(item => item.trim())
          .filter(Boolean);

        setResult(problems);
      } else if (json.error) {
        setResult([json.error]);
      }

      setProgress(100);
    } catch (error) {
      console.error("Error fetching:", error);
      setResult(["فشل التحليل، حاول مرة أخرى"]);
      setProgress(100);
    } finally {
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 1500);
    }
  };

  return (
    <div className="p-3">
      <button className="btn btn-primary mb-3" onClick={handleAnalysis}>
        تحليل مشاكل السيرفر
      </button>

      {loading && (
        <div className="mb-3">
          <ProgressBar animated now={progress} label={`${progress}%`} />
          <p className="mt-2">جاري التحليل...</p>
        </div>
      )}

      {result.length > 0 && !loading && (
        <div className="mt-3">
          <h5>نتيجة التحليل:</h5>
          <ul style={{ lineHeight: "1.8", paddingLeft: "20px" , direction: "rtl" }}>
            {result.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}



function ErorrserVerx() {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [result, setResult] = useState([]);
  const [userInput, setUserInput] = useState(""); // وصف المشكلة من المستخدم

  const token = localStorage.getItem("authToken");

  const handleAnalysis = async () => {
    if (!userInput.trim()) {
      setResult(["الرجاء كتابة وصف المشكلة قبل التحليل"]);
      return;
    }

    setLoading(true);
    setProgress(30);
    setResult([]);

    try {
      const res = await fetch(
        `https://mcrm.com.tr/api.php?erorrserverx&token=${token}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ problem: userInput }), // إرسال وصف المستخدم
        }
      );

      setProgress(70);
      const json = await res.json();

      if (json.masge) {
        const problems = json.masge
          .split(/\n\s*\n|\d+\.\s/)
          .map((item) => item.trim())
          .filter(Boolean);

        setResult(problems);
      } else if (json.error) {
        setResult([json.error]);
      }

      setProgress(100);
    } catch (error) {
      console.error("Error fetching:", error);
      setResult(["فشل التحليل، حاول مرة أخرى"]);
      setProgress(100);
    } finally {
      setTimeout(() => {
        setLoading(false);
        setProgress(0);
      }, 1500);
    }
  };

  return (
    <div className="p-3" style={{ direction: "rtl" }}>
      <h5 className="mb-2">صف مشكلتك:</h5>
      <textarea
        className="form-control mb-3"
        rows="4"
        placeholder="اكتب وصف المشكلة هنا..."
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
      />

      <button className="btn btn-primary mb-3" onClick={handleAnalysis}>
        تحليل
      </button>

      {loading && (
        <div className="mb-3">
          <ProgressBar animated now={progress} label={`${progress}%`} />
          <p className="mt-2">جاري التحليل...</p>
        </div>
      )}

      {result.length > 0 && !loading && (
        <div className="mt-3">
          <h5>نتيجة التحليل:</h5>
          <ul style={{ lineHeight: "1.8", paddingLeft: "20px" }}>
            {result.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}




/* سويتش مخصص */
function Switch({ checked, onChange, disabled }) {
  return (
    <button
      type="button"
      className={`mcrm-ccp__switch ${checked ? "is-on" : ""} ${disabled ? "is-disabled" : ""}`}
      onClick={() => !disabled && onChange(!checked)}
      aria-pressed={checked}
    >
      <span className="mcrm-ccp__switch-dot" />
      <span className="mcrm-ccp__switch-label">{checked ? "مفعّل" : "متوقف"}</span>
    </button>
  );
}





function App() {
  const location = useLocation();

  const showNavbarPatterns = [
    '/home',
    '/notifications',
    '/broadband-accounts',
'/broadband-accounts/:customerId',


'/hotspot-accounts/:customerId',

    '/passc',
    '/hotspot-accounts',
    '/broadband-profile',
    '/hotspot-profile',
    '/tools',


'/WidGet',

    '/print',
'/linkserver',
    '/mcrmapp',
'/editable',
    
'/device',
'/usershare',
'/print-templates',
'/backups',
'/generals',
    '/server',
    '/remot',
    '/remotd/:deviceId/:port',
    '/sales',
    '/designer',
    
'/remotdx/:id',
'/managers',
'/whatsapp',

'/spoe',
'/sendwhatsapp',
'/linedmg',

'/deletfinshcard',

'/accounting',


'/balance',

'/balance/:id',

'/clients',

'/eroeeserver',
'/eroeeserverx',
'/myapp',
    '/account/:id'
  ];

  const showNavbar = showNavbarPatterns.some(pattern => match(pattern)(location.pathname));

  const isLoginPage = location.pathname === '/';

  return (
    <>
      {showNavbar && <Navbar />}

      <div className={!isLoginPage ? 'main-content' : ''}>
        <Routes>
          <Route
            path="/"
            element={
              <div className="new">
                <div className="login-container">
                  <div className="header-section">
                    <div className="profile-icon">
                      <img
                        src="images/logo.png"
                        alt="شعار التطبيق"
                        style={{ width: '60px', height: '60px', borderRadius: '50%' }}
                      />
                    </div>
                    <h2>تسجيل الدخول</h2>
                    <p>أدخل بياناتك للوصول إلى حسابك</p>
                  </div>
                  <LoginForm />
                </div>
              </div>
            }
          />

          <Route path="/home" element={<HomePage />} />
          <Route path="/sguinup" element={<Sguinup />} />
          <Route path="/signup-success" element={<SignupSuccess />} />
          <Route path="/pass" element={<PasswordResetForm />} />
          <Route path="/passc" element={<ChangePasswordForm />} />
          <Route path="/tools" element={<Tool />} />
          <Route path="/hotspot-profile" element={<HotspotProfileManager />} />
          <Route path="/broadband-profile" element={<MikroTikProfileManager />} />
          <Route path="/print" element={<Print />} />
          <Route path="/hotspot-accounts" element={<HotspotAccounts />} />
          <Route path="/broadband-accounts" element={<BroadbandAccounts />} />

<Route path="/broadband-accounts/:customerId" element={<BroadbandAccounts />} />

<Route path="/hotspot-accounts/:customerId" element={<HotspotAccounts />} />
          <Route path="/broadband-add" element={<AddAccountForm />} />
            <Route path="/mcrmapp" element={<InstallPrompt />} />
         <Route path="/linkserver" element={<ConfigScript />} />
          <Route path="/device" element={<DeviceConfigPage />} />
       
           <Route path="/backups" element={<BackupFilesPage />} />
  <Route path="/usershare" element={<SharedSpeeds />} />
 <Route path="/designer" element={<HotspotCardDesigner />} />
 <Route path="/print-templates" element={<TemplateList />} />
<Route path="/server" element={<ServerAnalysis />} />

<Route path="/generals" element={<GeneralSettingsPage />} />

<Route path="/editable" element={<EditableSettingsPage />} />

<Route path="/remot" element={<Toolx />} />
<Route path="/remotd/:deviceId/:port" element={<RemoteConnectTool />} />
<Route path="/remotdx/:id" element={<DeviceDetails />} />

<Route path="/sales" element={<DailySalesPage />} />

<Route path="/Previewer" element={<CardPreviewer />} />

<Route path="/managers" element={<AdminManager />} />

<Route path="/spoe" element={<BroadbandOptions />} />
<Route path="/whatsapp" element={<WhatsAppConnection />} />
<Route path="/sendwhatsapp" element={<WhatsAppMessagesLog />} />
<Route path="/linedmg" element={<LineDmg />} />

<Route path="/deletfinshcard" element={<CardsCleanupPanel />} />

<Route path="/myapp" element={<EditableProviderForm />} />



<Route path="/eroeeserver" element={<ErorrserVer />} />

<Route path="/eroeeserverx" element={<ErorrserVerx />} />
<Route path="/WidGet" element={<WidGet />} />

<Route path="/accounting" element={<Accounting />} />

<Route path="/clients" element={<CustomerDashboard />} />

<Route path="/balance" element={<MovementsPage />} />
<Route path="/balance/:id" element={<MovementsPage />} />




        </Routes>
      </div>

      <div
        style={{
          textAlign: 'center',
          padding: '10px',
          fontSize: '14px',
          color: '#888',
          height: '84px'
        }}
      ></div>

      {showNavbar && <BottomNavbar />}
    </>
  );
}




export default App;

